import { urlTool, jsonTool, encodingTool, uaTool, netTool, commonTool, stepTimerClassDecorator, EvtEmitter, SimpleDefer, videoTool, logMethodCallDecoratorCreator, domTool, ResizeObserver, TaskLoop, LoopMode, VALIDATE_PASS_RESULT, runValidators, performanceCostDecoratorCreator, lsTool, HDR_CAPABILITY, costTimeEmitter, destroyProtectDecorator, StepTimer, KernelStepKey, requireModule, mountGlobal, cookieTool, getEventEmitterBinder, getEventTargetBinder, stringTool, ResizeObserverPolyfilled, hashTool } from '@tencent/thumbplayer-utils';
export { EvtEmitter, HDR_CAPABILITY, KernelStepKey, LoopMode, ResizeObserver, ResizeObserverPolyfilled, SimpleDefer, StepTimer, TaskLoop, commonTool, cookieTool, costTimeEmitter, destroyProtectDecorator, domTool, encodingTool, getEventEmitterBinder, getEventTargetBinder, hashTool, jsonTool, logMethodCallDecoratorCreator as logMethodCallDecoratorCreater, logMethodCallDecoratorCreator, lsTool, mountGlobal, netTool, performanceCostDecoratorCreator, requireModule, stepTimerClassDecorator, stringTool, uaTool, urlTool, videoTool } from '@tencent/thumbplayer-utils';
import { __spreadArray, __assign, __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';

/** Promise Finally的polyfill，主要针对chrome<66的移动端内核 */
if (!Promise.prototype.finally) {
    Promise.prototype.finally = function finallyConstructor(callback) {
        var constructor = this.constructor;
        return this.then(function (value) { return constructor.resolve(callback()).then(function () { return value; }); }, function (reason) { return constructor.resolve(callback()).then(function () { return constructor.reject(reason); }); });
    };
}

/**
 * 切换清晰度的模式
 */
var SetLevelMode;
(function (SetLevelMode) {
    /** 多video标签预加载切换 */
    SetLevelMode["SOFT"] = "soft";
    /** 黑屏重置src切换 */
    SetLevelMode["HARD"] = "hard";
    /** 无缝切换（依赖播放库实现） */
    SetLevelMode["SMOOTH"] = "smooth";
})(SetLevelMode || (SetLevelMode = {}));
/**
 * 播放模式枚举：点播/直播
 */
var PlayMode;
(function (PlayMode) {
    PlayMode["VOD"] = "vod";
    PlayMode["LIVE"] = "live";
})(PlayMode || (PlayMode = {}));
/**
 * 表示内核支持所有的格式。（如果是部分支持，则为['mp4']、['flv']此类数组）
 */
var CAN_PLAY_ALL = null;
/**
 * 内部创建的video标签容器的class名
 */
var VIDEO_CONTAINER_CLASS = 'txp_videos_container';
var VIDEO_CONTAINER_STYLE = 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:0;';
/**
 * 播放结束时的状态枚举，用于区分播放结束的原因
 * @enum {string}
 */
var EndState;
(function (EndState) {
    /** 正常结束（到底视频结束点播放完成） */
    EndState["NORMAL"] = "normal";
    /** 中断播放（未播放完成时被结束） */
    EndState["INTERRUPT"] = "interrupt";
    /** 播放出错 */
    EndState["ERROR"] = "error";
})(EndState || (EndState = {}));
/**
 * video标签的ready state枚举
 */
var VideoReadyState;
(function (VideoReadyState) {
    VideoReadyState[VideoReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    VideoReadyState[VideoReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    VideoReadyState[VideoReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    VideoReadyState[VideoReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    VideoReadyState[VideoReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(VideoReadyState || (VideoReadyState = {}));
/**
 * video标签事件列表
 */
var VideoEvts;
(function (VideoEvts) {
    VideoEvts["loadstart"] = "loadstart";
    VideoEvts["timeupdate"] = "timeupdate";
    VideoEvts["durationchange"] = "durationchange";
    VideoEvts["volumechange"] = "volumechange";
    VideoEvts["canplay"] = "canplay";
    VideoEvts["playing"] = "playing";
    VideoEvts["pause"] = "pause";
    VideoEvts["waiting"] = "waiting";
    VideoEvts["seeking"] = "seeking";
    VideoEvts["seeked"] = "seeked";
    VideoEvts["loadeddata"] = "loadeddata";
    VideoEvts["loadedmetadata"] = "loadedmetadata";
    VideoEvts["ended"] = "ended";
    VideoEvts["error"] = "error";
    VideoEvts["progress"] = "progress";
    VideoEvts["ratechange"] = "ratechange";
    VideoEvts["resize"] = "resize";
    /** wasm FakeVideo 专用 */
    VideoEvts["frameRender"] = "videoFrameRender";
})(VideoEvts || (VideoEvts = {}));
/**
 * 标记播放器状态
 * @enum {string}
 */
var VideoState;
(function (VideoState) {
    VideoState["IDLE"] = "idle";
    VideoState["LOAD_START"] = "loadStart";
    /** 当浏览器能够开始播放指定的音频/视频时，但尚未开始播放 */
    VideoState["CANPLAY"] = "canplay";
    VideoState["PLAYING"] = "playing";
    VideoState["PAUSE"] = "pause";
    VideoState["SEEKING"] = "seeking";
    VideoState["SEEKED"] = "seeked";
    VideoState["BUFFERING"] = "buffering";
    /** 正常播放结束（包括外部中断播放），如果是播放出错则没有此状态 */
    VideoState["END"] = "end";
})(VideoState || (VideoState = {}));
/** @deprecated 后续请使用ErrorBase进行比对 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["UNKNOWN_ERR"] = "70011000";
    /** video标签抛出来的错误1：视频取回被终止 */
    ErrorCode["MEDIA_ERR_ABORTED"] = "70016001";
    /** video标签抛出来的错误2：H5下载视频错误 */
    ErrorCode["MEDIA_ERR_NETWORK"] = "70016002";
    /** video标签抛出来的错误3：H5视频解码错误 */
    ErrorCode["MEDIA_ERR_DECODE"] = "70011102";
    /** video标签抛出来的错误4：H5不支持该音视频 */
    ErrorCode["MEDIA_ERR_SRC_NOT_SUPPORTED"] = "70011103";
    /**
     * 初次播放超时
     * 注意：目前是判断从开始加载视频到canplay/playing的过程耗时，因此这里的原因可能是
     * 1. 加载视频超时（较大概率）
     * 2. 指定了起播时间，但是无法跳转到对应时间导致超时（目标点无buffer数据等）
     * 3. 其他无法触发canplay/playing事件，但又不报错的情况
     */
    ErrorCode["ORG_LOAD_TIMEOUT"] = "70011104";
    /** 状态超过最大停滞时间 */
    ErrorCode["STATE_STUCK"] = "70011105";
    /** 播放时间超过最大停滞时间 */
    ErrorCode["ORG_PLAY_STUCK_ERR"] = "70011111";
    ErrorCode["NULL_URL"] = "70011112";
    ErrorCode["MISSING_KERNEL"] = "70011113";
    ErrorCode["KERNEL_NOT_SPT"] = "70011114";
})(ErrorCode || (ErrorCode = {}));
/** @deprecated 已迁移至 i18nConfig 中，访问 i18nConfig.core.ERROR_XXX */
var ErrorMsg;
(function (ErrorMsg) {
    ErrorMsg["UNKNOWN"] = "\u672A\u77E5\u9519\u8BEF";
    ErrorMsg["XHR_NET"] = "\u89C6\u9891\u83B7\u53D6\u9014\u4E2D\u51FA\u73B0\u95EE\u9898";
    // PRESET_MODULE_LOAD = 'preset module failed to load',
    ErrorMsg["PRELOAD_VIDEO_TIMEOUT"] = "\u89C6\u9891\u64AD\u653E\u8D85\u65F6";
    ErrorMsg["PLAY_STUCK"] = "\u89C6\u9891\u65E0\u6CD5\u7EE7\u7EED\u64AD\u653E";
    ErrorMsg["LOAD_STREAM_FAIL"] = "\u89C6\u9891\u6D41\u83B7\u53D6\u9014\u4E2D\u51FA\u73B0\u95EE\u9898";
    ErrorMsg["INNER"] = "\u5185\u90E8\u9519\u8BEF";
    ErrorMsg["NULL_URL"] = "\u4F20\u5165\u7684\u5730\u5740\u4E3A\u7A7A";
})(ErrorMsg || (ErrorMsg = {}));
/**
 * 播放事件定义
 */
var PlayEvent;
(function (PlayEvent) {
    /** 重新播放 */
    PlayEvent["RESTART"] = "restart";
    PlayEvent["TIME_UPDATE"] = "timeupdate";
    PlayEvent["METADATA_CHANGE"] = "metadataChange";
    PlayEvent["RATE_CHANGE"] = "rateChange";
    PlayEvent["VOLUME_CHANGE"] = "volumeChange";
    PlayEvent["DURATION_CHANGE"] = "durationChange";
    /** 自动播放被阻止 */
    PlayEvent["AUTOPLAY_BLOCKED"] = "autoplayBlocked";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */
    PlayEvent["LOAD_PROGRESS"] = "loadProgress";
    PlayEvent["STATE_CHANGE"] = "stateChange";
    /** 是否是否首次开播(即使当前播放列表有多个视频，也只有一次此事件，而且一定是看到画面) */
    PlayEvent["FIRST_PLAYING"] = "firstPlaying";
    /** 每一段播放结束 */
    PlayEvent["VIDEONODE_PLAY_OVER"] = "videoNodePlayOver";
    /** 每一段视频开始播放时候（可能并未看到画面，只是切到此视频开始加载） */
    PlayEvent["VIDEONODE_START_PLAY"] = "videoNodeStartPlay";
    /** 每一段视频是否首次开播(一定是看到画面) */
    PlayEvent["VIDEONODE_FIRST_PLAYING"] = "videoNodeFirstPlaying";
    /** 每一段视频准备播放（player列表的当前索引变化）* */
    PlayEvent["VIDEONODE_CHANGE"] = "videoNodeChange";
    /** 播放列表发生变化（每次列表变化，都只是变化当前播放地址后面的列表） */
    PlayEvent["LIST_CHANGE"] = "listChange";
    /** 通知外部是否显示loading动画 */
    PlayEvent["SET_LOADING"] = "setLoading";
    /** 列表预加载开始事件，多视频预加载只会通知一次 */
    PlayEvent["PRELOAD_START"] = "preloadStart";
    /** 单个视频预加载结束事件，多视频预加载每个视频都会通知 */
    PlayEvent["PRELOAD_VIDEONODE_OVER"] = "preloadVideonodeOver";
    /** 单个视频预加载清除事件，多视频预加载每个视频都会通知 */
    PlayEvent["PRELOAD_VIDEONODE_CLEAR"] = "preloadVideonodeClear";
    /** 单个视频预加载错误事件，多视频预加载每个视频都会通知 */
    PlayEvent["PRELOAD_VIDEONODE_ERROR"] = "preloadVideonodeError";
    /** video标签的buffered属性变化时 */
    PlayEvent["VIDEO_BUFFER_CHANGE"] = "videoBufferChange";
    /** 切换清晰度开始 */
    PlayEvent["SETLEVEL_START"] = "setLevelStart";
    /** 切换清晰度成功or失败 */
    PlayEvent["SETLEVEL_OVER"] = "setLevelOver";
    /** 切换音轨开始 */
    PlayEvent["SET_AUDIO_TRACK_START"] = "setAudioTrackStart";
    /** 切换音轨成功or失败 */
    PlayEvent["SET_AUDIO_TRACK_OVER"] = "setAudioTrackOver";
    PlayEvent["RESIZE"] = "resize";
    PlayEvent["STOPED"] = "stoped";
    PlayEvent["ERROR"] = "error";
    PlayEvent["RETRY_BACKURL"] = "retryBackUrl";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */
    PlayEvent["VIDEO_FRAME_RENDER"] = "videoFrameRender";
    /** 透传video的事件 */
    PlayEvent["ELEMENT_EVTS"] = "elementEvts";
    /** 视频分辨率发生变化 */
    PlayEvent["VIDEO_RESIZE"] = "videoResize";
    /** 全屏变化 */
    PlayEvent["FULLSCREEN_CHANGE"] = "fullscreenChange";
    /** 播放器容器尺寸变化 */
    PlayEvent["CONTAINER_RESIZE"] = "containerResize";
    /** 进入插入流播放 */
    PlayEvent["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */
    PlayEvent["EXIT_INSERT_STREAM"] = "exitInsertStream";
    /** 销毁内核 */
    PlayEvent["KERNEL_DESTROY"] = "kernelDestroy";
})(PlayEvent || (PlayEvent = {}));
/**
 * @ignore
 */
var PreloadEvent;
(function (PreloadEvent) {
    /** 开始预加载 */
    PreloadEvent["START"] = "START_PRELOAD";
    /**  停止预加载 */
    PreloadEvent["STOP"] = "STOP_PRELOAD";
    /** 更新预加载信息 */
    PreloadEvent["UPDATE"] = "UPDATE_PRELOAD_INFO";
})(PreloadEvent || (PreloadEvent = {}));
var VideoNodeEvent;
(function (VideoNodeEvent) {
    VideoNodeEvent["TIME_UPDATE"] = "vn_timeupdate";
    VideoNodeEvent["METADATA_CHANGE"] = "vn_metadataChange";
    VideoNodeEvent["VOLUME_CHANGE"] = "vn_volumeChange";
    VideoNodeEvent["DURATION_CHANGE"] = "vn_durationChange";
    VideoNodeEvent["PLAY_PROMISE_CATCHED"] = "vn_playPromiseCatched";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */
    VideoNodeEvent["LOAD_PROGRESS"] = "vn_loadProgress";
    VideoNodeEvent["RATE_CHANGE"] = "vn_rateChange";
    /**
     * 当有数据append到sourcebuffer中时（只有mse模式下有自定义加载，才会发出此事件）
     * @ignore
     */
    VideoNodeEvent["BUFFER_APPENDED"] = "vn_bufferAppended";
    VideoNodeEvent["STATE_CHANGE"] = "vn_stateChange";
    VideoNodeEvent["ERROR"] = "vn_error";
    /** videonode触发url重试 */
    VideoNodeEvent["RETRY"] = "vn_retry";
    VideoNodeEvent["SET_LOADING"] = "vn_setLoading";
    /** video标签的buffered属性变化时 */
    VideoNodeEvent["VIDEO_BUFFER_CHANGE"] = "vn_videoBufferChange";
    /** 切换清晰度开始 */
    VideoNodeEvent["SETLEVEL_START"] = "vn_setLevelStart";
    /** 切换清晰度成功or失败 */
    VideoNodeEvent["SETLEVEL_OVER"] = "vn_setLevelOver";
    /** 切换音轨开始 */
    VideoNodeEvent["SET_AUDIO_TRACK_START"] = "vn_setAudioTrackStart";
    /** 切换音轨成功or失败 */
    VideoNodeEvent["SET_AUDIO_TRACK_OVER"] = "vn_setAudioTrackOver";
    /** VideoNode中的地址变化 */
    VideoNodeEvent["URL_CHANGE"] = "vn_urlChange";
    /** 是否是否首次开播 */
    VideoNodeEvent["FIRST_PLAYING"] = "vn_firstPlaying";
    /** 透传video的事件 */
    VideoNodeEvent["ELEMENT_EVTS"] = "vn_elementEvts";
    /** videonode正常结束 */
    VideoNodeEvent["PLAY_OVER"] = "vn_playOver";
    /** 视频分辨率发生变化 */
    VideoNodeEvent["VIDEO_RESIZE"] = "vn_videoResize";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */
    VideoNodeEvent["VIDEO_FRAME_RENDER"] = "vn_videoFrameRender";
    /** 进入插入流播放 */
    VideoNodeEvent["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */
    VideoNodeEvent["EXIT_INSERT_STREAM"] = "exitInsertStream";
})(VideoNodeEvent || (VideoNodeEvent = {}));
/**
 * @ignore
 */
var PauseType;
(function (PauseType) {
    PauseType["USER"] = "user";
    PauseType["INNER"] = "inner";
    PauseType["SYS"] = "sys";
})(PauseType || (PauseType = {}));
/** 开启播放器的日志等级 */
var PlayerLogLevel;
(function (PlayerLogLevel) {
    /** 不打开日志 */
    PlayerLogLevel[PlayerLogLevel["NONE"] = 0] = "NONE";
    /** 开启core的日志 */
    PlayerLogLevel[PlayerLogLevel["CORE"] = 1] = "CORE";
    /** 开启内核日志 */
    PlayerLogLevel[PlayerLogLevel["KERNEL"] = 2] = "KERNEL";
})(PlayerLogLevel || (PlayerLogLevel = {}));
/**
 * 预加载策略类型
 */
var PreloadType;
(function (PreloadType) {
    /** 仅加载视频头部数据，最小流量消耗 */
    PreloadType["META_DATA"] = "metadata";
    /** 由浏览器自行决定加载数据大小，仅赋值src属性 */
    PreloadType["AUTO"] = "auto";
    /** 由浏览器自行决定加载数据大小，同时调用HTMLVideoElement的load()接口，可能会加载整个视频，属于最大流量消耗 */
    PreloadType["AUTO_LOAD"] = "autoLoad";
})(PreloadType || (PreloadType = {}));
/** @deprecated codec枚举 */
var Codec;
(function (Codec) {
    Codec[Codec["H264"] = 0] = "H264";
    Codec[Codec["H265"] = 1] = "H265";
    Codec[Codec["AV1"] = 2] = "AV1";
})(Codec || (Codec = {}));
/** 视频codec枚举 */
var VideoCodec;
(function (VideoCodec) {
    /** 未知编码 */
    VideoCodec["UNKNOWN"] = "unknown";
    VideoCodec["H264"] = "h264";
    VideoCodec["H265"] = "h265";
    VideoCodec["H266"] = "h266";
    VideoCodec["VP8"] = "vp8";
    VideoCodec["VP9"] = "vp9";
    VideoCodec["AV1"] = "av1";
    VideoCodec["DOLBY_VISION"] = "dolbyVision";
})(VideoCodec || (VideoCodec = {}));
/** 音频codec枚举 */
var AudioCodec;
(function (AudioCodec) {
    AudioCodec["AAC"] = "aac";
    AudioCodec["OPUS"] = "opus";
})(AudioCodec || (AudioCodec = {}));
/** 封装容器枚举 */
var ContainerFormat;
(function (ContainerFormat) {
    ContainerFormat["MPEG_TS"] = "mpegts";
    ContainerFormat["FMP4"] = "fmp4";
    ContainerFormat["MP4"] = "mp4";
})(ContainerFormat || (ContainerFormat = {}));
/**
 * video标签的状态：被占用/被释放
 */
var VideoElementState;
(function (VideoElementState) {
    VideoElementState["FREE"] = "0";
    VideoElementState["USED"] = "1";
})(VideoElementState || (VideoElementState = {}));
var CDN_PATH_PREFIX = 'https://vm.gtimg.cn/thumbplayer/';
var CacheSizeKey;
(function (CacheSizeKey) {
    CacheSizeKey["DEMUX"] = "demux_cache_size";
})(CacheSizeKey || (CacheSizeKey = {}));
var DrmType;
(function (DrmType) {
    DrmType["FAIRPLAY"] = "fairplay";
    DrmType["WIDEVINE"] = "widevine";
    DrmType["PLAYREADY"] = "playready";
    DrmType["CHACHA"] = "chacha";
    DrmType["NONE"] = "none";
})(DrmType || (DrmType = {}));
/** 可播放格式能力枚举 */
var VideoType;
(function (VideoType) {
    VideoType["HLS"] = "hls";
    VideoType["MP4"] = "mp4";
    VideoType["MOV"] = "mov";
    VideoType["FLV"] = "flv";
    VideoType["WEBRTC"] = "webrtc";
    VideoType["AVI"] = "avi";
    VideoType["MPEG"] = "mpeg";
    VideoType["WEBM"] = "webm";
    VideoType["OGG"] = "ogg";
    VideoType["OTHER"] = "other";
})(VideoType || (VideoType = {}));
var KernelName;
(function (KernelName) {
    KernelName["ORIGIN"] = "origin";
    KernelName["DEMUX_2_FMP4"] = "demux2fmp4";
    KernelName["FLV_JS"] = "flv.js";
    KernelName["HLS_JS"] = "hls.js";
    KernelName["WASM"] = "wasm";
    KernelName["WEBRTC"] = "webrtc";
    KernelName["ELECTRON"] = "electron";
})(KernelName || (KernelName = {}));
var CoreStepKey;
(function (CoreStepKey) {
    /** 选择，创建内核 */
    CoreStepKey["SEL_KERNEL"] = "selKernel";
    /** drm license请求前设置 */
    CoreStepKey["LIC_REQ_SET"] = "licReqSet";
    /** drm license请求 */
    CoreStepKey["LIC_REQ"] = "licReq";
    /** drm license请求后设置 */
    CoreStepKey["LIC_RES_SET"] = "licResSet";
})(CoreStepKey || (CoreStepKey = {}));

/** 音轨相关的错误文案 */
var AudioTrackErrorMsg;
(function (AudioTrackErrorMsg) {
    AudioTrackErrorMsg["KERNEL_NOT_EXISTS"] = "kernel not exists";
    AudioTrackErrorMsg["NOT_SUPPORT"] = "not support";
    AudioTrackErrorMsg["STATE_INVALID"] = "state invalid";
})(AudioTrackErrorMsg || (AudioTrackErrorMsg = {}));

/**
 * 默认的 i18n 文案配置
 */
var defaultI18nConfig = {
    common: {},
    core: {
        // Internal Error
        ERROR_MSG_UNKNOWN: '未知错误',
        ERROR_XHR_NET: '视频获取途中出现问题',
        ERROR_PRELOAD_VIDEO_TIMEOUT: '加载视频超时',
        ERROR_INNER: '视频无法继续播放',
        ERROR_LOAD_STREAM_FAIL: '视频流获取途中出现问题',
        ERROR_PLAY_STUCK: '播放缓冲出错',
        ERROR_NULL_URL: '传入的地址为空',
        // <video/> Error
        ERROR_MEDIA_ERR_ABORTED: '视频获取被终止',
        ERROR_MEDIA_ERR_NETWORK: '下载视频发生错误',
        ERROR_MEDIA_ERR_DECODE: '尝试解码出错',
        ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED: '浏览器不支持该音视频',
        // KernelProxy Error
        ERROR_KERNEL_NOT_FOUND: '切换清晰度时找不到对应内核',
        // check-player-status.ts
        ERROR_STATUS_NOT_INITIALIZED: '播放器尚未初始化',
        ERROR_STATUS_NOT_PLAYING: '播放未开始',
        ERROR_STATUS_EMPTY_URL: '切换目标视频地址为空',
        ERROR_STATUS_VIDEO_INFO: '找不到当前播放信息',
        ERROR_STATUS_PLAYTIME_CHECK: '播放未开始',
        ERROR_STATUS_CLOSE_TO_END: '播放即将结束',
        ERROR_STATUS_TARGET_UNCHANGED: '切换的视频地址没有变化',
        // DRM
        ERROR_DRM_UNKNOWN: '未知错误',
        ERROR_DRM_LICENSE_NOT_EXIST: '视频资源已加密，但未配置解密证书地址',
        ERROR_DRM_KEY_SYS_NOT_REQUESTED: '视频资源已加密，但尚未请求CDM',
        ERROR_DRM_KEY_NOT_EXIST: '视频资源已加密，但尚未获取到MediaKey',
        ERROR_DRM_KEY_SESSION_NOT_EXIST: '视频资源已加密，但CDM',
        ERROR_DRM_INIT_DATA_EMPTY: '视频资源已加密，但事件信息中没有用于创建请求的 initData',
        ERROR_DRM_KEY_SESSION_REQUEST_FAILED: '视频资源已加密，但 CDM Session 请求失败',
        ERROR_DRM_KEY_SYS_NOT_SUPPORTED: '$0 不支持',
        ERROR_DRM_KEY_SYS_ACCESS_FAILED: '访问CDM失败, keySystem $0',
        ERROR_DRM_KEY_SESSION_CREATION_FAILED: 'CDM Session 初始化失败',
        ERROR_DRM_HDCP: '你可能链接了不支持HDCP标准的显示器',
        ERROR_DRM_KEY_INTERNAL: '内部错误',
        ERROR_DRM_KEY_EXPIRED: 'MediaKey 已过期',
        ERROR_DRM_KEY_RELEASED: 'MediaKey 已从CDM中注销',
        ERROR_DRM_MEDIA_KEYS_SET_FAILED: 'failed to set media keys',
        ERROR_DRM_KEY_SESSION_UPDATE_FAILED: 'CDM Session 更新失败，请检查证书解析',
        ERROR_DRM_LICENSE_REQUEST_FAILED: '证书请求失败 $0',
        ERROR_DRM_FPS_SET_KEY_FAILED: 'Webkit MediaKey创建失败',
        ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST: '视频资源已加密，但 Fairplay 服务端证书未配置',
        // Audio Effect
        INFO_AUDIO_EFFECT_DEFAULT: '默认音效',
        INFO_AUDIO_EFFECT_SPATIAL_STEREO: '立体环绕',
        INFO_AUDIO_EFFECT_BASE_BOOSTER: '重低音',
        INFO_AUDIO_EFFECT_VOCAL_BOOSTER: '清澈人声',
        INFO_AUDIO_EFFECT_VOCAL_WEAK: '弱化人声',
        INFO_AUDIO_EFFECT_POP: '流行',
        INFO_AUDIO_EFFECT_CLASSICAL: '古典',
        INFO_AUDIO_EFFECT_ELECTRONIC: '电子音乐',
        INFO_AUDIO_EFFECT_GUITAR: '吉他',
        INFO_AUDIO_EFFECT_HIPHOP: '嘻哈',
        INFO_AUDIO_EFFECT_JAZZ: '爵士',
        INFO_AUDIO_EFFECT_RNB: 'R&B',
        INFO_AUDIO_EFFECT_ROCK_N_ROLL: '摇滚',
        INFO_AUDIO_EFFECT_CONCERT_HALL: '音乐厅',
        INFO_AUDIO_EFFECT_LIVE: '演唱会现场',
        INFO_AUDIO_EFFECT_LIVING_ROOM: '客厅',
        INFO_AUDIO_EFFECT_RECEIVER: '听筒效果',
        INFO_AUDIO_EFFECT_TREMOLO: '震音',
        INFO_AUDIO_EFFECT_CHORUS: '和声',
    },
};
/**
 * i18n 文案配置，可通过文案字符串 / 文案生成函数来定制文案内容
 */
var i18nConfig = defaultI18nConfig;

/**
 * 编译 i18n 文案，传入对应参数，这里支持两种参数传入方式
 * 1. 以参数列表的方式进行排序，在字符串中以参数索引方式进行引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $0 秒，前往 $1 观看完整版"
 * compile(i18nConfig.zhCN.preview, '10', '腾讯视频');
 * // => "试看 10 秒，前往腾讯视频观看完整版"
 * ```
 * 2. 以 Record<string, unknown> 的方式进行传入，编译字符串使用设置的对应 keyName 引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $time 秒，前往 $qq_web 观看完整版"
 * compile(i18nConfig.zhCN.preview, { time: 10, qq_web: '腾讯视频' });
 * ```
 * 此外，还支持将 i18n 文案字符串定义为回调函数，参数列表为回调函数中的调用参数
 * // i18nConfig.zhCN.preview = (time, dest) => `试看 ${time} 秒,前往 ${dest} 观看完整版`
 */
function compile(message) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof message === 'function') {
        return message.apply(void 0, args);
    }
    var result = message;
    for (var i = 0; i < args.length; i++) {
        result = result.replace("$".concat(i), String(args[i]));
    }
    return result;
}
var i18nTool = { compile: compile };

var _a$5;
/**
 * 对比两个UrlConfig是否是同一个视频节点
 */
function compareUrlConfig(a, b) {
    if (!a || !b) {
        return false;
    }
    // 如果有uid，先对比uid
    if (a.uid && b.uid && a.uid === b.uid) {
        return true;
    }
    // 然后直接对比UrlConfig对象的引用
    if (a === b) {
        return true;
    }
    return false;
}
/**
 * 通过后缀名判断VideoType，用于判断内核
 * @param extension 文件后缀名
 * @returns 返回对应VIDEO_TYPE
 */
function fileExtension2VideoType(extension) {
    var lcExtension = extension === null || extension === void 0 ? void 0 : extension.toLocaleLowerCase();
    // 通过后缀名判断VideoType，用于判断内核
    switch (lcExtension) {
        case 'm3u8':
        case 'm3u':
            return VideoType.HLS;
        case 'mp4':
        case 'mov':
            return VideoType.MP4;
        case 'flv':
        case 'f4v':
            return VideoType.FLV;
        case 'avi':
            return VideoType.AVI;
        case 'mpeg':
            return VideoType.MPEG;
        case 'webm':
            return VideoType.WEBM;
        case 'ogg':
            return VideoType.OGG;
    }
    return VideoType.OTHER;
}
/**
 * 检查UrlConfig作为参数时是否是合法的。例如UrlConfig的url参数为空，则会返回错误。
 * @param value 地址信息（或列表）
 * @param kernelName 播放内核名称
 * @returns 如果不能播放返回错误信息，如果可以播放返回undefined
 */
function checkUrlConfigVailed(value) {
    if (!value) {
        return { code: ErrorCode.NULL_URL, message: compile(i18nConfig.core.ERROR_NULL_URL), fatal: true };
    }
    // 先拿到所有可以支持的视频类型列表
    var vailed = function (conf) {
        // 先判断是否有空url
        var nullUrl = !conf.url;
        if (nullUrl) {
            return { code: ErrorCode.NULL_URL, message: compile(i18nConfig.core.ERROR_NULL_URL), fatal: true };
        }
        return;
    };
    if (value instanceof Array) {
        // UrlConfig数组中只要有一个通不过验证，则返回那个错误信息。否则返回void 0
        for (var i = 0, len = value.length; i < len; i++) {
            var error = vailed(value[i]);
            if (error) {
                return error;
            }
        }
        return;
    }
    return vailed(value);
}
/**
 * 根据UrlConfig的地址拿到后缀，然后判断视频类型
 * @returns 返回视频类型的字符串，例如mp4，或者hls等
 */
function getUrlConfigVideoType(urlConfig) {
    var url = (urlConfig || {}).url;
    if (!url || url.startsWith('blob:')) {
        return VideoType.OTHER;
    }
    if (url.startsWith('webrtc:')) {
        return VideoType.WEBRTC;
    }
    var extension = urlTool.getFileExtension(url);
    var videoType = fileExtension2VideoType(extension);
    return videoType;
}
/**
 * 从config传入的video标签数组查找未使用的video标签（是否在文档流中）
 * @param videoElements video元素对象
 * @returns 空闲的IVideoElement
 */
function findFreeBaseVideoElement(videoElements) {
    if (!videoElements || videoElements.length === 0) {
        throw new Error('videoElements is null or length equal 0');
    }
    var freeVideoElement = null;
    for (var i = 0; i < videoElements.length; i++) {
        var el = videoElements[i];
        if (typeof el.dataset.used === 'undefined' || el.dataset.used === VideoElementState.FREE) {
            freeVideoElement = videoElements[i];
            break;
        }
    }
    if (!freeVideoElement) {
        throw new Error('Unable to find free video element!');
    }
    freeVideoElement.dataset.used = VideoElementState.USED;
    return freeVideoElement;
}
/** videonode的事件到播放器事件的映射 */
var videoEvt2PlayerEvtMap = (_a$5 = {},
    _a$5[VideoNodeEvent.DURATION_CHANGE] = PlayEvent.DURATION_CHANGE,
    _a$5[VideoNodeEvent.VOLUME_CHANGE] = PlayEvent.VOLUME_CHANGE,
    _a$5[VideoNodeEvent.ERROR] = PlayEvent.ERROR,
    _a$5[VideoNodeEvent.METADATA_CHANGE] = PlayEvent.METADATA_CHANGE,
    _a$5[VideoNodeEvent.SETLEVEL_OVER] = PlayEvent.SETLEVEL_OVER,
    _a$5[VideoNodeEvent.SETLEVEL_START] = PlayEvent.SETLEVEL_START,
    _a$5[VideoNodeEvent.SET_LOADING] = PlayEvent.SET_LOADING,
    _a$5[VideoNodeEvent.STATE_CHANGE] = PlayEvent.STATE_CHANGE,
    _a$5[VideoNodeEvent.TIME_UPDATE] = PlayEvent.TIME_UPDATE,
    _a$5[VideoNodeEvent.VIDEO_BUFFER_CHANGE] = PlayEvent.VIDEO_BUFFER_CHANGE,
    _a$5[VideoNodeEvent.LOAD_PROGRESS] = PlayEvent.LOAD_PROGRESS,
    _a$5[VideoNodeEvent.FIRST_PLAYING] = PlayEvent.VIDEONODE_FIRST_PLAYING,
    _a$5[VideoNodeEvent.RATE_CHANGE] = PlayEvent.RATE_CHANGE,
    _a$5[VideoNodeEvent.RETRY] = PlayEvent.RETRY_BACKURL,
    _a$5[VideoNodeEvent.ELEMENT_EVTS] = PlayEvent.ELEMENT_EVTS,
    _a$5[VideoNodeEvent.PLAY_OVER] = PlayEvent.STOPED,
    _a$5[VideoNodeEvent.VIDEO_RESIZE] = PlayEvent.VIDEO_RESIZE,
    _a$5[VideoNodeEvent.VIDEO_FRAME_RENDER] = PlayEvent.VIDEO_FRAME_RENDER,
    _a$5[VideoNodeEvent.SET_AUDIO_TRACK_OVER] = PlayEvent.SET_AUDIO_TRACK_OVER,
    _a$5[VideoNodeEvent.SET_AUDIO_TRACK_START] = PlayEvent.SET_AUDIO_TRACK_START,
    _a$5[VideoNodeEvent.ENTER_INSERT_STREAM] = PlayEvent.ENTER_INSERT_STREAM,
    _a$5[VideoNodeEvent.EXIT_INSERT_STREAM] = PlayEvent.EXIT_INSERT_STREAM,
    _a$5);
// VideoNode 抛出这些事件，因为过于频繁，所以不打印
var IGNORE_EVT_TYPE = [
    VideoNodeEvent.TIME_UPDATE,
    VideoNodeEvent.LOAD_PROGRESS,
    VideoNodeEvent.VIDEO_BUFFER_CHANGE,
    VideoNodeEvent.VIDEO_FRAME_RENDER,
];
// IVideoElement 抛出这些事件，因为过于频繁，所以不打印
var IGNORE_VIDEO_EVT = [
    VideoEvts.timeupdate,
    VideoEvts.progress,
    VideoEvts.frameRender,
];

/** 缓存已经打印的日志字符串 */
var logCache = {};
/** 获取某个播放器实例的日志缓存 */
function getLogCache(instanceId) {
    return logCache[instanceId];
}
/** 清除某个播放器实例的日志缓存 */
function clearLogCache(instanceId) {
    logCache[instanceId] = [];
}
function mallocLogCache(instanceId) {
    if (!logCache[instanceId]) {
        logCache[instanceId] = [];
    }
}
function appendLogCache(instanceId, payload) {
    var _a;
    (_a = logCache[instanceId]) === null || _a === void 0 ? void 0 : _a.push(payload);
}

var LOG_CACHE_LIMIT = 4000;
var noop = function () { };
var dummyConsole = {
    trace: noop,
    debug: noop,
    info: noop,
    log: noop,
    warn: noop,
    error: noop,
};
/**
 * 日志存储的模式, bitmap标识，可以多种模式组合
 */
var LogMode;
(function (LogMode) {
    /** 在控制台中输出 */
    LogMode[LogMode["console"] = 1] = "console";
    /** 存入缓存中 */
    LogMode[LogMode["cache"] = 2] = "cache";
})(LogMode || (LogMode = {}));

var patchedConsole = Object.assign({}, dummyConsole);
/** 启用全局console的开关函数 */
function enable(levels) {
    (levels || Object.keys(dummyConsole)).forEach(function (key) {
        var _a;
        patchedConsole[key] = ((_a = self.console) === null || _a === void 0 ? void 0 : _a[key]) || noop;
    });
}
/**
 * 在console中输出日志
 */
function consoleOutput(level, logPrefix) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    patchedConsole[level].apply(patchedConsole, __spreadArray([logPrefix], args, false));
}

/**
 * 是否可以直接输出的日志类型，例如string类型可以直接输出（而不需要stringify）
 */
function checkDirectLogType(logValue) {
    return ['string', 'number', 'bigint', 'boolean', 'symbol', 'undefined'].indexOf(typeof logValue) !== -1;
}
/**
 * 将logger.log(a, b, c)中的参数列表进行参数序列化。
 * （没有直接用json.stringify是避免打印出现较多无效字符，例如被[]和""包裹的情况）
 */
function stringifyLogArgs(args, ignoreKeyList) {
    if (ignoreKeyList === void 0) { ignoreKeyList = []; }
    var argStrArr = [];
    if (args) {
        argStrArr = args.map(function (arg) {
            if (checkDirectLogType(arg)) {
                // 直接输出
                return arg;
            }
            return stringifyLog(arg, ignoreKeyList);
        });
    }
    return argStrArr.join(' ');
}
/**
 * 序列化日志数据为字符串
 */
function stringifyLog(data, ignoreKeyList) {
    if (ignoreKeyList === void 0) { ignoreKeyList = []; }
    return jsonTool.safelyStringify(data, function (key, logValue) {
        if (ignoreKeyList.indexOf(key) !== -1) {
            // 如果打印的key在黑名单，不打印
            return '';
        }
        if (!logValue || logValue instanceof Array || checkDirectLogType(logValue)) {
            return logValue;
        }
        if (typeof logValue === 'function') {
            // 函数不要转换成真实函数字符串
            return '[function]';
        }
        if (logValue.constructor !== Object) {
            // 仅{}和new Object()可以被JSON.stringify展开
            return "".concat(logValue);
        }
        return logValue;
    });
}
/**
 * 下载日志txt文本
 */
function dumpLog(data) {
    var element = document.createElement('a');
    var output = data.join('\n\n');
    element.setAttribute('href', "data:text/plain;charset=utf-8,".concat(encodeURIComponent(output)));
    element.setAttribute('download', "tp-log-".concat(Date.now(), ".txt"));
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function getLogTime() {
    var time = new Date();
    var timeStr = "".concat(time.getHours(), ":").concat(time.getMinutes(), ":").concat(time.getSeconds())
        + ".".concat(("0000".concat(time.getMilliseconds())).slice(-3));
    return timeStr;
}

/**
 * 绑定播放器实例的日志工具，将日志字符串cache起来使用
 */
var Logger = /** @class */ (function () {
    function Logger(playerId, scopeName, logModeConfig) {
        this.playerId = playerId;
        this.scopeName = scopeName;
        if (!this.playerId) {
            throw new Error('Missing logger id');
        }
        mallocLogCache(playerId);
        // 默认仅使用log, warn, error的日志
        this.logModeConfig = __assign({ trace: LogMode.console, debug: LogMode.console, info: LogMode.console, log: LogMode.cache | LogMode.console, warn: LogMode.cache | LogMode.console, error: LogMode.cache | LogMode.console }, logModeConfig);
    }
    Logger.timeStart = function (instanceId) {
        Logger.totalTimeCostMap[instanceId] = { cost: 0, cnt: 0 };
    };
    Logger.timeEnd = function (instanceId) {
        return Logger.totalTimeCostMap[instanceId] || { cost: 0, cnt: 0 };
    };
    // 日志写入接口
    Logger.prototype.trace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['trace'], args, false));
    };
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['debug'], args, false));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['info'], args, false));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['log'], args, false));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['warn'], args, false));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['error'], args, false));
    };
    /**
     * 仅cache日志用于上传，不在devtools打印
     */
    Logger.prototype.cache = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var level = 'log';
        var logPrefix = this.getLogPrefix();
        this.callApiForCache.apply(this, __spreadArray([level, logPrefix], args, false));
    };
    Logger.prototype.getLogPrefix = function () {
        var _a = this, playerId = _a.playerId, scopeName = _a.scopeName;
        var logPrefix = "[".concat(playerId.slice(-8), "][").concat(getLogTime(), "]").concat(scopeName ? "[".concat(scopeName, "]") : '');
        return logPrefix;
    };
    Logger.prototype.callApi = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var startTime = performance.now();
        var logPrefix = this.getLogPrefix();
        if (this.logModeConfig[level] & LogMode.console) {
            consoleOutput.apply(void 0, __spreadArray([level, logPrefix], args, false));
        }
        this.callApiForCache.apply(this, __spreadArray([level, logPrefix], args, false));
        if (typeof Logger.totalTimeCostMap[this.playerId] !== 'undefined') {
            var rcd = Logger.totalTimeCostMap[this.playerId];
            rcd.cost += Math.round(performance.now() - startTime);
            rcd.cnt += 1;
        }
    };
    Logger.prototype.callApiForCache = function (level, logPrefix) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (this.logModeConfig[level] & LogMode.cache) {
            var payload = "[".concat(level, "]").concat(logPrefix, " ").concat(stringifyLogArgs(args, this.getStringifyLogIgnoreKeys()));
            if (payload.length >= LOG_CACHE_LIMIT) {
                payload = "".concat(payload.slice(0, LOG_CACHE_LIMIT), "...(").concat(payload.length, ")");
            }
            this.cacheLog(payload);
        }
    };
    /**
     * 日志转字符串时候需要忽略的key列表
     */
    Logger.prototype.getStringifyLogIgnoreKeys = function () {
        return ['m3u8'];
    };
    // 慎改，外部有劫持
    Logger.prototype.cacheLog = function (payload) {
        appendLogCache(this.playerId, payload);
    };
    Object.defineProperty(Logger.prototype, "ignoreKeyList", {
        // 慎改，外部有劫持
        /**
         * 输出日志时忽略某些key值，例如加密相关敏感字端
         */
        get: function () {
            // chachaParam等关键词为了避免敏感词检索，由外部劫持后定义
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Logger.totalTimeCostMap = {};
    /** @deprecated */
    Logger.level = 0;
    return Logger;
}());
/** @deprecated 为了兼容某些插件用引入thumbplayer-core的日志函数保留空函数 */
function logTool() { }

function transformInitData(initData, contentId, certificate) {
    var contentIdBuffer = encodingTool.utf16.toUint16Array(contentId);
    // Format:
    // [initData]
    // [4 byte: idLength]
    // [idLength byte: id]
    // [4 byte:certificateLength]
    // [certificateLength byte: certificate]
    var size = initData.byteLength + 4 + contentIdBuffer.byteLength + 4 + certificate.byteLength;
    var offset = 0;
    var buffer = new ArrayBuffer(size);
    var dataView = new DataView(buffer);
    var initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initDataArray.byteLength;
    dataView.setUint32(offset, contentIdBuffer.byteLength, true);
    offset += 4;
    var idArray = new Uint16Array(buffer, offset, contentIdBuffer.length);
    idArray.set(contentIdBuffer);
    offset += idArray.byteLength;
    dataView.setUint32(offset, certificate.byteLength, true);
    offset += 4;
    var certificateArray = new Uint8Array(buffer, offset, certificate.byteLength);
    certificateArray.set(certificate);
    return new Uint8Array(buffer, 0, buffer.byteLength);
}
function getContentId(initData) {
    var _a, _b, _c;
    var asString = encodingTool.utf16.fromTypeArray(initData);
    var contentId = (_c = (_b = (_a = asString.split('skd://')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('?')) === null || _c === void 0 ? void 0 : _c[0];
    return contentId;
}

function builtMessageXML(message) {
    return new DOMParser()
        .parseFromString(String.fromCharCode.apply(null, new Uint16Array(message)), 'application/xml');
}
function getChallenge(doc) {
    var el = doc.getElementsByTagName('Challenge')[0];
    try {
        return atob(el.childNodes[0].nodeValue);
    }
    catch (e) {
        throw 'cannot parse <Challenge> from init message';
    }
}
function builtHeadersFromXML(doc) {
    var headers = {};
    var headerNames = doc.getElementsByTagName('name');
    var headerValues = doc.getElementsByTagName('value');
    if (headerNames.length !== headerValues.length) {
        throw 'header names and values are not match';
    }
    for (var i = 0; i < headerNames.length; i++) {
        headers[headerNames[i].childNodes[0].nodeValue] = headerValues[i].childNodes[0].nodeValue;
    }
    return headers;
}

var i18nCore$1 = i18nConfig.core;
/**
 * 加密系统名称
 */
var KeySystems;
(function (KeySystems) {
    KeySystems["FairPlayWebKit"] = "com.apple.fps.1_0";
    KeySystems["Widevine"] = "com.widevine.alpha";
    KeySystems["FairPlay"] = "com.apple.fps";
    KeySystems["Chacha"] = "com.tencent.chacha";
    KeySystems["PlayReady"] = "com.microsoft.playready";
    KeySystems["PlayReadyHardware"] = "com.microsoft.playready.hardware";
})(KeySystems || (KeySystems = {}));
function getSupportedKeySystemConfig(keySystem) {
    switch (keySystem) {
        case KeySystems.FairPlayWebKit:
            return null;
        case KeySystems.Widevine:
            return {
                initDataTypes: ['cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                        robustness: 'SW_SECURE_CRYPTO',
                    }],
            };
        case KeySystems.FairPlay:
            return {
                initDataTypes: ['skd', 'cenc'],
                videoCapabilities: [
                    {
                        contentType: 'application/vnd.apple.mpegurl',
                        robustness: '',
                    },
                ],
            };
        case KeySystems.PlayReady:
        case KeySystems.PlayReadyHardware:
            return {
                initDataTypes: ['keyids', 'cenc'],
                audioCapabilities: [{
                        contentType: 'audio/mp4; codecs="mp4a.40.2"',
                    }],
                videoCapabilities: [{
                        contentType: 'video/mp4; codecs="avc1.42E01E"',
                    }],
            };
        default:
            return null;
    }
}
var ERR = 'error';
/**
 * DRM模块，支持Apple Fairplay Streaming和Widevine
 *
 * fairplay和widevine均可以通过EME标准接口实现，区别仅在fps需要服务端证书和两者的license请求包数据不同
 *
 * ! fairplay需要在macOS 10.14.4，ios 12.2以上才支持EME接口, webkit需要最低macOS 10.10.3, iOS 11.2
 */
var DRM = /** @class */ (function (_super) {
    __extends(DRM, _super);
    function DRM(media, config, instanceId) {
        var _this = _super.call(this) || this;
        /** 是否处于启用的状态 */
        _this.started = false;
        /**
         * 当前的keySession信息，包含mediaKey，session，initData等
         */
        _this.mediaKeyDescriptor = null;
        /**
         * mediaKey promise，给EME实现的版本使用
         */
        _this.mediaKeyPromise = null;
        _this.destroyed = false;
        /**
         * ====================================================================================
         * 标准EME实现的加密播放流程
         * 1. 创建mediaKey
         * 2. 通过mediaKey创建mediaKeySession，创建session请求信息，同时把mediaKey绑定到video上
         * 3. 监听mediaKeySession的message事件，请求license
         * 4. 更新session解密信息
         */
        /**
         * HTML5 video encrypted事件监听
         * @event encrypted
         */
        _this.onVideoEncrypted = function (event) {
            _this.logger.log('media encrypted', event);
            if (!_this.mediaKeyPromise) {
                _this.emit(ERR, {
                    code: 4 /* DrmErrorCode.KEY_SYS_NOT_REQUESTED */,
                    message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_NOT_REQUESTED),
                });
                return;
            }
            _this.mediaKeyPromise
                .then(function () {
                if (!_this.mediaKeyDescriptor) {
                    _this.emit(ERR, {
                        code: 6 /* DrmErrorCode.KEY_NOT_EXIST */,
                        message: compile(i18nCore$1.ERROR_DRM_KEY_NOT_EXIST),
                    });
                    return;
                }
                // 这里主要是避免重复设置mediaKey，但是原则上这个事件应该只派发一次
                if (_this.mediaKeyDescriptor.hasInitialized) {
                    _this.logger.warn('Media key-session has been initialized but requested again');
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeys) {
                    _this.emit(ERR, {
                        code: 6 /* DrmErrorCode.KEY_NOT_EXIST */,
                        message: compile(i18nCore$1.ERROR_DRM_KEY_NOT_EXIST),
                    });
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeySession) {
                    _this.emit(ERR, {
                        code: 5 /* DrmErrorCode.KEY_SESSION_NOT_EXIST */,
                        message: compile(i18nConfig.ERROR_DRM_KEY_SESSION_NOT_EXIST),
                    });
                    return;
                }
                if (!event.initData) {
                    _this.emit(ERR, {
                        code: 7 /* DrmErrorCode.INIT_DATA_EMPTY */,
                        message: compile(i18nCore$1.ERROR_DRM_INIT_DATA_EMPTY),
                    });
                    return;
                }
                _this.mediaKeyDescriptor.mediaKeySession.generateRequest(event.initDataType, event.initData).catch(function () {
                    _this.emit(ERR, {
                        code: 13 /* DrmErrorCode.KEY_SESSION_REQUEST_FAILED */,
                        message: compile(i18nConfig.ERROR_DRM_KEY_SESSION_REQUEST_FAILED),
                    });
                    return;
                });
                _this.mediaKeyDescriptor.initData = event.initData;
                _this.mediaKeyDescriptor.hasInitialized = true;
            });
        };
        /**
         * HTML5 video webkitneededkey事件监听
         */
        _this.onVideoWebkitneedkey = function (event) {
            // 通过initData解析contentId，sdk://xxxx的格式
            var contentId = _this.config.fpsCustomContentId(event.initData);
            var cert = DRM_1.serverCertificate[KeySystems.FairPlayWebKit];
            if (!cert) {
                _this.emit(ERR, {
                    code: 9 /* DrmErrorCode.FPS_CERTIFICATE_NOT_EXIST */,
                    message: compile(i18nCore$1.ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST),
                });
                return;
            }
            // webkit这里需要重新拼接init信息，格式为assetId + certificate
            var initData = _this.config.fpsCustomTransformInitData(event.initData, contentId, cert);
            _this.mediaKeyDescriptor.initData = initData;
            // 避免重复创建session，防止请求的包数据错误
            if (_this.mediaKeyDescriptor.mediaKeySession) {
                _this.logger.warn('Media key-session has already been initialized');
                return;
            }
            _this.mediaKeyDescriptor.mediaKeySession = _this.createSessionWithMediaKey(_this.mediaKeyDescriptor.mediaKeys, initData);
            _this.mediaKeyDescriptor.assetID = contentId;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyadded = _this.onFPSKeySessionKeyAdded;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyerror = _this.onFPSKeySessionKeyError;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeymessage = function (event) {
                _this.onMediaKeySessionMessage(_this.mediaKeyDescriptor.mediaKeySession, event);
            };
        };
        _this.onFPSKeySessionKeyAdded = function (_event) {
            // 目前没发现用途，主要是debug
        };
        _this.onFPSKeySessionKeyError = function (_event) {
            var err = _this.mediaKeyDescriptor.mediaKeySession.error;
            if (err.systemCode) {
                var errCodeMap = {
                    // https://developer.apple.com/forums/thread/64204
                    1212433232: [10 /* DrmErrorCode.HDCP_ERROR */, compile(i18nCore$1.ERROR_DRM_HDCP)],
                };
                if (errCodeMap[err.systemCode]) {
                    _this.emit(ERR, {
                        code: errCodeMap[err.systemCode][0],
                        message: errCodeMap[err.systemCode][1],
                    });
                }
                return;
            }
            _this.emit(ERR, {
                code: 0 /* DrmErrorCode.UNKNOWN */,
                message: compile(i18nCore$1.ERROR_DRM_UNKNOWN),
            });
        };
        _this.media = media;
        _this.instanceId = instanceId;
        _this.logger = new Logger(_this.instanceId, 'drm');
        _this.config = __assign({ keySystem: null, fpsCustomContentId: getContentId, fpsCustomTransformInitData: transformInitData }, config);
        return _this;
    }
    DRM_1 = DRM;
    Object.defineProperty(DRM.prototype, "isFairPlay", {
        /** 是否是fairplay */
        get: function () {
            var ks = this.config.keySystem;
            return ks === KeySystems.FairPlay || ks === KeySystems.FairPlayWebKit;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 检测环境是否支持指定的keySystem
     * @param keySystem EME key system name, e.g. com.apple.fps.1_0
     */
    DRM.isKeySystemSupported = function (keySystem) {
        var _a;
        var _b, _c;
        var condition = (_a = {},
            _a[KeySystems.FairPlayWebKit] = [
                (_b = self.WebKitMediaKeys) === null || _b === void 0 ? void 0 : _b.isTypeSupported(keySystem, 'video/mp4'),
            ],
            // 这里只检查EME接口是否存在
            _a[KeySystems.FairPlay] = [
                uaTool.browser.safari,
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.Widevine] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.PlayReady] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a[KeySystems.PlayReadyHardware] = [
                self.MediaKeys,
                self.navigator.requestMediaKeySystemAccess,
            ],
            _a);
        return (_c = condition[keySystem]) === null || _c === void 0 ? void 0 : _c.every(Boolean);
    };
    DRM.prototype.destroy = function () {
        this.reset();
        this.removeAllListeners();
        this.logger = null;
        this.destroyed = true;
    };
    /**
     * 更新配置参数，主要用于更新license地址和服务器证书等
     * @param config 配置参数
     */
    DRM.prototype.configure = function (config) {
        var _this = this;
        this.config = __assign(__assign({}, this.config), config);
        if (this.config.certificate) {
            Object.keys(this.config.certificate).forEach(function (key) {
                DRM_1.serverCertificate[key] = _this.config.certificate[key];
            });
        }
    };
    /**
     * DRM模块是否已启用
     */
    DRM.prototype.hasStarted = function () {
        return this.started;
    };
    /**
     * 初始化drm流程，需要外部主动调用
     * @param config 可选配置参数
     */
    DRM.prototype.init = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.reset()];
                    case 1:
                        _a.sent();
                        if (config) {
                            this.configure(config);
                        }
                        if (!(typeof DRM_1.serverCertificate[this.config.keySystem] === 'string')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.requestServerCertificate(this.config.keySystem, DRM_1.serverCertificate[this.config.keySystem])];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (this.destroyed) {
                            // 调用方可能在play()以后马上destroy，例如feeds页面快速滚动的情况，
                            // 如果马上销毁这个init上面两个await的异步操作可能没执行完毕，导致播放器被销毁以后，还在继续往下执行导致报错。
                            return [2 /*return*/];
                        }
                        this.bind();
                        this.logger.log('drm module initialized');
                        this.logger.cache('drm config', this.config);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 重置。注销事件监听，销毁keySession等。
     * ! setMediaKeys 需要在src为空时调用，否则会抛出异常
     */
    DRM.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jobs, session;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.started = false;
                        if (!this.config.keySystem || !this.mediaKeyDescriptor)
                            return [2 /*return*/];
                        jobs = (_a = {},
                            _a[KeySystems.FairPlayWebKit] = this.cleanupFPSSession,
                            _a[KeySystems.FairPlay] = this.cleanupMediaKeySession,
                            _a[KeySystems.Widevine] = this.cleanupMediaKeySession,
                            _a[KeySystems.PlayReady] = this.cleanupMediaKeySession,
                            _a[KeySystems.PlayReadyHardware] = this.cleanupMediaKeySession,
                            _a);
                        this.videoEncryptedEventPicker(false);
                        if (!jobs[this.config.keySystem]) return [3 /*break*/, 4];
                        session = this.mediaKeyDescriptor.mediaKeySession;
                        this.mediaKeyPromise = null;
                        this.mediaKeyDescriptor = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, jobs[this.config.keySystem].call(this, session)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 绑定事件，创建mediaKey
     */
    DRM.prototype.bind = function () {
        // 如果进来的时候没有keySystem则不执行任何逻辑
        var userKeySystem = this.config.keySystem;
        if (!userKeySystem) {
            return;
        }
        if (!DRM_1.isKeySystemSupported(userKeySystem)) {
            this.logger.warn("\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301 ".concat(userKeySystem));
            return;
        }
        this.started = true;
        // 这个promise会在session创建后resolve
        this.mediaKeyPromise = this.createKeySystemAccess(userKeySystem);
        this.videoEncryptedEventPicker(true);
    };
    /**
     * 标准EME实现的清理方法。
     */
    DRM.prototype.cleanupMediaKeySession = function (mediaKeySession) {
        if (!this.media || !mediaKeySession)
            return Promise.resolve();
        mediaKeySession.onmessage = null;
        mediaKeySession.onkeystatuseschange = null;
        // 不处理close和setMediaKey过程中的报错
        mediaKeySession.close().catch(function () { });
        return this.media.setMediaKeys(null);
    };
    /**
     * 根据keySystem监听video的加密事件
     * @param toggle true为监听，false为取消监听
     */
    DRM.prototype.videoEncryptedEventPicker = function (toggle) {
        var _a;
        if (toggle === void 0) { toggle = true; }
        var supportedEvents = (_a = {},
            _a[KeySystems.FairPlayWebKit] = ['webkitneedkey', this.onVideoWebkitneedkey],
            _a[KeySystems.Widevine] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.FairPlay] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.PlayReady] = ['encrypted', this.onVideoEncrypted],
            _a[KeySystems.PlayReadyHardware] = ['encrypted', this.onVideoEncrypted],
            _a);
        var _b = supportedEvents[this.config.keySystem], event = _b[0], handler = _b[1];
        if (toggle)
            this.media.addEventListener(event, handler);
        else
            this.media.removeEventListener(event, handler);
    };
    /**
     * 根据keySystem创建mediaKey session
     * @param mediaKey EME mediaKey
     * @param sessionInitData 加密事件抛出的initData，fps webkit使用
     */
    DRM.prototype.createSessionWithMediaKey = function (mediaKey, sessionInitData) {
        var _a;
        var creator = (_a = {},
            _a[KeySystems.FairPlayWebKit] = this.createFPSWebkitSession,
            _a[KeySystems.Widevine] = this.createMediaKeySession,
            _a[KeySystems.FairPlay] = this.createMediaKeySession,
            _a[KeySystems.PlayReady] = this.createMediaKeySession,
            _a[KeySystems.PlayReadyHardware] = this.createMediaKeySession,
            _a);
        return creator[this.config.keySystem].call(this, mediaKey, sessionInitData);
    };
    /**
     * 创建用于CDM访问的mediaKey
     * @param keySystem 加密类型
     */
    DRM.prototype.createKeySystemAccess = function (keySystem) {
        var _a;
        var creator = (_a = {},
            _a[KeySystems.Widevine] = this.requestKeySystemAccess,
            _a[KeySystems.FairPlay] = this.requestKeySystemAccess,
            _a[KeySystems.FairPlayWebKit] = this.requestFPSMediaKeys,
            _a[KeySystems.PlayReady] = this.requestKeySystemAccess,
            _a[KeySystems.PlayReadyHardware] = this.requestKeySystemAccess,
            _a);
        return creator[this.config.keySystem].call(this, keySystem);
    };
    /**
     * 根据keySystem请求license
     * @param data license请求的数据
     * @param callback license xhr请求的onload回调
     */
    DRM.prototype.requestLicense = function (data, callback) {
        var _a;
        if (!this.config.licenseUrl) {
            this.emit(ERR, {
                code: 12 /* DrmErrorCode.LICENSE_NOT_EXIST */,
                message: compile(i18nCore$1.ERROR_DRM_LICENSE_NOT_EXIST),
            });
            return;
        }
        var request = (_a = {},
            _a[KeySystems.FairPlayWebKit] = this.createFPSLicenseRequest,
            _a[KeySystems.Widevine] = this.createWidevineLicenseRequest,
            _a[KeySystems.PlayReady] = this.createPlayReadyLicenseRequest,
            _a[KeySystems.FairPlay] = this.createFPSLicenseRequest,
            _a[KeySystems.PlayReadyHardware] = this.createPlayReadyLicenseRequest,
            _a);
        return request[this.config.keySystem].call(this, data, callback);
    };
    /**
     * 请求服务端证书
     * @param keySystem 加密类型
     * @param url 证书地址
     */
    DRM.prototype.requestServerCertificate = function (keySystem, url) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, netTool.xhr({
                            method: 'GET',
                            responseType: 'arraybuffer',
                            url: url,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        DRM_1.serverCertificate[keySystem] = new Uint8Array(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第一步，创建CDM access
     */
    DRM.prototype.requestKeySystemAccess = function (keySystem) {
        return __awaiter(this, void 0, void 0, function () {
            var keySystemConfig, keySystemAccess;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        keySystemConfig = getSupportedKeySystemConfig(keySystem);
                        if (!keySystemConfig) {
                            this.emit(ERR, {
                                code: 3 /* DrmErrorCode.KEY_SYS_NOT_SUPPORTED */,
                                message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_NOT_SUPPORTED, keySystem),
                            });
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, self.navigator.requestMediaKeySystemAccess(keySystem, [keySystemConfig])];
                    case 2:
                        keySystemAccess = _a.sent();
                        return [2 /*return*/, this.onMediaKeySystemObtained(keySystem, keySystemAccess)];
                    case 3:
                        _a.sent();
                        this.emit(ERR, {
                            code: 1 /* DrmErrorCode.KEY_SYS_ACCESS_FAILED */,
                            message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_ACCESS_FAILED, keySystem),
                        });
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第二步，创建mediaKey
     */
    DRM.prototype.onMediaKeySystemObtained = function (keySystem, mediaKeySystemAccess) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaKeys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mediaKeySystemAccess.createMediaKeys()];
                    case 1:
                        mediaKeys = _a.sent();
                        this.mediaKeyDescriptor = {
                            hasInitialized: false,
                            mediaKeySession: null,
                            mediaKeySystemAccess: mediaKeySystemAccess,
                            mediaKeys: mediaKeys,
                            closed: false,
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!(keySystem === KeySystems.FairPlay)) return [3 /*break*/, 4];
                        return [4 /*yield*/, mediaKeys.setServerCertificate(DRM_1.serverCertificate[KeySystems.FairPlay])];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.createSessionWithMediaKey(mediaKeys);
                        return [2 /*return*/, mediaKeys];
                    case 5:
                        _a.sent();
                        this.emit(ERR, {
                            code: 2 /* DrmErrorCode.KEY_SESSION_CREATION_FAILED */,
                            message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED),
                        });
                        return [2 /*return*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 第三步，创建mediaKeySession，监听message事件
     */
    DRM.prototype.createMediaKeySession = function (mediaKeys) {
        var _this = this;
        var _a;
        // 这里避免重复创建导致session信息错误
        if (this.mediaKeyDescriptor.mediaKeySession) {
            this.logger.warn('Media key-session has already been initialized');
            return;
        }
        // https://www.w3.org/TR/encrypted-media/#dom-mediakeystatus
        // EME spec中定义的key status
        var keyStatusMap = {
            'output-restricted': [10 /* DrmErrorCode.HDCP_ERROR */, compile(i18nCore$1.ERROR_DRM_HDCP)],
            'output-downscaled': [10 /* DrmErrorCode.HDCP_ERROR */, compile(i18nCore$1.ERROR_DRM_HDCP)],
            'status-pending': null,
            'internal-error': [17 /* DrmErrorCode.KEY_INTERNAL_ERROR */, compile(i18nCore$1.ERROR_DRM_KEY_INTERNAL)],
            usable: null,
            expired: [15 /* DrmErrorCode.KEY_EXPIRED */, compile(i18nCore$1.ERROR_DRM_KEY_EXPIRED)],
            released: [16 /* DrmErrorCode.KEY_RELEASED */, compile(i18nCore$1.ERROR_DRM_KEY_RELEASED)],
        };
        var keySession = mediaKeys.createSession();
        this.mediaKeyDescriptor.mediaKeySession = keySession;
        if (typeof ((_a = keySession.closed) === null || _a === void 0 ? void 0 : _a.then) === 'function') {
            keySession.closed.then(function () { return _this.mediaKeyDescriptor.closed = true; });
        }
        this.mediaKeyDescriptor.mediaKeySession.onkeystatuseschange = function (e) {
            var _a, _b, _c;
            (_c = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.keyStatuses) === null || _b === void 0 ? void 0 : _b.forEach) === null || _c === void 0 ? void 0 : _c.call(_b, function (status) {
                if (!_this.mediaKeyDescriptor)
                    return;
                if (keyStatusMap[status]) {
                    var _a = keyStatusMap[status], code = _a[0], message = _a[1];
                    _this.emit(ERR, {
                        code: code,
                        message: message,
                    });
                }
            });
        };
        this.mediaKeyDescriptor.mediaKeySession.onmessage = function (event) {
            _this.onMediaKeySessionMessage(keySession, event);
        };
        this.media.setMediaKeys(mediaKeys)
            .then(function () {
            _this.logger.log('media keys set');
        })
            .catch(function (e) {
            _this.logger.error('media keys set failed', e);
            _this.emit(ERR, {
                code: 18 /* DrmErrorCode.MEDIA_KEYS_SET_FAILED */,
                message: compile(i18nCore$1.ERROR_DRM_MEDIA_KEYS_SET_FAILED),
            });
        });
    };
    /**
     * 第四步，请求license并更新session解密信息
     *
     * 这里webkit和EME的实现相同，两者共用一个方法处理
     */
    DRM.prototype.onMediaKeySessionMessage = function (keySession, event) {
        var _this = this;
        this.logger.log('received media key session message', event);
        // workaround: 20230523 M113版本的Chrome当使用4.10.2652.0版本的Widevine CDM时，会出现密钥失效的问题
        // 这里做一个兼容，从证书protobuf中读取到特征字段后直接抛出错误引导用户重启浏览器进程
        if (this.config.enableChromeM113Workaround
            && uaTool.browser.chrome
            && commonTool.compareVersion(uaTool.browser.version, '113') === 0) {
            try {
                if (new TextDecoder()
                    .decode(event.message)
                    .includes('4.10.2652.0')) {
                    this.emit(ERR, {
                        code: 14 /* DrmErrorCode.KEY_SESSION_UPDATE_FAILED */,
                        message: '当前浏览器版本解密模块存在问题导致无法播放, 请尝试升级或重启浏览器进行修复[CDM=4.10.2652.0]',
                        fatal: true,
                    });
                    return;
                }
            }
            catch (e) { }
        }
        this.requestLicense(event, function (response) { return __awaiter(_this, void 0, void 0, function () {
            var data, e_3, updatePromise, e_4;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.mediaKeyDescriptor.closed)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        data = response.data;
                        if (!this.config.licenseResponseSetup) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        this.timeStart(CoreStepKey.LIC_RES_SET);
                        return [4 /*yield*/, this.config.licenseResponseSetup(data)];
                    case 3:
                        data = (_b.sent()) || data;
                        this.timeEnd(CoreStepKey.LIC_RES_SET);
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _b.sent();
                        if (this.mediaKeyDescriptor.closed)
                            return [2 /*return*/];
                        this.emit(ERR, {
                            code: 20 /* DrmErrorCode.LICENSE_RESPONSE_SETUP_EXCEPTION */,
                            detail: (_a = e_3.code) !== null && _a !== void 0 ? _a : 0,
                            message: compile(i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED),
                        });
                        return [2 /*return*/];
                    case 5:
                        if (!data) {
                            // 如果无法解析或解析出不合法结果，报错并终止
                            this.emit(ERR, {
                                code: 14 /* DrmErrorCode.KEY_SESSION_UPDATE_FAILED */,
                                message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED),
                            });
                            return [2 /*return*/];
                        }
                        updatePromise = keySession.update(data);
                        // 兼容一下webkit fps，只有标准EME实现update才会返回promise
                        updatePromise === null || updatePromise === void 0 ? void 0 : updatePromise.catch(function () {
                            if (_this.mediaKeyDescriptor.closed)
                                return;
                            _this.emit(ERR, {
                                code: 14 /* DrmErrorCode.KEY_SESSION_UPDATE_FAILED */,
                                message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED),
                            });
                            return;
                        });
                        return [3 /*break*/, 7];
                    case 6:
                        e_4 = _b.sent();
                        if (this.mediaKeyDescriptor.closed)
                            return [2 /*return*/];
                        this.emit(ERR, {
                            code: 11 /* DrmErrorCode.LICENSE_REQUEST_FAILED */,
                            detail: e_4.code,
                            message: compile(i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED),
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 创建widevine license的xhr请求
     * ! widevine的请求数据为event.message
     */
    DRM.prototype.createWidevineLicenseRequest = function (event, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var message, opts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = event.message;
                        opts = {
                            method: 'POST',
                            responseType: 'arraybuffer',
                            body: message,
                            url: this.config.licenseUrl,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                        };
                        return [4 /*yield*/, this.requestLicenseBySystem(opts, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 创建playready的license请求
     */
    DRM.prototype.createPlayReadyLicenseRequest = function (event, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var message, keyMessageXML, opts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = event.message;
                        keyMessageXML = builtMessageXML(message);
                        opts = {
                            method: 'POST',
                            responseType: 'arraybuffer',
                            body: getChallenge(keyMessageXML),
                            url: this.config.licenseUrl,
                            headers: builtHeadersFromXML(keyMessageXML),
                        };
                        return [4 /*yield*/, this.requestLicenseBySystem(opts, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 创建fps license的xhr请求
     * ! fps的基础请求数据为spc=data, 其中data是base64编码的event.message
     */
    DRM.prototype.createFPSLicenseRequest = function (event, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var message, spcMessage, opts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = event.message;
                        spcMessage = encodeURIComponent(encodingTool.base64.fromUint8Array(message));
                        opts = {
                            method: 'POST',
                            responseType: 'arraybuffer',
                            body: "spc=".concat(spcMessage, "&assetId=").concat(this.mediaKeyDescriptor.assetID),
                            url: this.config.licenseUrl,
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                        };
                        return [4 /*yield*/, this.requestLicenseBySystem(opts, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DRM.prototype.requestLicenseBySystem = function (opts, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5, rsp, error_2, code;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.config.licenseRequestSetup) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.timeStart(CoreStepKey.LIC_REQ_SET);
                        return [4 /*yield*/, this.config.licenseRequestSetup(opts)];
                    case 2:
                        opts = _b.sent();
                        this.timeEnd(CoreStepKey.LIC_REQ_SET);
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _b.sent();
                        this.emit(ERR, {
                            code: 19 /* DrmErrorCode.LICENSE_REQUEST_SETUP_EXCEPTION */,
                            detail: (_a = e_5.code) !== null && _a !== void 0 ? _a : 0,
                            message: compile(i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED),
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        this.timeStart(CoreStepKey.LIC_REQ);
                        return [4 /*yield*/, netTool.xhr(opts)];
                    case 5:
                        rsp = _b.sent();
                        this.timeEnd(CoreStepKey.LIC_REQ);
                        callback(rsp);
                        return [3 /*break*/, 7];
                    case 6:
                        error_2 = _b.sent();
                        code = (error_2 || {}).code;
                        this.emit(ERR, {
                            code: 11 /* DrmErrorCode.LICENSE_REQUEST_FAILED */,
                            detail: code,
                            message: compile(i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED),
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * ====================================================================================
     * Apple Fairplay Webkit标准的加密播放流程
     * 1. 创建webkit mediaKey
     * 2. 绑定mediakey到video，这里需要先绑定后创建session
     * 3. 监听webkitneededkey，拼装initData并创建session
     * 4. 监听session的message事件，创建license请求
     * 5. 更新session的解密信息
     */
    /**
     * 创建webkit mediaKey
     */
    DRM.prototype.requestFPSMediaKeys = function () {
        var mediaKey = new window.WebKitMediaKeys(KeySystems.FairPlayWebKit);
        // ! fps1.0 need to set key before create session
        this.media.webkitSetMediaKeys(mediaKey);
        // 这里如果设置失败了，在createSession的时候会因为没有mediakey而报错
        this.mediaKeyDescriptor = {
            mediaKeySession: null,
            initData: null,
            hasInitialized: false,
            mediaKeySystemAccess: null,
            mediaKeys: this.media.webkitKeys,
            closed: false,
        };
        return Promise.resolve(mediaKey);
    };
    /**
     * 创建webkit mediakey的session
     */
    DRM.prototype.createFPSWebkitSession = function (mediaKeys, initData) {
        // 这里取到的mediaKey是绑定在video标签上的，如果绑定失败了会在这里抛出
        if (!mediaKeys) {
            this.emit(ERR, {
                code: 8 /* DrmErrorCode.FPS_SET_KEY_FAILED */,
                message: compile(i18nCore$1.ERROR_DRM_FPS_SET_KEY_FAILED),
            });
            return;
        }
        // 创建session失败时返回为null
        // todo 其实如果sessionId为空也应该判别为失败
        var session = mediaKeys.createSession('video/mp4', initData);
        if (!session) {
            this.emit(ERR, {
                code: 2 /* DrmErrorCode.KEY_SESSION_CREATION_FAILED */,
                message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED),
            });
            return;
        }
        return session;
    };
    /**
     * 清理webkit mediakey session
     */
    DRM.prototype.cleanupFPSSession = function (mediaKeySession) {
        if (!mediaKeySession)
            return Promise.resolve();
        this.media.webkitSetMediaKeys(null);
        mediaKeySession.onwebkitkeyadded = null;
        mediaKeySession.onwebkitkeyerror = null;
        mediaKeySession.onwebkitkeymessage = null;
        return Promise.resolve();
    };
    var DRM_1;
    /**
     * 服务器证书缓存，目前只有fairplay会用到
     */
    DRM.serverCertificate = {};
    DRM = DRM_1 = __decorate([
        stepTimerClassDecorator,
        __metadata("design:paramtypes", [Object, Object, String])
    ], DRM);
    return DRM;
}(EvtEmitter));

var AutoPlayPolicy = /** @class */ (function () {
    function AutoPlayPolicy(videoElement, extra) {
        this.logger = new Logger(extra.instanceId, 'AutoPlayPolicy');
        this.videoElement = videoElement;
    }
    /**
     * 触发自动播放的原理就是调用了play以后马上调用pause，这里会分成两种情况：
     * 1. 如果video.readyState为0（https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLMediaElement/readyState），这里可以
     * 捕获到如下错误，捕获到错误以后触发完成。
     * chrome: The play() request was interrupted by a call to pause()
     * safari/ios: The operation was aborted
     *
     * 2. 如果video.readyState不为0（可能已经设置src或者已经有数据），直接触发完成。
     */
    AutoPlayPolicy.prototype.userTrigger = function () {
        var _this = this;
        this.triggerDefer = new SimpleDefer();
        this.logger.log('userTrigger(), start');
        var catchTimeoutId;
        // video调用一次play和pause，通常情况会catch住一个video抛出来的interrupt异常，如果被自动播放阻止，则为另一个异常
        var catchHandler = function (e) {
            if (catchTimeoutId > 0) {
                clearTimeout(catchTimeoutId);
                catchTimeoutId = 0;
            }
            _this.logger.log('userTrigger(), catch: ', e.name, e.message);
            if (videoTool.isAutoPlayBlockedMessage(e.message)) {
                _this.triggerDefer.reject(e);
            }
            else {
                _this.logger.log('userTrigger() over, catched.');
                _this.triggerDefer.resolve();
            }
        };
        var playPromise = this.videoElement.play();
        this.videoElement.pause();
        if (this.videoElement.readyState === 0) {
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            if (playPromise) {
                playPromise.catch(catchHandler);
            }
            // 某些浏览器环境video.play没有返回promise或者play后马上pause不会有catch，这种情况用超时来判断
            catchTimeoutId = window.setTimeout(function () {
                _this.logger.log('userTrigger() over, timeout.');
                _this.triggerDefer.resolve();
            }, 300);
        }
        else {
            this.logger.log('userTrigger() over, sync.');
            var delayTime = (uaTool.browser.safari && !uaTool.mobile) ? 400 : 0;
            // 同步触发的话，play马上pause，那么这两个事件是非常接近的。可能会导致外部来不及处理，所以延迟一下。
            // 但这里调试遇到safari需要点两次播放按钮的问题，具体如下：
            // 1. setTimeout的delay为0时，safari点播放按钮，状态为loadStart,canplay,playing，此时画面不动，需要再点一次
            // 2. setTimeout的delay为400ms（实验值）时，safari点播放按钮，状态为loadStart,canplay,playing，可正常起播
            // 3. 我们把这个setTimeout改成Promise.resolve，发现safari点播放按钮有时候可以成功播放，有时候无法成功播放，
            // 状态均为 loadStart,canplay,playing,pause,playing
            // 4. 去掉这个延迟，即不用setTimeout或Promise，也可能出现点一下播放按钮可播放，或者点两下才可播的情况，
            // 状态均为 loadStart,canplay,playing,pause,playing
            // 所以这里猜测safari浏览器自动播放被阻止后调用play, pause（autoplay-policy内的逻辑），再调用play（外部调用恢复播放）存在异步
            // 调用bug，浏览器兼容性暂无法解决，用上述2的方法延迟处理
            window.setTimeout(function () {
                _this.triggerDefer.resolve();
            }, delayTime);
        }
        return this.triggerDefer.promise;
    };
    AutoPlayPolicy.prototype.destroy = function () {
        this.videoElement = null;
    };
    return AutoPlayPolicy;
}());

var _a$4;
/* eslint-disable @typescript-eslint/naming-convention */
var BuiltInErrorType;
(function (BuiltInErrorType) {
    /** 原生错误 */
    BuiltInErrorType["Native"] = "native";
    /** 网络错误 */
    BuiltInErrorType["Network"] = "network";
    /** 加密错误 */
    BuiltInErrorType["Encryption"] = "encryption";
    /** 自定义错误 */
    BuiltInErrorType["Custom"] = "custom";
})(BuiltInErrorType || (BuiltInErrorType = {}));
var ErrorTypeCodeMap = (_a$4 = {},
    _a$4[BuiltInErrorType.Native] = 11,
    _a$4[BuiltInErrorType.Network] = 16,
    _a$4[BuiltInErrorType.Encryption] = 90,
    _a$4[BuiltInErrorType.Custom] = -1,
    _a$4);
var MediaElementNetworkErrorCode = [1 /** MEDIA_ERR_ABORTED */, 2 /** MEDIA_ERR_NETWORK */];
var MediaElementPlaybackErrorCode = [3 /** MEDIA_ERR_DECODE */, 4 /** MEDIA_ERR_SRC_NOT_SUPPORTED */];
/**
 * 11103、11104的细分错误码枚举（bit位）
 */
var MediaElementNativeDetail;
(function (MediaElementNativeDetail) {
    /** 不支持avc播放 */
    MediaElementNativeDetail[MediaElementNativeDetail["BaselineAVCNotSupported"] = 2] = "BaselineAVCNotSupported";
    /** 未开启硬件加速 */
    MediaElementNativeDetail[MediaElementNativeDetail["HardwareAcceleratedOff"] = 1] = "HardwareAcceleratedOff";
    /**
     * 服务端返回了200/206。返回的数据无法播放
     */
    MediaElementNativeDetail[MediaElementNativeDetail["NetworkOk"] = 4] = "NetworkOk";
    /**
     * 服务端有数据返回（responseStart和responseEnd表示第一个字节时开始，在收到最后一个字节后立即结束）。可能的情况有：
     * 1. 考虑cdn返回403
     * 2. 考虑返回的数据无法播放
     */
    MediaElementNativeDetail[MediaElementNativeDetail["NetworkResponsed"] = 8] = "NetworkResponsed";
    /** 握手成功，但服务端未返回任何数据 */
    MediaElementNativeDetail[MediaElementNativeDetail["NetworkConnected"] = 16] = "NetworkConnected";
    /** 网络不通 */
    MediaElementNativeDetail[MediaElementNativeDetail["NetworkOffline"] = 32] = "NetworkOffline";
})(MediaElementNativeDetail || (MediaElementNativeDetail = {}));

/**
 * 错误基类，兼容已有的IVideoError
 *
 * @export
 * @class ErrorBase
 * @typedef {ErrorBase}
 * @implements {IVideoError}
 */
var ErrorBase = /** @class */ (function () {
    function ErrorBase(type, config) {
        /** 详细错误码 */
        this.detail = null;
        var code = config.code, detail = config.detail, message = config.message, fatal = config.fatal, debugMessage = config.debugMessage;
        this.type = type;
        this.errorCode = code;
        this.detail = detail !== null && detail !== void 0 ? detail : null;
        this.fatal = fatal !== null && fatal !== void 0 ? fatal : false;
        this.message = message !== null && message !== void 0 ? message : compile(defaultI18nConfig.core.ERROR_MSG_UNKNOWN);
        this.debugMessage = debugMessage;
    }
    Object.defineProperty(ErrorBase.prototype, "code", {
        /** 外显的完整错误码 */
        get: function () {
            var base = this.type === BuiltInErrorType.Custom
                ? "".concat(this.errorCode)
                : "".concat(ThumbPlayerErrorPrefix).concat(ErrorTypeCodeMap[this.type]).concat(patchCode(this.errorCode));
            if (this.detail) {
                return "".concat(base, ".").concat(this.detail);
            }
            return base;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 通过code比较两个error是否相同
     */
    ErrorBase.prototype.equals = function (other, strict) {
        if (strict === void 0) { strict = false; }
        if (other instanceof ErrorBase) {
            return this.type === other.type
                && this.errorCode === other.errorCode
                && (strict ? this.detail === other.detail : true);
        }
        return this.code === (other === null || other === void 0 ? void 0 : other.code);
    };
    // log工具，用于序列化错误对象
    ErrorBase.prototype.toString = function () {
        return this.serialize();
    };
    ErrorBase.prototype.toJSON = function () {
        return this.serialize();
    };
    ErrorBase.prototype.serialize = function () {
        var _a, _b;
        return "error=".concat(this.code, ";fatal=").concat(+this.fatal, ";msg=").concat((_b = (_a = this.debugMessage) !== null && _a !== void 0 ? _a : this.message) !== null && _b !== void 0 ? _b : '');
    };
    return ErrorBase;
}());
/** 中台播放器的固定错误码前缀 */
var ThumbPlayerErrorPrefix = '700';
/** string padStart的简化版 */
function patchCode(code) {
    return "000".concat(code).slice(-3);
}

// 历史原因，命名不符合tslint规范，但函数可能已经被业务使用。
var PlayerError = /** @class */ (function () {
    function PlayerError() {
    }
    PlayerError.CustomError = function (config) {
        return new ErrorBase(BuiltInErrorType.Custom, config);
    };
    /**
     * 生成原生错误对象，type=11
     *
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.NativeError = function (config) {
        return new ErrorBase(BuiltInErrorType.Native, config);
    };
    /**
     * 生成介质网络错误对象，type=16，code分配规则如下：
     * 0-99: 预留为core层面或原生video网络错误
     * 100-199: 预留为hlsjs网络错误
     * 200-299: 预留为flvjs网络错误
     * 300-399: 预留为demux内核网络错误
     * 400-499: 预留为wasm内核网络错误
     * 500-599: 预留为rtc内核网络错误
     * 600-699: 预留为electron内核网络错误
     * 700-999: reserved
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.NetworkError = function (config) {
        return new ErrorBase(BuiltInErrorType.Network, config);
    };
    /**
     * 生成加密错误对象，type=90
     *
     * @public
     * @static
     * @param {ErrorConfig} config
     */
    PlayerError.EncryptionError = function (config) {
        return new ErrorBase(BuiltInErrorType.Encryption, config);
    };
    return PlayerError;
}());

var NetTimingObserver = /** @class */ (function () {
    function NetTimingObserver() {
        var _this = this;
        this.originObserver = null;
        this.intervalObserverID = 0;
        this.isRunningInner = false;
        this.urlMap = {};
        this.filterPerformanceEntrys = function (entrys) {
            var entryList = entrys.getEntries();
            if (!entryList || entryList.length <= 0) {
                return;
            }
            Object.keys(_this.urlMap).forEach(function (url) {
                var _a, _b;
                var urlItem = _this.urlMap[url];
                if (urlItem.entry) {
                    // 已经被记录了：没有PerformanceObserver时interval监测的始终是performance.getEntrys()的列表，所以检查到一次就ok了
                    return;
                }
                var entry = entryList.find(function (entry) { return entry.name === url; });
                if (entry) {
                    urlItem.entry = entry;
                    (_b = (_a = urlItem.opts).callback) === null || _b === void 0 ? void 0 : _b.call(_a, entry);
                }
            });
        };
    }
    NetTimingObserver.prototype.destroy = function () {
        this.stop();
        this.urlMap = null;
    };
    NetTimingObserver.prototype.start = function () {
        if (this.isRunningInner) {
            return;
        }
        this.isRunningInner = true;
        if (typeof window.PerformanceObserver === 'undefined') {
            this.observerByInterval();
        }
        else {
            this.observerByOrigin();
        }
    };
    NetTimingObserver.prototype.stop = function () {
        this.isRunningInner = false;
        if (this.originObserver) {
            this.originObserver.disconnect();
            this.originObserver = null;
        }
        if (this.intervalObserverID !== 0) {
            window.clearInterval(this.intervalObserverID);
            this.intervalObserverID = 0;
        }
    };
    Object.defineProperty(NetTimingObserver.prototype, "isRunning", {
        get: function () {
            return this.isRunningInner;
        },
        enumerable: false,
        configurable: true
    });
    NetTimingObserver.prototype.push = function (opts) {
        var url = opts.url;
        this.urlMap[url] = { entry: undefined, opts: opts };
    };
    NetTimingObserver.prototype.getEntry = function (url) {
        var _a;
        return ((_a = this.urlMap[url]) === null || _a === void 0 ? void 0 : _a.entry) || [];
    };
    NetTimingObserver.prototype.remove = function (opts) {
        var _this = this;
        var url = opts.url, removeTag = opts.tag;
        if (removeTag) {
            // 如果传入了tag，按tag删除
            Object.keys(this.urlMap).forEach(function (url) {
                if (_this.urlMap[url].opts.tag === removeTag) {
                    delete _this.urlMap[url];
                }
            });
        }
        else {
            delete this.urlMap[url];
        }
    };
    NetTimingObserver.prototype.observerByOrigin = function () {
        this.originObserver = new PerformanceObserver(this.filterPerformanceEntrys);
        this.originObserver.observe({ entryTypes: ['resource'] });
    };
    NetTimingObserver.prototype.observerByInterval = function () {
        var _this = this;
        this.intervalObserverID = window.setInterval(function () {
            _this.filterPerformanceEntrys(performance);
        }, 1000);
    };
    return NetTimingObserver;
}());
/**
 * 收集跟视频加载相关的网络信息
 */
var NetTiming = /** @class */ (function () {
    function NetTiming() {
    }
    NetTiming.isSupported = function () {
        return 'function' === typeof performance.getEntries;
    };
    /**
     * 监测某个url的加载。
     */
    NetTiming.observer = function (instanceId, opts) {
        if (!this.isSupported() || !instanceId || !opts) {
            return;
        }
        var observer = this.observers[instanceId];
        if (!observer) {
            observer = new NetTimingObserver();
            this.observers[instanceId] = observer;
        }
        if (!observer.isRunning) {
            observer.start();
        }
        observer.push(opts);
    };
    NetTiming.unobserver = function (instanceId, opts) {
        var _a;
        if (!instanceId || !opts) {
            return;
        }
        (_a = this.observers[instanceId]) === null || _a === void 0 ? void 0 : _a.remove(opts);
    };
    /**
     * 获得某个url对应的一组监测数据（一个url可能存在多个网络数据，例如重复加载）
     */
    NetTiming.getEntry = function (instanceId, url) {
        var _a;
        if (!instanceId || !url) {
            return undefined;
        }
        return (_a = this.observers[instanceId]) === null || _a === void 0 ? void 0 : _a.getEntry(url);
    };
    NetTiming.disconnect = function (instanceId) {
        if (!instanceId) {
            return;
        }
        var observer = this.observers[instanceId];
        if (observer) {
            observer.destroy();
            delete this.observers[instanceId];
        }
    };
    NetTiming.observers = {};
    return NetTiming;
}());
function getVideoNetworkDetail(currentUrl, instanceId) {
    if (!currentUrl || currentUrl.indexOf('blob:') === 0) {
        // blob地址排除
        return 0;
    }
    var entry = NetTiming.getEntry(instanceId, currentUrl); // ts的PerformanceEntry定义不完整所以as any
    if (!entry) {
        return 0;
    }
    if (entry.responseStatus === 200 || entry.responseStatus === 206) {
        // 测试发现403等情况responseStatus还是0，很奇怪。所以仅用responseStatus判断成功的情况
        return MediaElementNativeDetail.NetworkOk;
    }
    if (0 < entry.responseStart && entry.responseStart <= entry.responseEnd && entry.transferSize > 0) {
        return MediaElementNativeDetail.NetworkResponsed;
    }
    if (0 < entry.connectStart && entry.connectStart <= entry.connectEnd) {
        return MediaElementNativeDetail.NetworkConnected;
    }
    if (navigator.onLine === false) {
        return MediaElementNativeDetail.NetworkOffline;
    }
    // 其他情况，例如地址错误（404，502等）或者 cdn未返回Timing-Allow-Origin的header
    return 0;
}

/**
  * 从各种内核的原始信息中解析出的标准的错误信息
  * @param errorData 各种内核的错误信息
  * @returns  标准化的错误信息
  */
function commonErrorParse(errorData) {
    if (errorData instanceof ErrorBase)
        return errorData;
    if (errorData) {
        var code = errorData.code, message = errorData.message;
        // 检查errorData的错误码是不是tp格式的
        if (/^(700)(\d{2})(\d{3})(\.(\d+))?$/g.test(code)) {
            return errorData;
        }
        return PlayerError.NativeError({
            code: 0 /* PlaybackErrorCode.UNKNOWN_ERR */,
            detail: code,
            message: message || compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
            debugMessage: message,
        });
    }
    return PlayerError.NativeError({
        code: 0 /* PlaybackErrorCode.UNKNOWN_ERR */,
        message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
    });
}
/**
 * 将 <video /> 标签的抛出的 Error 对象中的 code 状态码转换为对应错误对象
 * 这里因为要考虑 i18n 的可配置，因此不能直接写成枚举，而是要包在函数内以便外部覆盖
 */
function getVideoError(videoTag, instanceId) {
    var _a;
    var code = (_a = videoTag.error) === null || _a === void 0 ? void 0 : _a.code;
    var errorCodeMap = {
        1: 1 /* VideoElementNetworkErrorCode.MEDIA_ERR_ABORTED */,
        2: 2 /* VideoElementNetworkErrorCode.MEDIA_ERR_NETWORK */,
        3: 102 /* PlaybackErrorCode.MEDIA_ERR_DECODE */,
        4: 103 /* PlaybackErrorCode.MEDIA_ERR_SRC_NOT_SUPPORTED */,
    };
    var messageMap = {
        1: compile(i18nConfig.core.ERROR_MEDIA_ERR_ABORTED),
        2: compile(i18nConfig.core.ERROR_MEDIA_ERR_NETWORK),
        3: compile(i18nConfig.core.ERROR_MEDIA_ERR_DECODE),
        4: compile(i18nConfig.core.ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED),
    };
    var numberCode = +code;
    var message = messageMap[numberCode];
    if (MediaElementNetworkErrorCode.includes(numberCode)) {
        return PlayerError.NetworkError({
            code: errorCodeMap[numberCode],
            fatal: false,
            message: message,
        });
    }
    if (MediaElementPlaybackErrorCode.includes(numberCode)) {
        var detail = 0;
        if (!videoTool.isVideoCanPlayType('video/mp4; codecs="avc1.42E01E"')) {
            detail |= MediaElementNativeDetail.BaselineAVCNotSupported;
        }
        if (!videoTool.isHardwareAccelerated()) {
            detail |= MediaElementNativeDetail.HardwareAcceleratedOff;
        }
        if (numberCode === 4 && instanceId) {
            detail |= getVideoNetworkDetail(videoTag.src, instanceId);
        }
        return PlayerError.NativeError({
            code: errorCodeMap[numberCode],
            fatal: false,
            detail: detail,
            message: message,
        });
    }
}

var CheckHealth = /** @class */ (function (_super) {
    __extends(CheckHealth, _super);
    function CheckHealth(vn) {
        var _this = _super.call(this) || this;
        /** 记录当前状态的开始时间戳 */
        _this.stateStartTimeStamp = 0;
        /** 上一帧的播放时间点 */
        _this.preFramePlaytime = 0;
        /** 已经在playtime无变化时停滞的帧数 */
        _this.playtimeStalledFrameCount = 0;
        _this.videoNode = vn;
        _this.setVideoNodeEvts(true);
        return _this;
    }
    /**
     * 循环调用此函数来检查播放健康情况
     */
    CheckHealth.prototype.loop = function () {
        var curTimeStamp = +new Date();
        // 检查状态变化和检查时间变化的逻辑是分开的。实际上这两个逻辑是类似的，都是在某个状态下播放进度长时间停滞。但是分开的原因是在直播的场景下
        // 发现hls.js内核会停留在seeking状态并且不断seek，此时播放进度是不断变化的
        // 因此无法将每个状态的停滞逻辑基于播放进度停滞来编写，而是状态停滞用一个函数，播放进度停滞用一个函数。
        this.checkStateStalled(curTimeStamp);
        this.checkPlaytimeStalled();
    };
    CheckHealth.prototype.destroy = function () {
        this.setVideoNodeEvts(false);
        this.removeAllListeners();
        this.stateStartTimeStamp = 0;
        this.videoNode = null;
        this.videoNodeEvtMap = null;
        this.preFramePlaytime = 0;
        this.playtimeStalledFrameCount = 0;
    };
    CheckHealth.prototype.setVideoNodeEvts = function (value) {
        var _a;
        var _this = this;
        if (!this.videoNode) {
            return;
        }
        if (!this.videoNodeEvtMap) {
            this.videoNodeEvtMap = (_a = {},
                _a[VideoNodeEvent.STATE_CHANGE] = this.videoNodeStateChange.bind(this),
                _a);
        }
        Object.keys(this.videoNodeEvtMap).forEach(function (key) {
            if (value) {
                _this.videoNode.on(key, _this.videoNodeEvtMap[key]);
            }
            else {
                _this.videoNode.off(key, _this.videoNodeEvtMap[key]);
            }
        });
    };
    CheckHealth.prototype.videoNodeStateChange = function () {
        // 设置每个状态扭转时的起始时间戳
        this.stateStartTimeStamp = +new Date();
    };
    /**
     * 检查是否在某些状态下长时间停滞
     */
    CheckHealth.prototype.checkStateStalled = function (curTimeStamp) {
        var _a = this.videoNode, config = _a.config, state = _a.state;
        if ([VideoState.BUFFERING, VideoState.SEEKING].indexOf(state) === -1) {
            // 只检查这些状态的停滞
            return;
        }
        if (this.stateStartTimeStamp <= 0 || config.maxStateStalledTime <= 0) {
            return;
        }
        if (curTimeStamp - this.stateStartTimeStamp > config.maxStateStalledTime) {
            // 重试前把当前状态的开始时间戳重置。因为重试过程中状态可能无变化（例如一直是buffering状态），重置后可避免重复的重试。
            this.stateStartTimeStamp = 0;
            this.emit(HEALTH_EVTS.STATE_STUCK, {
                code: ErrorCode.STATE_STUCK,
                message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                state: state,
            });
        }
    };
    /**
   * 检查在playing状态下playtime是否长时间停滞
   */
    CheckHealth.prototype.checkPlaytimeStalled = function () {
        var _a = this.videoNode, config = _a.config, state = _a.state, videoElement = _a.videoElement;
        if (state !== VideoState.PLAYING
            || videoElement.duration <= 0
            // currentTime <= 0条件摘自老播放器，说明如下：
            // 某些浏览器在直播时不会发出timeupdate事件，不会更新currentTime的值，这里要避免为0的情况
            || videoElement.currentTime <= 0
            || config.maxPlaytimeStalledTime <= 0) {
            return;
        }
        if (this.preFramePlaytime > 0) {
            if (this.preFramePlaytime !== videoElement.currentTime) {
                // 只要播放进度有变化，就重置停滞的帧数
                this.playtimeStalledFrameCount = 0;
            }
            else {
                // 否则开始检查停滞的时长
                this.playtimeStalledFrameCount++;
                if (this.playtimeStalledFrameCount * 16.7 > config.maxPlaytimeStalledTime) {
                    this.playtimeStalledFrameCount = 0;
                    this.emit(HEALTH_EVTS.PLAYTIME_STUCK, {
                        code: ErrorCode.ORG_PLAY_STUCK_ERR,
                        message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                        state: state,
                    });
                }
            }
        }
        this.preFramePlaytime = videoElement.currentTime;
    };
    return CheckHealth;
}(EvtEmitter));
// eslint-disable-next-line @typescript-eslint/naming-convention
var HEALTH_EVTS;
(function (HEALTH_EVTS) {
    HEALTH_EVTS["STATE_STUCK"] = "state-stuck";
    HEALTH_EVTS["PLAYTIME_STUCK"] = "playtime-stuck";
})(HEALTH_EVTS || (HEALTH_EVTS = {}));

/**
 * VideoNode播放状态检查类
 */
var CheckVideoNodeStatus = /** @class */ (function () {
    function CheckVideoNodeStatus(vn) {
        this.videoNode = vn;
    }
    /**
   * 检查当前切换清晰度是否已经结束，以方便执行下一步骤
   * @param evtName 事件名，切换清晰度完成可能在多个事件中检查。
   * @returns 返回为空表示setLevel未结束，非空表示结束
   */
    CheckVideoNodeStatus.prototype.checkIsSetLevelOver = function (evtName, targetPlaytime) {
        var _a;
        if (evtName === void 0) { evtName = VideoEvts.playing; }
        if (targetPlaytime === void 0) { targetPlaytime = 0; }
        if (!((_a = this.videoNode) === null || _a === void 0 ? void 0 : _a.videoElement)) {
            throw new Error('Target VideoNode is null!');
        }
        if (!this.videoNode.getLevelSwitching()) {
            // 返回为空就是没有结束
            return null;
        }
        // 播放中检查
        var succInPlaying = false;
        // Seek后的检查
        var succInSeeked = false;
        // Timeupdate检查
        var succInTimeupdate = false;
        if (this.videoNode.config.type === PlayMode.LIVE) {
            // 直播开播以后就直接判断切换清晰度成功，并且没有seek的情况
            succInPlaying = evtName === VideoEvts.playing;
            succInTimeupdate = evtName === VideoEvts.timeupdate;
        }
        else {
            var isMFSupport = videoTool.supportMediaFragmentsURISpec(this.videoNode.config.enableMediaFragmentsURI);
            // 支持#t的时候切换清晰度是直接在url带上了目标位置，开播即到达目标播放位置
            succInPlaying = evtName === VideoEvts.playing && isMFSupport;
            // 不支持#t标准的浏览器环境下，切换到下一个清晰度了还需要调用seek操作才能到达播放目标位置，因此在seeked状态检测
            succInSeeked = evtName === VideoEvts.seeked && !isMFSupport;
            // timeupdate中是兜底的检测，下一个清晰度的时间超过了容忍值0.3S切换时记录的时间则切换成功
            var toleranceMinGap = 0.3;
            var toleranceGap = this.videoNode.videoElement.currentTime - targetPlaytime >= toleranceMinGap;
            succInTimeupdate = evtName === VideoEvts.timeupdate && toleranceGap;
        }
        if (succInPlaying || succInSeeked || succInTimeupdate) {
            // 只要其中一个为true，就返回非空表示结束
            return {
                succInPlaying: succInPlaying,
                succInSeeked: succInSeeked,
                succInTimeupdate: succInTimeupdate,
            };
        }
        // 返回为空就是没有结束
        return null;
    };
    /**
     * 检查当前videonode是否可以切换清晰度
     * @returns {canSetLevel:boolean,message:string} canSetLevel表示是否能切换，message表示具体信息描述和不能切换原因
     */
    CheckVideoNodeStatus.prototype.checkCanSetLevel = function () {
        if (!this.videoNode) {
            return {
                canSetLevel: false,
                message: 'videoNode is null',
            };
        }
        if (!this.videoNode.played) {
            // 如果根本没能起播，是无法切换清晰度的
            return {
                canSetLevel: false,
                message: 'setLevel(), play is not triggered.',
            };
        }
        if (this.videoNode.getLevelSwitching()) {
            // 切换清晰度正在进行中，需要继续等待
            return {
                canSetLevel: false,
                message: 'setLevel(), in progress.',
            };
        }
        if (!this.videoNode.currentVideoInfo || this.videoNode.currentVideoInfo.playtime <= 0) {
            // 如果currentVideoInfo为空，也暂时无法切换清晰度
            return {
                canSetLevel: false,
                message: 'setLevel(), setLevel can\'t start.',
            };
        }
        if (this.videoNode.config.type === PlayMode.VOD
            && this.videoNode.currentVideoInfo.playtime + 1 >= this.videoNode.currentVideoInfo.duration) {
            // 点播下如果播放接近结束（一秒内），可以认为切换清晰度是无意义的
            return {
                canSetLevel: false,
                message: 'setLevel(), video is about to end.',
            };
        }
        return {
            canSetLevel: true,
            message: 'setLevel(), can set level now',
        };
    };
    /**
     * 检查当前video是否能seek,在调用seek前检查
     * @param seekOpts seek相关信息
     * @returns {canSeek:boolean,message:string} canSeek表示是否能seek，message表示具体信息描述和不能seek原因
     */
    CheckVideoNodeStatus.prototype.checkCanSeek = function (seekOpts) {
        var _a;
        if (!((_a = this.videoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)) {
            // 如果vn或者vn.currentVideoInfo为空，无法Seek
            return {
                canSeek: false,
                message: 'seek(), because videonode or videoInfo is null',
            };
        }
        if (this.videoNode.videoElement.duration <= 0) {
            // 如果video元素duration小于等于0，不能seek。在MSE上会有拼接导致duration产生变化，所以没有使用currentVideoInfo
            return {
                canSeek: false,
                message: 'seek(), cannot seek when the duration is 0',
            };
        }
        var _b = seekOpts || {}, _c = _b.seektime, seektime = _c === void 0 ? NaN : _c, _d = _b.userActivation, userActivation = _d === void 0 ? false : _d, _e = _b.setLevelMode, setLevelMode = _e === void 0 ? SetLevelMode.HARD : _e;
        if (Number.isNaN(seektime)) {
            // 如果没有传入seektime不，无法seek
            return {
                canSeek: false,
                message: 'target time is NaN',
            };
        }
        if (seektime - this.videoNode.currentVideoInfo.duration >= 1) {
            // seek比duration还多出1S，也不能seek
            // 为什么是1S？是因为以下原因，需要做保护性矫正，check执行后都会减去1S保证不出现上面问题：
            // 1. safari/x5下可能出现直接seek到视频的最结尾（seek时间等于视频时长）后，video不发出end事件出来，所以检测如果这种情况，把time值回退1s
            // 2. chrome环境seek到最最后面，可能会卡死在seeking状态
            return {
                canSeek: false,
                message: "seek(), return because too large time, uid=".concat(this.videoNode.currentVideoInfo.uid, "/idx=").concat(this.videoNode.idx, "/time=").concat(seektime)
                    + "/duration=".concat(this.videoNode.currentVideoInfo.duration),
            };
        }
        if (typeof setLevelMode !== 'undefined'
            && setLevelMode !== SetLevelMode.SMOOTH
            && this.videoNode.getLevelSwitching()
            && userActivation) {
            // 非平滑切换时，“外部”不能seek（内部是可以seek的，例如某些浏览器切清晰度的时候，下一个清晰度需要seek到目标时间点）。
            // 因为加载下一个清晰度加了#t参数，如果当前清晰度进行seek操作，那么下一个清晰度加载ok以后跟上一个清晰度seek后的时间就无法对齐
            return {
                canSeek: false,
                message: 'seek(), cannot seek when hard/soft level switching',
            };
        }
        return {
            canSeek: true,
            message: 'seek(), can seek now',
        };
    };
    /**
     * 检查是否能设置音轨
     * @param audioTrackOpts 音轨相关信息
     * @returns {canSetAudioTrack:boolean,message:string} canSetAudioTrack表示是否能设置音轨，message表示具体信息描述和不能设置原因
     */
    CheckVideoNodeStatus.prototype.checkCanSetAudioTrack = function (audioTrackDefer) {
        if (audioTrackDefer) {
            // 当前正在切换中，返回不能切换
            return {
                canSetAudioTrack: false,
                message: 'setAudioTrack(), in progress',
            };
        }
        if (!this.videoNode) {
            // 如果vn为空，无法设置音轨
            return {
                canSetAudioTrack: false,
                message: 'setAudioTrack(), because videonode is null',
            };
        }
        if (!this.videoNode.hasAltAudio) {
            // 如果不存在可以切换的音轨，返回不能切换
            return {
                canSetAudioTrack: false,
                message: 'setAudioTrack(), current content does not contain alternative audio track',
            };
        }
        if (!this.videoNode.played) {
            // 如果vn并没有起播，无法切换音轨
            return {
                canSetAudioTrack: false,
                message: 'setAudioTrack(), can only be invoked after content plays',
            };
        }
        return {
            canSetAudioTrack: true,
            message: 'setAudioTrack(), can set audio track now',
        };
    };
    /** 销毁 */
    CheckVideoNodeStatus.prototype.destroy = function () {
        this.videoNode = null;
    };
    return CheckVideoNodeStatus;
}());

/**
 * 提供给kernel往外派发自定义事件，例如hls内核派发跟thls.js相关的事件出去。
 */
var kernelEvtBus = new EvtEmitter();
/**
 * 预加载过程中，内核派发给播放器上层的事件对象
 */
var preloadEvtBus = new EvtEmitter();

/**
 * 直播延迟控制器模块，具体的延迟计算方式和控制策略由callback处理
 *
 * @export
 * @class LatencyController
 * @typedef {LatencyController}
 */
var LatencyController = /** @class */ (function () {
    function LatencyController(media, config, onLatencyExceeded, onLatencyDropped, latencyCalculationMethod) {
        var _this = this;
        this.onLatencyExceeded = function () { };
        this.onLatencyDropped = function () { };
        this.latencyCalculationMethod = defaultLatencyCalculationMethod;
        this.setupEvents = function () {
            _this.media.addEventListener('timeupdate', _this.onTimeUpdate);
        };
        this.onTimeUpdate = function () {
            var _a = _this.media, buffered = _a.buffered, currentTime = _a.currentTime, paused = _a.paused;
            if (paused)
                return;
            var latency = _this.latencyCalculationMethod(currentTime, buffered);
            if (latency < 0 || isNaN(latency))
                return;
            if (latency > _this.config.expectedLatency && _this.state !== 1 /* LatencyState.Exceeded */) {
                _this.onLatencyExceeded(currentTime, latency, _this.media);
                _this.state = 1 /* LatencyState.Exceeded */;
            }
            else if (latency <= _this.config.minLatency && _this.state !== 0 /* LatencyState.Normal */) {
                _this.onLatencyDropped(currentTime, latency, _this.media);
                _this.state = 0 /* LatencyState.Normal */;
            }
        };
        this.media = media;
        this.playerConfig = config;
        this.state = 0 /* LatencyState.Normal */;
        if (typeof onLatencyExceeded === 'function')
            this.onLatencyExceeded = onLatencyExceeded;
        if (typeof onLatencyDropped === 'function')
            this.onLatencyDropped = onLatencyDropped;
        if (typeof latencyCalculationMethod === 'function')
            this.latencyCalculationMethod = latencyCalculationMethod;
        this.setupEvents();
    }
    Object.defineProperty(LatencyController.prototype, "config", {
        get: function () {
            return __assign(__assign({}, defaultConfig), this.playerConfig.latencyConfig);
        },
        enumerable: false,
        configurable: true
    });
    LatencyController.prototype.destroy = function () {
        this.media.removeEventListener('timeupdate', this.onTimeUpdate);
        this.onLatencyExceeded = null;
        this.onLatencyDropped = null;
        this.latencyCalculationMethod = null;
    };
    return LatencyController;
}());
var defaultConfig = {
    expectedLatency: 5,
    minLatency: 2,
    syncSpeed: 1.75,
};
function defaultLatencyCalculationMethod(currentTime, buffered) {
    if (!(buffered.length > 0 && currentTime > 0))
        return -1;
    for (var i = 0; i < buffered.length; i++) {
        var start = buffered.start(i);
        var end = buffered.end(i);
        if (currentTime >= start && currentTime <= end) {
            return end - currentTime;
        }
    }
}

/**
 * 对外发送展示/隐藏Loading事件
 */
var Loading = /** @class */ (function () {
    /**
     * 构造函数需要传递事件发送对象
     * @param evtEmiter 事件发送对象
     */
    function Loading(evtEmiter) {
        this.delayTimeoutId = 0;
        this.evtEmiter = evtEmiter;
    }
    /**
     * 发送展示loading事件
     * @param delayShowTimeMS 延迟展示Loading时间，单位毫秒，0为立即展示
     */
    Loading.prototype.show = function (delayShowTimeMS) {
        var _this = this;
        if (delayShowTimeMS === void 0) { delayShowTimeMS = 0; }
        if (!this.evtEmiter) {
            return;
        }
        this.clearDelay();
        if (delayShowTimeMS === 0) {
            this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, { show: true });
            return;
        }
        this.delayTimeoutId = window.setTimeout(function () {
            _this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, { show: true });
        }, delayShowTimeMS);
    };
    /**
     * 隐藏loading事件，如果有延迟展示也会清除
     */
    Loading.prototype.hide = function () {
        if (!this.evtEmiter) {
            return;
        }
        this.clearDelay();
        this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, { show: false });
    };
    /**
     * 清除延迟展示的loading，外部在destroy时可以调用
     */
    Loading.prototype.clearDelay = function () {
        if (this.delayTimeoutId > 0) {
            window.clearTimeout(this.delayTimeoutId);
            this.delayTimeoutId = 0;
        }
    };
    return Loading;
}());

/**
 * IVideoElement 监控模块，用于获取视频播放性能数据
 * BaseVideoNode 将数据同步到 IVideoInfo.qualityInfo 字段中
 */
var PerformanceMonitor = /** @class */ (function () {
    function PerformanceMonitor(video) {
        this.video = video;
    }
    PerformanceMonitor.prototype.report = function () {
        var _a = videoTool.getVideoPlaybackQuality(this.video), totalVideoFrames = _a.totalVideoFrames, droppedVideoFrames = _a.droppedVideoFrames;
        var frameDroppedInPercentage = droppedVideoFrames / totalVideoFrames * 100;
        if (isNaN(frameDroppedInPercentage)) {
            frameDroppedInPercentage = -1;
        }
        return {
            droppedVideoFrames: droppedVideoFrames,
            totalVideoFrames: totalVideoFrames,
            frameDroppedInPercentage: frameDroppedInPercentage,
        };
    };
    return PerformanceMonitor;
}());

var _a$3;
/**
 * 当前状态的前置状态表，例如loadStart上一个状态表为[idle]
 */
var VALID_PREVIOUS_STATE_MAP = (_a$3 = {},
    _a$3[VideoState.LOAD_START] = [VideoState.IDLE],
    _a$3[VideoState.CANPLAY] = [VideoState.LOAD_START],
    _a$3[VideoState.PLAYING] = [VideoState.CANPLAY, VideoState.SEEKED, VideoState.PAUSE, VideoState.BUFFERING],
    _a$3[VideoState.BUFFERING] = [VideoState.PLAYING],
    _a$3[VideoState.PAUSE] = [VideoState.PLAYING, VideoState.BUFFERING],
    _a$3[VideoState.SEEKING] = [
        VideoState.CANPLAY, VideoState.PLAYING, VideoState.PAUSE, VideoState.BUFFERING, VideoState.SEEKING,
    ],
    _a$3[VideoState.SEEKED] = [VideoState.SEEKING],
    _a$3[VideoState.END] = [
        VideoState.LOAD_START,
        VideoState.CANPLAY,
        VideoState.SEEKING,
        VideoState.SEEKED,
        VideoState.BUFFERING,
        VideoState.PLAYING,
        VideoState.PAUSE,
    ],
    _a$3[VideoState.IDLE] = [VideoState.END],
    _a$3);
/**
 * 切清晰度时的合法状态。例如无缝切换时，实际上是可以进行pause等操作的。
 */
var VALID_STATE_IN_LEVEL_SWITCHING = [
    VideoState.PAUSE,
    VideoState.PLAYING,
    VideoState.END,
    VideoState.IDLE,
];
var logMethodCall$7 = logMethodCallDecoratorCreator('StateMgr');
/**
 * VideoNode的状态机管理，根据video事件转换为播放状态机。[状态图参考](document/state.png)
 */
var StateMgr = /** @class */ (function () {
    function StateMgr(vn) {
        var _a;
        this.videoEvtHandler = (_a = {},
            _a[VideoEvts.canplay] = this.onCanplayEvt.bind(this),
            _a[VideoEvts.playing] = this.setPlaying.bind(this),
            _a[VideoEvts.waiting] = this.setWaiting.bind(this),
            _a[VideoEvts.pause] = this.onPauseEvt.bind(this),
            _a[VideoEvts.seeking] = this.onSeekingEvt.bind(this),
            _a[VideoEvts.seeked] = this.onSeekedEvt.bind(this),
            _a);
        this.videoNode = vn;
        this.logger = new Logger(vn.config.instanceId, 'StateMgr');
    }
    StateMgr.prototype.destroy = function () {
        this.videoNode = null;
    };
    StateMgr.prototype.validCallState = function (tarState) {
        var _a;
        return (_a = VALID_PREVIOUS_STATE_MAP[tarState]) === null || _a === void 0 ? void 0 : _a.includes(this.videoNode.state);
    };
    StateMgr.prototype.setEnded = function () {
        this.setVideoNodeState(VideoState.END);
        // end状态以后紧跟idle状态（历史原因导致这两个状态现在没有什么区别，但需要兼容老的调用方）
        this.setVideoNodeState(VideoState.IDLE);
    };
    StateMgr.prototype.setLoadStart = function () {
        this.setVideoNodeState(VideoState.LOAD_START);
    };
    StateMgr.prototype.setCanplay = function () {
        this.setVideoNodeState(VideoState.CANPLAY);
    };
    StateMgr.prototype.setWaiting = function () {
        this.setVideoNodeState(VideoState.BUFFERING);
    };
    StateMgr.prototype.setPlaying = function () {
        this.setVideoNodeState(VideoState.PLAYING);
    };
    StateMgr.prototype.onSetLevelOver = function () {
        if (this.videoNode.state === VideoState.PAUSE) {
            // 在暂停状态切换清晰度，切换成功以后是播放状态，因此需要修改为playing状态
            this.setVideoNodeState(VideoState.PLAYING);
        }
    };
    /**
     * 收到video标签事件以后进行处理
     * @param evtName video标签事件名
     */
    StateMgr.prototype.receiveVideoEvt = function (evtName) {
        var _a, _b;
        (_b = (_a = this.videoEvtHandler)[evtName]) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    /**
     * 设置VideoNode的状态，此状态是排除非法状态、兼容性处理以后完全处理好的状态。
     * @param state 状态名
     */
    StateMgr.prototype.setVideoNodeState = function (state) {
        if (this.videoNode.getLevelSwitching() && !VALID_STATE_IN_LEVEL_SWITCHING.includes(state)) {
            // 切换清晰度时过滤一部分状态
            this.logger.log("can not set state 2 ".concat(state, " when level switching"));
            return;
        }
        if (!VALID_PREVIOUS_STATE_MAP[state].includes(this.videoNode.state)) {
            // 上一个状态必须符合前置状态表
            this.logger.log("can not set state from ".concat(this.videoNode.state, " to ").concat(state));
            return;
        }
        this.videoNode.state = state;
    };
    StateMgr.prototype.onCanplayEvt = function () {
        // ios的waiting以后是canplay和canplaythrough（没有playing事件）这里需要判断以后额外加一个事件。
        // 另外发现safari播放直播时，从静音到恢复音量，video的事件变化为playing->waiting->canplay，所以会丢失playing状态。
        var applePlat = uaTool.os.ios || uaTool.browser.safari;
        if (applePlat && this.isVideoElementPlaying() && this.videoNode.state === VideoState.BUFFERING) {
            this.setVideoNodeState(VideoState.PLAYING);
        }
        else {
            this.setVideoNodeState(VideoState.CANPLAY);
        }
    };
    StateMgr.prototype.onPauseEvt = function () {
        this.setVideoNodeState(VideoState.PAUSE);
    };
    StateMgr.prototype.onSeekingEvt = function () {
        this.setVideoNodeState(VideoState.SEEKING);
    };
    StateMgr.prototype.onSeekedEvt = function () {
        this.setVideoNodeState(VideoState.SEEKED);
        var applePlat = uaTool.os.ios || uaTool.browser.safari;
        if (applePlat && this.isVideoElementPlaying()) {
            // 播放中seek，ios的seeked事件以后不是playing状态。这里需要额外增加playing状态
            this.setVideoNodeState(VideoState.PLAYING);
        }
    };
    /**
     * video标签是否在播放状态
     */
    StateMgr.prototype.isVideoElementPlaying = function () {
        return !this.videoNode.videoElement.paused && !this.videoNode.videoElement.ended;
    };
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "destroy", null);
    __decorate([
        logMethodCall$7
        /**
         * 校验调用接口时的状态是否正确
         */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "validCallState", null);
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "setEnded", null);
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "setLoadStart", null);
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "setCanplay", null);
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "setWaiting", null);
    __decorate([
        logMethodCall$7,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StateMgr.prototype, "setPlaying", null);
    return StateMgr;
}());

/** 引用方式枚举 */
var VideoFillType;
(function (VideoFillType) {
    VideoFillType["COVER"] = "cover";
    VideoFillType["CONTAIN"] = "contain";
})(VideoFillType || (VideoFillType = {}));
/**
 * Video元素reszie类，添加到Observer后会自动根据容器尺寸调整
 */
var VideoResizeAutoFill = /** @class */ (function () {
    function VideoResizeAutoFill(videoElement, minFillBlackBorder) {
        if (minFillBlackBorder === void 0) { minFillBlackBorder = 10; }
        /** 默认最小自动黑边范围，默认10像素 */
        this.minFillBlackBorder = 10;
        this.videoElement = videoElement;
        this.minFillBlackBorder = minFillBlackBorder;
        this.addToObserver();
    }
    /**
    * video标签默认样式object-fit: contain，这样高宽比不匹配时候，会被添加黑边。
    * 该方法用于当视频显示尺寸和播放器尺寸有很小的误差时候（例如出现了10px以下的黑边），那就直接铺满video画面(object-fit: cover)避免黑边
    * 的产生，这种情况下人眼看不出比例的实际变化
    * 在视频原始尺寸发生变化和video元素尺寸发生变化两种情况下，需要调用此函数检查。
    */
    VideoResizeAutoFill.prototype.resizeAutoFill = function () {
        if (!(this.videoElement instanceof HTMLVideoElement)) {
            // TODO：265暂时没有方案处理小黑边
            return;
        }
        if (this.minFillBlackBorder <= 0) {
            // 如果没有设置最小适配黑边，就无需计算，默认即可
            return;
        }
        if (this.videoElement.videoWidth === 0 || this.videoElement.videoHeight === 0) {
            // 在多video模式下，video元素宽高是0，继续往下计算是没有意义的
            return;
        }
        var videoElementSize = domTool.getDomSize(this.videoElement);
        var videoElementWidth = videoElementSize.width, videoElementHeight = videoElementSize.height;
        // 这是假设为contain模式，算出来的画面宽度
        var picWidth = this.videoElement.videoWidth * (videoElementHeight / this.videoElement.videoHeight);
        // 这是假设为contain模式，算出来的画面高度
        var picHeight = this.videoElement.videoHeight * (videoElementWidth / this.videoElement.videoWidth);
        if (picWidth < videoElementWidth && picWidth >= videoElementWidth - this.minFillBlackBorder) {
            // 画面宽度小于容器宽度左右出现了黑边，并且小于阀值
            videoTool.setElementFitType(this.videoElement, VideoFillType.COVER);
        }
        else if (picHeight < videoElementHeight && picHeight >= videoElementHeight - this.minFillBlackBorder) {
            // 画面高度小于容器高度上下出现了黑边，并且小于阀值
            videoTool.setElementFitType(this.videoElement, VideoFillType.COVER);
        }
        else {
            // 容忍黑边
            videoTool.setElementFitType(this.videoElement, VideoFillType.CONTAIN);
        }
    };
    /**
     * 销毁，并停止监听video元素
     */
    VideoResizeAutoFill.prototype.destroy = function () {
        if (!this.videoElement || !(this.videoElement instanceof HTMLVideoElement)) {
            // 在非video播放模式下，不能通过这个Observer调整尺寸
            return;
        }
        if (!this.videoResizeObserver) {
            return;
        }
        this.videoResizeObserver.disconnect();
        this.videoResizeObserver.unobserve(this.videoElement);
        this.videoResizeObserver = null;
        this.videoElement = null;
    };
    /**
     * 添加到Observer做自动容器适应
     */
    VideoResizeAutoFill.prototype.addToObserver = function () {
        var _this = this;
        if (!this.videoElement) {
            return;
        }
        if (!(this.videoElement instanceof HTMLVideoElement)) {
            // 在非video播放模式下，不能通过这个Observer调整尺寸
            return;
        }
        this.videoResizeObserver = new ResizeObserver(function () {
            _this.resizeAutoFill();
        });
        this.videoResizeObserver.observe(this.videoElement);
    };
    return VideoResizeAutoFill;
}());

var _a$2;
/**
   * 返回当前环境是否支持 audioControl
   * @returns 是否支持 audioControl
   */
function isEnvSupport() {
    if (!window.AudioContext && !window.webkitAudioContext) {
        return false;
    }
    // safari 不支持 WebAudio 音效
    if (uaTool.browser.safari) {
        return false;
    }
    return true;
}
/** 根据 effectName 查找对应的 AudioPreCfg */
function getPreCfgByName(effectName, cfgList) {
    var cpsCfg = cfgList.find(function (preCfg) { return preCfg.name === effectName; });
    return cpsCfg;
}
/**
 * 分贝到 gainNode 值转换
 * @param db 分贝值
 * @returns gainNode 的对应增益值
 */
function dbToGainValue(db) {
    return Math.pow(10, (db / DB_CONSTANT));
}
/** 分贝转换常量 */
var DB_CONSTANT = 20;
/** 音频效果名，用于指定音频效果 */
var AudioEffectName;
(function (AudioEffectName) {
    /** 默认无附加效果 */
    AudioEffectName["DEFAULT"] = "default";
    /** 空间环绕立体声 */
    AudioEffectName["SPATIAL_STEREO"] = "spatial_stereo";
    /** 重低音 */
    AudioEffectName["BASE_BOOSTER"] = "base_booster";
    /** 清澈人声 */
    AudioEffectName["VOCAL_BOOSTER"] = "vocal_booster";
    /** 弱化人声 */
    AudioEffectName["VOCAL_WEAK"] = "vocal_weak";
    /* 流行 */
    AudioEffectName["POP"] = "pop";
    /** 古典 */
    AudioEffectName["CLASSICAL"] = "classcal";
    /** 电子音乐 */
    AudioEffectName["ELECTRONIC"] = "electronic";
    /** 吉他 */
    AudioEffectName["GUITAR"] = "guitar";
    /** 嘻哈 */
    AudioEffectName["HIPHOP"] = "hiphop";
    /** 爵士 */
    AudioEffectName["JAZZ"] = "jazz";
    /** R&B */
    AudioEffectName["RNB"] = "rnb";
    /** 摇滚 */
    AudioEffectName["ROCK_N_ROLL"] = "rocknroll";
    /** 音乐厅模式 */
    AudioEffectName["CONCERT_HALL"] = "concert_hall";
    /** 演唱会现场 */
    AudioEffectName["LIVE"] = "live";
    /** 客厅 */
    AudioEffectName["LIVING_ROOM"] = "living_room";
    /** 听筒 */
    AudioEffectName["RECEIVER"] = "receiver";
    /** 震音 */
    AudioEffectName["TREMOLO"] = "tremolo";
    /** 和声 */
    AudioEffectName["CHORUS"] = "chorus";
})(AudioEffectName || (AudioEffectName = {}));
/** 枚举 AudioContext 状态 */
var AudioContextState;
(function (AudioContextState) {
    // 运行中
    AudioContextState["RUNNING"] = "running";
    // 暂停
    AudioContextState["SUSPENDED"] = "suspended";
    // 关闭
    AudioContextState["CLOSED"] = "closed";
})(AudioContextState || (AudioContextState = {}));
/** 滤波器的过滤方式类型参数，相关文档非常专业，这里用最简单的方式描述一下 */
var BiquadFilterType;
(function (BiquadFilterType) {
    /** 默认值，允许低于该频率的信号通过，高频的则过滤掉 */
    BiquadFilterType["LOWPASS"] = "lowpass";
    /** 高频通过，低频过滤 */
    BiquadFilterType["HIGHPASS"] = "highpass";
    /**
      * bandpass 带通是一个允许特定频段的波通过同时屏蔽其他频段
      * 允许频率有个公差( tolerance ), 通过 Q（品质因素）来指定，Q值越大，频点附近宽度越窄，影响的频率区域也就越少
      */
    BiquadFilterType["BANDPASS"] = "bandpass";
    /** 低频不够 就补偿低频 */
    BiquadFilterType["LOWSHELF"] = "lowshelf";
    /** 高频不够 就补偿高频  */
    BiquadFilterType["HIGHSHELF"] = "highshelf";
    /** 峰值滤波 */
    BiquadFilterType["PEAKING"] = "peaking";
})(BiquadFilterType || (BiquadFilterType = {}));
/** 音频效果中文名，用于展示内容 */
var AUDIO_EFFECT_CNNAME = (_a$2 = {},
    _a$2[AudioEffectName.DEFAULT] = i18nConfig.core.INFO_AUDIO_EFFECT_DEFAULT,
    _a$2[AudioEffectName.SPATIAL_STEREO] = i18nConfig.core.INFO_AUDIO_EFFECT_SPATIAL_STEREO,
    _a$2[AudioEffectName.BASE_BOOSTER] = i18nConfig.core.INFO_AUDIO_EFFECT_BASE_BOOSTER,
    _a$2[AudioEffectName.VOCAL_BOOSTER] = i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_BOOSTER,
    _a$2[AudioEffectName.VOCAL_WEAK] = i18nConfig.core.INFO_AUDIO_EFFECT_VOCAL_WEAK,
    _a$2[AudioEffectName.POP] = i18nConfig.core.INFO_AUDIO_EFFECT_POP,
    _a$2[AudioEffectName.CLASSICAL] = i18nConfig.core.INFO_AUDIO_EFFECT_CLASSICAL,
    _a$2[AudioEffectName.ELECTRONIC] = i18nConfig.core.INFO_AUDIO_EFFECT_ELECTRONIC,
    _a$2[AudioEffectName.GUITAR] = i18nConfig.core.INFO_AUDIO_EFFECT_GUITAR,
    _a$2[AudioEffectName.HIPHOP] = i18nConfig.core.INFO_AUDIO_EFFECT_HIPHOP,
    _a$2[AudioEffectName.JAZZ] = i18nConfig.core.INFO_AUDIO_EFFECT_JAZZ,
    _a$2[AudioEffectName.RNB] = i18nConfig.core.INFO_AUDIO_EFFECT_RNB,
    _a$2[AudioEffectName.ROCK_N_ROLL] = i18nConfig.core.INFO_AUDIO_EFFECT_ROCK_N_ROLL,
    _a$2[AudioEffectName.CONCERT_HALL] = i18nConfig.core.INFO_AUDIO_EFFECT_CONCERT_HALL,
    _a$2[AudioEffectName.LIVE] = i18nConfig.core.INFO_AUDIO_EFFECT_LIVE,
    _a$2[AudioEffectName.LIVING_ROOM] = i18nConfig.core.INFO_AUDIO_EFFECT_LIVING_ROOM,
    _a$2[AudioEffectName.RECEIVER] = i18nConfig.core.INFO_AUDIO_EFFECT_RECEIVER,
    _a$2[AudioEffectName.TREMOLO] = i18nConfig.core.INFO_AUDIO_EFFECT_TREMOLO,
    _a$2[AudioEffectName.CHORUS] = i18nConfig.core.INFO_AUDIO_EFFECT_CHORUS,
    _a$2);
/** 用于默认外显列表，根据产品策略控制覆盖 */
var AUDIO_EFFECT_DISPLAYLIST = [
    AudioEffectName.SPATIAL_STEREO,
    AudioEffectName.VOCAL_BOOSTER,
    AudioEffectName.BASE_BOOSTER,
    AudioEffectName.CLASSICAL,
    AudioEffectName.ROCK_N_ROLL,
    AudioEffectName.LIVE,
    AudioEffectName.CHORUS,
];
/**
 * 用于存储 media 和 sourceNode 间的映射关系
 * 原因是在 Chrome 下一旦 audioSource 接管了 video 元素的声音，仅能使用该 audioSoure 才能播放出声音，否则出现无法播放卡住的问题
 */
var audioSourceNodes = new WeakMap();
/**
 * 关闭 media 对应的 AudioContext，注意仅在 media 对象销毁时使用
 */
function closeAudioSourceNode(media) {
    if (!(audioSourceNodes === null || audioSourceNodes === void 0 ? void 0 : audioSourceNodes.has(media))) {
        return;
    }
    // 关闭对应的 AudioContext
    var audioSource = audioSourceNodes.get(media);
    var audioCtx = audioSource.context;
    if (audioCtx && audioCtx.state !== AudioContextState.CLOSED) {
        audioCtx.close();
    }
    // 最后删除 media 和 AudioContext 的关系
    audioSourceNodes.delete(media);
}

var BaseAudioEffector = /** @class */ (function () {
    function BaseAudioEffector(audioCtx, logger) {
        this.using = false;
        // 增益百分比，允许大于 1，由子类自行扩展实现
        this.currentGainValue = 0;
        this.audioCtx = audioCtx;
        this.logger = logger;
    }
    /**
     * 传入外部音效节点链接到当前节点，并且返回当前节点
     * @param node
     */
    BaseAudioEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        return node;
    };
    /**
     * 断开音效节点，消除该效果
     */
    BaseAudioEffector.prototype.disconnect = function () {
        var _a;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    /**
     * 销毁该音效节点
     */
    BaseAudioEffector.prototype.destroy = function () {
        var _a;
        this.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " destroy()"));
        this.logger = null;
    };
    /**
     * 获取当前效果器名称
     */
    BaseAudioEffector.prototype.getEffectorName = function () {
        return BaseAudioEffector.effectorName;
    };
    /**
     * 设置预制音效参数
     */
    BaseAudioEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName) {
            return;
        }
        this.currPreCfgName = effectName;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("BaseAudioEffector setPreConfigName(), currPreCfgName=".concat(effectName));
    };
    /**
     * 获取预制音效参数
     */
    BaseAudioEffector.prototype.getPreConfigName = function () {
        return this.currPreCfgName;
    };
    /**
    * 获取增益百分比
    */
    BaseAudioEffector.prototype.getGainValue = function () {
        return this.currentGainValue;
    };
    /**
    * 设置增益百分比
    */
    BaseAudioEffector.prototype.setGainValue = function (value) {
        this.currentGainValue = value;
    };
    /**
     * 当音效需要调用播放主 Loop 时，例如立体音灯，可以调用该方法
     */
    BaseAudioEffector.prototype.updateLoop = function () {
        // 继承实现
    };
    BaseAudioEffector.effectorName = 'BaseAudioEffector';
    return BaseAudioEffector;
}());

/**
 * 多节点效果器，统一创建输入输出节点
 */
var MultiNodesEffector = /** @class */ (function (_super) {
    __extends(MultiNodesEffector, _super);
    function MultiNodesEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        _this.inputNode = audioCtx.createGain();
        _this.outputNode = audioCtx.createGain();
        return _this;
    }
    MultiNodesEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        // 连接头尾节点
        node.connect(this.inputNode);
        // 连接内部节点
        this.connectInnerNodes();
        return this.outputNode;
    };
    MultiNodesEffector.prototype.disconnect = function () {
        var _a;
        this.disconnectInnerNodes();
        if (this.outputNode) {
            this.outputNode.disconnect();
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    MultiNodesEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.inputNode = null;
        this.outputNode = null;
    };
    MultiNodesEffector.prototype.getEffectorName = function () {
        return MultiNodesEffector.effectorName;
    };
    /** 连接内部效果节点，继承实现 */
    MultiNodesEffector.prototype.connectInnerNodes = function () {
        // 继承实现
    };
    /** 断开首尾效果节点，其他节点继承实现 */
    MultiNodesEffector.prototype.disconnectInnerNodes = function () {
        if (this.inputNode) {
            this.inputNode.disconnect();
        }
    };
    MultiNodesEffector.effectorName = 'MultiNodes';
    return MultiNodesEffector;
}(BaseAudioEffector));

/**
 * 和声处理单声道处理器，支持设置feedback(反馈)、feedforward（前馈）延迟和声音增益强度
 */
var ChorusSingleChannel = /** @class */ (function () {
    function ChorusSingleChannel(audioCtx, logger) {
        this.isConnected = false;
        this.gainIntensity = 0;
        // feedback/feedford 增益系数
        this.intensityCoefficient = 0.3;
        this.gainNode = audioCtx.createGain();
        this.feedbackGainNode = audioCtx.createGain();
        this.feedforwardGainNode = audioCtx.createGain();
        this.blendGainNode = audioCtx.createGain();
        this.delayVibrato = audioCtx.createDelay();
        this.delayFixed = audioCtx.createDelay();
        this.logger = logger;
    }
    /**
     * 通过 spliterNode\mergerNode 连接音路处理链接
     * @param channelSplitterNode splitterNode 引用
     * @param channelMergerNode mergerNode 引用
     * @param channelIndex 声道序号
     */
    ChorusSingleChannel.prototype.connect = function (channelSplitterNode, channelMergerNode, channelIndex) {
        var _a, _b;
        if (channelIndex === void 0) { channelIndex = 0; }
        if (!channelSplitterNode || !channelMergerNode) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('channelSplitterNode or channelMergerNode is null');
            return false;
        }
        if (this.isConnected) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log('ChorusSingleChannel is already connected');
            return true;
        }
        this.channelSplitterNode = channelSplitterNode;
        this.channelMergerNode = channelMergerNode;
        this.connectInnerNodes(channelIndex);
        return true;
    };
    /**
     * 断开该单声道的音路链接
     */
    ChorusSingleChannel.prototype.disconnect = function () {
        var _a;
        if (!this.isConnected) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('ChorusSingleChannel is already disconnected');
            return true;
        }
        this.isConnected = false;
        this.channelSplitterNode.disconnect(this.gainNode);
        this.gainNode.disconnect(this.delayVibrato);
        this.gainNode.disconnect(this.delayFixed);
        this.delayVibrato.disconnect(this.feedforwardGainNode);
        this.delayVibrato.disconnect(this.channelMergerNode);
        this.delayFixed.disconnect(this.feedbackGainNode);
        this.feedbackGainNode.disconnect(this.gainNode);
        this.blendGainNode.disconnect(this.channelMergerNode);
        return true;
    };
    /**
     * 销毁
     */
    ChorusSingleChannel.prototype.destroy = function () {
        this.disconnect();
        this.logger = null;
        this.channelSplitterNode = null;
        this.channelMergerNode = null;
        this.gainNode = null;
        this.delayVibrato = null;
        this.delayFixed = null;
        this.feedbackGainNode = null;
        this.blendGainNode = null;
    };
    /**
     * 获取feedforward延迟时间对象，以方便外部连接
     */
    ChorusSingleChannel.prototype.getFeedForwardDelayTime = function () {
        var _a;
        return (_a = this.delayVibrato) === null || _a === void 0 ? void 0 : _a.delayTime;
    };
    /**
     * 设置 feedforward 延迟时间，单位秒
     */
    ChorusSingleChannel.prototype.setFeedForwardDelayTimeValue = function (value) {
        var _a;
        if (!this.isConnected) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('ChorusSingleChannel is already disconnected');
            return;
        }
        this.delayVibrato.delayTime.value = value;
    };
    /**
     * 获取 feedfback 延迟时间对象，以方便外部连接
     */
    ChorusSingleChannel.prototype.getFeedBackDelayTime = function () {
        var _a;
        return (_a = this.delayFixed) === null || _a === void 0 ? void 0 : _a.delayTime;
    };
    /**
     * 设置 feedfback 延迟时间，单位秒
     */
    ChorusSingleChannel.prototype.setFeedBackDelayTimeValue = function (value) {
        var _a;
        if (!this.isConnected) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('ChorusSingleChannel is already disconnected');
            return;
        }
        this.delayFixed.delayTime.value = value;
    };
    /**
     * 获取 feedback/feedforward 增益强度
     */
    ChorusSingleChannel.prototype.getGainIntensity = function () {
        return this.gainIntensity;
    };
    /**
     * 设置 feedback/feedforward 增益强度
     * 主要给混音、前馈、反馈节点声音增益赋值，这里通过系数常量模拟两者关系
     */
    ChorusSingleChannel.prototype.setGainIntensity = function (intensity) {
        this.gainIntensity = intensity;
        this.blendGainNode.gain.value = 1 - (intensity * this.intensityCoefficient);
        this.feedforwardGainNode.gain.value = (intensity * this.intensityCoefficient) + (1 - this.intensityCoefficient);
        this.feedbackGainNode.gain.value = intensity * (1 - this.intensityCoefficient);
    };
    /**
     * 内部处理节点连接，包括：feedward 和 feedback 处理链
     */
    ChorusSingleChannel.prototype.connectInnerNodes = function (channelIndex) {
        this.isConnected = true;
        this.channelSplitterNode.connect(this.gainNode, channelIndex, 0);
        this.gainNode.connect(this.delayVibrato);
        this.gainNode.connect(this.delayFixed);
        // feedforward 处理链：输入音频直接处理了颤音效果、增益衰减控制后，就提交给 channelMergerNode
        this.delayVibrato.connect(this.feedforwardGainNode);
        this.delayVibrato.connect(this.channelMergerNode, 0, channelIndex);
        // feedback 处理链：处理后的信号再回来去控制延迟和增益，会让声音听起来更平缓更音乐性
        this.delayFixed.connect(this.feedbackGainNode);
        this.feedbackGainNode.connect(this.gainNode);
        this.blendGainNode.connect(this.channelMergerNode, 0, channelIndex);
    };
    return ChorusSingleChannel;
}());

/**
 * 和声效果：实现原理是将声音分离到左右声道，然后各添加前馈和回馈效果，同步进行（有些许延迟）不同音阶的演唱，制造出和声的效果
 * 通过音调延伸制造出数个声音，并与原来的声音结合成新的声音效果。和声可让声音软化，但过多的Chorus也可能会让声音糊掉，因此只在左右声道添加效果
 */
var ChorusEffector = /** @class */ (function (_super) {
    __extends(ChorusEffector, _super);
    function ChorusEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 干湿混音 mix 系数，数值越大，背景和声越大
        _this.mix = 0.3;
        // 左右声道前馈\回馈延迟时间配置，设置些许不一致目的是能够让听觉上能听出多人效果
        // 单位秒，时间越大延迟越大
        _this.leftFeedbackDelayTime = 0.018;
        _this.leftFeedForwardDelayTime = 0.15;
        _this.rightFeedbackDelayTime = 0.02;
        _this.rightFeedForwardDelayTime = 0.2;
        _this.leftDethGain = 0.013;
        _this.rightDethGain = -0.017;
        // 默认 LFO 频率，暂时不需要外部传入，默认配置即可
        _this.lfoFrequency = 0.15;
        // 信号以正弦波形方式周期振荡
        _this.lfoType = 'sine';
        // 暂时只分开左右双声道做处理，5.1 貌似浏览器目前还不支持
        _this.channellCount = 2;
        _this.wetGainNode = audioCtx.createGain();
        _this.dryGainNode = audioCtx.createGain();
        _this.setDryWetMix(_this.mix);
        _this.channelSplitterNode = audioCtx.createChannelSplitter(_this.channellCount);
        _this.channelMergerNode = audioCtx.createChannelMerger(_this.channellCount);
        // 创建左右声道子节点，目的是创建左右声道的差异
        _this.leftChannelNode = new ChorusSingleChannel(audioCtx, logger);
        _this.rightChannelNode = new ChorusSingleChannel(audioCtx, logger);
        _this.channelNodes = [_this.leftChannelNode, _this.rightChannelNode];
        _this.leftDepth = audioCtx.createGain();
        _this.rightDepth = audioCtx.createGain();
        _this.lfoNode = audioCtx.createOscillator();
        _this.lfoNode.type = _this.lfoType;
        _this.lfoNode.frequency.value = _this.lfoFrequency;
        _this.lfoNodeRunning = false;
        return _this;
    }
    ChorusEffector.prototype.destroy = function () {
        // super.destroy 会调用 disconnect
        _super.prototype.destroy.call(this);
        if (this.lfoNode && this.lfoNodeRunning) {
            this.lfoNodeRunning = false;
            // destory 了就调用 OscillatorNode.stop
            this.lfoNode.stop();
        }
        this.lfoNode = null;
        this.wetGainNode = null;
        this.dryGainNode = null;
        if (this.channelNodes && this.channelNodes.length > 0) {
            this.channelNodes.forEach(function (channelNode) {
                channelNode.destroy();
            });
            this.channelNodes.length = 0;
        }
        this.channelNodes = null;
    };
    ChorusEffector.prototype.getEffectorName = function () {
        return ChorusEffector.effectorName;
    };
    /**
    * 重新建立节点连接，如果使用默认则头尾 input 链接 output 即可
    */
    ChorusEffector.prototype.connectInnerNodes = function () {
        this.disconnectInnerNodes();
        this.inputNode.connect(this.channelSplitterNode);
        this.inputNode.connect(this.dryGainNode);
        // 处理单声道分离后，分别处理音效链
        for (var i = 0; i < this.channelNodes.length; i++) {
            var channelNode = this.channelNodes[i];
            // 0 为左声道，1 为右声道
            channelNode.connect(this.channelSplitterNode, this.channelMergerNode, i);
        }
        this.channelMergerNode.connect(this.wetGainNode);
        this.dryGainNode.connect(this.outputNode);
        this.wetGainNode.connect(this.outputNode);
        // 振荡器连接
        this.lfoNode.connect(this.leftDepth);
        this.lfoNode.connect(this.rightDepth);
        // 左右声道前馈延迟
        this.leftDepth.connect(this.channelNodes[0].getFeedForwardDelayTime());
        this.rightDepth.connect(this.channelNodes[1].getFeedForwardDelayTime());
        this.leftDepth.gain.value = this.leftDethGain;
        this.rightDepth.gain.value = this.rightDethGain;
        // 振荡器启动
        if (!this.lfoNodeRunning) {
            this.lfoNodeRunning = true;
            this.lfoNode.start(0);
        }
        this.updateAllGainCfg();
    };
    ChorusEffector.prototype.disconnectInnerNodes = function () {
        _super.prototype.disconnectInnerNodes.call(this);
        this.inputNode.disconnect();
        this.channelNodes.forEach(function (channelNode) {
            channelNode.disconnect();
        });
        this.channelMergerNode.disconnect();
        this.dryGainNode.disconnect();
        this.wetGainNode.disconnect();
        // 断开连接后振荡器会自动暂停，如果只是断开连接无需调用 stop 方法
        // 原因是 WebAudio API 里设计 OscillatorNode.start 和 stop 只能调用一次，二次调用会报错
        this.lfoNode.disconnect();
        this.leftDepth.disconnect();
        this.rightDepth.disconnect();
    };
    /**
     * 设置预设增益配置，目前不需要外部传入，内部调配好即可
     * 给左右声道设置反馈和前馈延迟时间和增益大小
     */
    ChorusEffector.prototype.updateAllGainCfg = function () {
        this.leftChannelNode.setFeedBackDelayTimeValue(this.leftFeedbackDelayTime);
        this.leftChannelNode.setFeedForwardDelayTimeValue(this.leftFeedForwardDelayTime);
        // 设置左声道的反馈和前馈的增益强度大小，赋值 1 目的是经过反复实际调教后效果较好
        this.leftChannelNode.setGainIntensity(1);
        this.rightChannelNode.setFeedBackDelayTimeValue(this.rightFeedbackDelayTime);
        this.rightChannelNode.setFeedForwardDelayTimeValue(this.rightFeedForwardDelayTime);
        // 设置右声道反馈和前馈的增益强度大小，赋值 1 原因与左声道设置同理
        this.rightChannelNode.setGainIntensity(1);
    };
    /**
     * 设置干湿混音增益
     */
    ChorusEffector.prototype.setDryWetMix = function (mix) {
        if (!this.dryGainNode || !this.wetGainNode) {
            return;
        }
        var mixValue = Math.min(1, Math.max(0, mix));
        this.dryGainNode.gain.value = 1 - mixValue;
        this.wetGainNode.gain.value = mixValue;
    };
    ChorusEffector.effectorName = 'Chorus';
    return ChorusEffector;
}(MultiNodesEffector));

/**
 * 压缩器效果
 * 主要作用就是压缩音频的动态范围，让整个音乐都处于合理的音量范围
 */
var CompressorEffector = /** @class */ (function (_super) {
    __extends(CompressorEffector, _super);
    function CompressorEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        _this.compressor = audioCtx.createDynamicsCompressor();
        return _this;
    }
    CompressorEffector.prototype.connectBy = function (node) {
        if (!node || !this.compressor) {
            return null;
        }
        node.connect(this.compressor);
        this.setPreConfigName(AudioEffectName.DEFAULT);
        return this.compressor;
    };
    CompressorEffector.prototype.disconnect = function () {
        var _a;
        if (!this.compressor) {
            return;
        }
        this.compressor.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    CompressorEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.compressor = null;
    };
    CompressorEffector.prototype.getEffectorName = function () {
        return CompressorEffector.effectorName;
    };
    /**
     * 设置效果器预设值
     */
    CompressorEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName || !this.compressor) {
            return;
        }
        // 在controller里activeEffects方法加入对cpsEffector.using=false处理，就无需在此处专门处理默认音效
        this.currPreCfgName = effectName;
        this.compressor.attack.value = cpsPreCfg.attack;
        this.compressor.knee.value = cpsPreCfg.knee;
        this.compressor.ratio.value = cpsPreCfg.ratio;
        this.compressor.release.value = cpsPreCfg.release;
        this.compressor.threshold.value = cpsPreCfg.threshold;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("CompressorEffector setPreConfigName() effectName=".concat(effectName));
    };
    CompressorEffector.effectorName = 'Compressor';
    return CompressorEffector;
}(BaseAudioEffector));
/**
 * Compressor 音效预配置
 */
var cpsPreCfg = {
    attack: 0.003,
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24,
};

/**
 * 均衡器效果
 */
var EqualizerEffector = /** @class */ (function (_super) {
    __extends(EqualizerEffector, _super);
    function EqualizerEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 十段均衡器控制声音频率，根据查阅声音相关资料相关定义：
        // 31~62Hz 为超低频范围（鼓点、贝斯等），125~250Hz 为低频范围（弦乐）,250~500Hz 中低频（人声）
        // 500~1KHz 低中频（大部分乐器），1K~2KHz 中频（电吉他等），2K~4KHz 中高频（影响语音清晰度）
        // 4K~8KHz 高频（影响音色），8K~16KHz 超高频(人能听到的高频范围)
        _this.audioFrequency = [31, 62, 125, 250, 500, 1000, 2000, 4000, 8000, 16000];
        // 定义2个频率高低频临界值，以决定使用哪种滤波器
        _this.lowHz = 62;
        _this.highHz = 8000;
        // 峰值滤波的质量因素值
        _this.peakQuality = 0.8;
        // 以指数方式接近目标值的速率常量，数值越大该过渡越慢
        _this.gainTimeConstant = 0.02;
        _this.biquadFilterList = [];
        return _this;
    }
    EqualizerEffector.prototype.connectBy = function (node) {
        if (!node || !this.inputNode) {
            return null;
        }
        // 如果没有创建滤波器，就按当前值默认创建一组
        if (this.biquadFilterList.length === 0) {
            this.setPreConfigName(AudioEffectName.DEFAULT);
        }
        // 内部节点已经连接了，返回连接第一个滤波节点，返回最后一个即可
        node.connect(this.inputNode);
        return this.outputNode;
    };
    EqualizerEffector.prototype.disconnect = function () {
        var _a;
        if (!this.outputNode) {
            return;
        }
        // 断掉最后节点即可，内部连接无需断开
        this.outputNode.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    EqualizerEffector.prototype.destroy = function () {
        var _a;
        if (!this.inputNode) {
            return;
        }
        // 内外音效节点均需要断开
        this.inputNode.disconnect();
        this.outputNode.disconnect();
        this.inputNode = null;
        this.outputNode = null;
        if (this.biquadFilterList.length === 0) {
            return;
        }
        this.biquadFilterList.forEach(function (biquadFilter) {
            biquadFilter.disconnect();
        });
        this.biquadFilterList.splice(0, this.biquadFilterList.length);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " destroy()"));
        this.logger = null;
    };
    EqualizerEffector.prototype.getEffectorName = function () {
        return EqualizerEffector.effectorName;
    };
    /**
     * 设置滤波器预设值，内含滤波器创建逻辑
     */
    EqualizerEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName || !this.inputNode) {
            return;
        }
        this.currPreCfgName = effectName;
        var cfg = getPreCfgByName(effectName, EQ_PRECFG_LIST);
        if (!cfg) {
            return;
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("EqualizerEffector setPreConfigName() effectName=".concat(effectName));
        var lastBiquadFilter = this.inputNode;
        for (var i = 0; i < this.audioFrequency.length; i++) {
            var frequency = this.audioFrequency[i];
            var biquadFilter = void 0;
            // 如果频率和滤波器数组长度不一样说明需要继续创建
            if (this.biquadFilterList.length !== this.audioFrequency.length) {
                biquadFilter = this.audioCtx.createBiquadFilter();
                this.biquadFilterList.push(biquadFilter);
                if (lastBiquadFilter) {
                    lastBiquadFilter.connect(biquadFilter);
                }
                // 最后一个节点就连接 outputNode
                if (this.biquadFilterList.length === this.audioFrequency.length) {
                    biquadFilter.connect(this.outputNode);
                }
            }
            else {
                biquadFilter = this.biquadFilterList[i];
            }
            // 根据音频高低设置不同的滤波器参数
            if (frequency <= this.lowHz) {
                biquadFilter.type = BiquadFilterType.LOWSHELF;
            }
            else if (frequency >= this.highHz) {
                biquadFilter.type = BiquadFilterType.HIGHSHELF;
            }
            else {
                // 峰值滤波需要设置质量因素值
                biquadFilter.Q.value = this.peakQuality;
                biquadFilter.type = BiquadFilterType.PEAKING;
            }
            // 设置当前频率到滤波器
            biquadFilter.frequency.setValueAtTime(frequency, this.audioCtx.currentTime);
            // 设置对应频率滤波器的音量大小
            biquadFilter.gain.setTargetAtTime(cfg.eq[i], this.audioCtx.currentTime, this.gainTimeConstant);
            lastBiquadFilter = biquadFilter;
        }
    };
    EqualizerEffector.effectorName = 'Equalizer';
    return EqualizerEffector;
}(MultiNodesEffector));
/**
 * EQ 音效名称、中文名和预配置
 */
var EQ_PRECFG_LIST = [
    {
        name: AudioEffectName.DEFAULT,
        eq: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    }, {
        name: AudioEffectName.BASE_BOOSTER,
        eq: [6, 5, 5, 3, 1, 0, 0, 0, 0, 0],
    }, {
        name: AudioEffectName.VOCAL_BOOSTER,
        eq: [-2, -3, -3, 1, 4, 4, 3, 1, 0, -2],
    }, {
        name: AudioEffectName.VOCAL_WEAK,
        eq: [3, 2, 0, -1, -3, -3, -4, -3, -3, 2],
    }, {
        name: AudioEffectName.POP,
        eq: [-2, -1, 0, 2, 4, 4, 2, 0, -1, -2],
    }, {
        name: AudioEffectName.CLASSICAL,
        eq: [4.5, 4, 3, 2, -1, -1, 0, 2, 3, 4],
    }, {
        name: AudioEffectName.ELECTRONIC,
        eq: [5, 3, 1, 0, -2, 2, 0.5, 1, 4, 5],
    }, {
        name: AudioEffectName.GUITAR,
        eq: [-5, -3, -2, 2, -0.5, 0, 0, 2, 6, 0],
    }, {
        name: AudioEffectName.HIPHOP,
        eq: [5, 4, 1, 3, -1, -1, 1, -1, 2, 3],
    }, {
        name: AudioEffectName.JAZZ,
        eq: [4, 3, 1, 2, -2, -2, 0, 1, 3, 4],
    }, {
        name: AudioEffectName.RNB,
        eq: [3, 7, 6, 2, -3, -2, 2, 3, 3, 4],
    }, {
        name: AudioEffectName.ROCK_N_ROLL,
        eq: [5, 4, 3, 2, -1, -1, 1, 3, 4, 5],
    },
];

/**
 * 音效增益效果
 */
var GainEffector = /** @class */ (function (_super) {
    __extends(GainEffector, _super);
    function GainEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 最大音量增益 200%，对应值为 10 分贝
        _this.maxGainValue = 2;
        // 最小音量增益 0%，即不做任何增益，对应值为 0 分贝
        _this.minGainValue = 0;
        // 以指数方式接近目标值的速率常量，数值越大该过渡越慢
        _this.gainTimeConstant = 0.02;
        _this.gainNode = audioCtx.createGain();
        _this.currentGainValue = _this.minGainValue;
        return _this;
    }
    GainEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        node.connect(this.gainNode);
        return this.gainNode;
    };
    GainEffector.prototype.disconnect = function () {
        var _a;
        if (!this.gainNode) {
            return;
        }
        this.gainNode.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    GainEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.gainNode = null;
    };
    GainEffector.prototype.getEffectorName = function () {
        return GainEffector.effectorName;
    };
    /**
     * 设置增益百分比，范围[0,2]
     * 比如传入 0.5，意味在当前音量大小下增益 50%，最大增益到 100%
     * @param value 增益值
     */
    GainEffector.prototype.setGainValue = function (value) {
        var _a;
        if (!this.gainNode) {
            return;
        }
        // 先检查范围，确保在 min 和 maxGainValue 范围内，如果小于 minGainValue，就恢复无增益效果
        this.currentGainValue = Math.max(value, this.minGainValue);
        this.currentGainValue = Math.min(this.currentGainValue, this.maxGainValue);
        // 增益值到分贝转换计算
        var db = (this.currentGainValue - this.minGainValue) * 10;
        // 在给定时间以具有给定时间常数的速率开始以指数方式接近目标值
        this.gainNode.gain.setTargetAtTime(dbToGainValue(db), this.audioCtx.currentTime, this.gainTimeConstant);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("GainEffector setGainValue() value=".concat(value, ",db=").concat(db));
    };
    GainEffector.effectorName = 'Gain';
    return GainEffector;
}(BaseAudioEffector));

/**
 * 音效听筒效果
 */
var ReceiverEffector = /** @class */ (function (_super) {
    __extends(ReceiverEffector, _super);
    function ReceiverEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        _this.lowPassFrequency = 3000;
        _this.highPassFrequency = 500;
        _this.lowPassBqFilter = _this.createBqFilter(BiquadFilterType.LOWPASS, _this.lowPassFrequency);
        _this.highPassBqFilter = _this.createBqFilter(BiquadFilterType.HIGHPASS, _this.highPassFrequency);
        _this.lowPassBqFilter.connect(_this.highPassBqFilter);
        return _this;
    }
    ReceiverEffector.prototype.connectBy = function (node) {
        if (!node) {
            return null;
        }
        node.connect(this.lowPassBqFilter);
        return this.highPassBqFilter;
    };
    ReceiverEffector.prototype.disconnect = function () {
        var _a;
        if (!this.highPassBqFilter) {
            return;
        }
        this.highPassBqFilter.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    ReceiverEffector.prototype.destroy = function () {
        // super.destroy 会调用 disconnect
        _super.prototype.destroy.call(this);
        this.lowPassBqFilter.disconnect();
        this.lowPassBqFilter = null;
        this.highPassBqFilter = null;
    };
    ReceiverEffector.prototype.getEffectorName = function () {
        return ReceiverEffector.effectorName;
    };
    /** 创建一个 BIQUAD_FILTER_TYPE 和指定频率的 BiquadFilterNode */
    ReceiverEffector.prototype.createBqFilter = function (bqType, frequency) {
        var biquadFilter = this.audioCtx.createBiquadFilter();
        biquadFilter.type = bqType;
        biquadFilter.frequency.value = frequency;
        return biquadFilter;
    };
    ReceiverEffector.effectorName = 'Receiver';
    return ReceiverEffector;
}(BaseAudioEffector));

/**
 * 混响效果
 * 模拟声音在自然传播的效果，添加空间感，相当于可以在模拟不同场景，音乐厅、客厅等
 */
var ReverbEffector = /** @class */ (function (_super) {
    __extends(ReverbEffector, _super);
    function ReverbEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 通道数
        _this.channelNum = 2;
        // 干湿音音量系数
        _this.dryWetConstant = 0.5;
        // 低通频率
        _this.lowPassFrequency = 7000;
        // 高通频率
        _this.highPassFrequency = 0;
        _this.lowPassBfNode = audioCtx.createBiquadFilter();
        _this.lowPassBfNode.type = BiquadFilterType.LOWPASS;
        _this.highPassBfNode = audioCtx.createBiquadFilter();
        _this.highPassBfNode.type = BiquadFilterType.HIGHPASS;
        _this.reverbNode = audioCtx.createConvolver();
        _this.dryGainNode = audioCtx.createGain();
        _this.wetGainNode = audioCtx.createGain();
        return _this;
    }
    ReverbEffector.prototype.connectBy = function (node) {
        if (!node || !this.inputNode) {
            return null;
        }
        // 连接头尾
        node.connect(this.inputNode);
        this.setPreConfigName(AudioEffectName.DEFAULT);
        return this.outputNode;
    };
    ReverbEffector.prototype.destroy = function () {
        var _a;
        _super.prototype.destroy.call(this);
        this.lowPassBfNode = null;
        this.highPassBfNode = null;
        this.reverbNode = null;
        this.dryGainNode = null;
        this.wetGainNode = null;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.getEffectorName(), " destroy()"));
        this.logger = null;
    };
    ReverbEffector.prototype.getEffectorName = function () {
        return ReverbEffector.effectorName;
    };
    /**
     * 设置混响预配置
     */
    ReverbEffector.prototype.setPreConfigName = function (effectName) {
        var _a, _b, _c;
        if (effectName === this.currPreCfgName || !this.inputNode) {
            return;
        }
        this.currPreCfgName = effectName;
        this.connectInnerNodes();
        if (this.currPreCfgName === AudioEffectName.DEFAULT) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log('ReverbEffector setPreConfigName() currPreCfgName is DEFAULT');
            return;
        }
        var cfg = getPreCfgByName(effectName, RVB_PRECFG_LIST);
        if (!cfg) {
            (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log("ReverbEffector setPreConfigName() effectName= ".concat(effectName, " cfg is null!"));
            return;
        }
        // 混响 buffer
        this.reverbNode.buffer = this.rebuildImpulse(cfg);
        // 低通频率更新
        this.lowPassBfNode.frequency.setValueAtTime(this.lowPassFrequency, this.audioCtx.currentTime);
        // 高通频率更新
        this.highPassBfNode.frequency.setValueAtTime(this.highPassFrequency, this.audioCtx.currentTime);
        // 干湿音音量计算
        var dryWetValue = this.getDryWetValue(cfg.mix);
        this.dryGainNode.gain.value = dryWetValue.dry;
        this.wetGainNode.gain.value = dryWetValue.wet;
        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.log("ReverbEffector setPreConfigName() effectName= ".concat(effectName, " dry=").concat(dryWetValue.dry, " wet=").concat(dryWetValue.wet));
    };
    /**
     * 建立内部节点连接
     */
    ReverbEffector.prototype.connectInnerNodes = function () {
        this.disconnectInnerNodes();
        // 如果是 default，只需要 input 和 output 连接即可
        if (this.currPreCfgName === AudioEffectName.DEFAULT) {
            this.inputNode.connect(this.outputNode);
        }
        else {
            // 干音连接通路
            this.inputNode.connect(this.dryGainNode);
            this.dryGainNode.connect(this.outputNode);
            // 湿音连接通路
            this.inputNode.connect(this.lowPassBfNode);
            this.lowPassBfNode.connect(this.highPassBfNode);
            this.highPassBfNode.connect(this.reverbNode);
            this.reverbNode.connect(this.wetGainNode);
            this.wetGainNode.connect(this.outputNode);
        }
        this.outputNode.gain.value = 1;
    };
    /**
     * 断开内部节点连接
     */
    ReverbEffector.prototype.disconnectInnerNodes = function () {
        _super.prototype.disconnectInnerNodes.call(this);
        this.lowPassBfNode.disconnect();
        this.highPassBfNode.disconnect();
        this.reverbNode.disconnect();
        this.dryGainNode.disconnect();
        this.wetGainNode.disconnect();
    };
    /**
     * 构建简易和幂运算混响效果
     * 幂运算混响会再次多做一个循环计算衰减效果，如果时间系数和衰减系数过大会加大计算量
     */
    ReverbEffector.prototype.rebuildImpulse = function (cfg) {
        var sampleRate = this.audioCtx.sampleRate;
        // 计算音效的采样帧数
        var sampleLen = cfg.time * sampleRate;
        // 创建混音长度为 samplelen 的 buffer
        var buffer = this.audioCtx.createBuffer(this.channelNum, sampleLen, this.audioCtx.sampleRate);
        // 获取左右声道数据
        var channelLeft = buffer.getChannelData(0);
        var channelRight = buffer.getChannelData(1);
        for (var i = 0; i < sampleLen; i++) {
            var rev = cfg.reverse ? sampleLen - i : i;
            // 用随机值再对多声道计算
            // PS: 左右分别计算让左右声道保持少许回响区别，提升双耳感知效果
            channelLeft[i] = this.getChannelSamples(rev, sampleLen, cfg);
            channelRight[i] = this.getChannelSamples(rev, sampleLen, cfg);
        }
        if (!cfg.simpleImpulseMode) {
            // 非简单算法下根据衰减长度，再计算音效的衰减采样帧数
            var sampleDecay = cfg.decay * sampleRate;
            for (var i = 0; i < sampleDecay; i++) {
                var rev = cfg.reverse ? sampleLen - i : i;
                var revDecay = rev / sampleDecay;
                // 同样需要保持左右声道少许区别
                channelLeft[rev] *= revDecay;
                channelRight[rev] *= revDecay;
            }
        }
        return buffer;
    };
    /**
     * 计算当前声道帧数据，
     * */
    ReverbEffector.prototype.getChannelSamples = function (rev, sampleLen, cfg) {
        // 非简单混响算法使用 0.001 为基数计算指数
        var powBase = 0.001;
        // 获取范围 -1~1 的随机值
        var random = ((Math.random() * 2) - 1);
        // 指数计算后帧的值
        var powSamples = 0;
        // 使用简单算法创建，通过衰减系数做指数计算
        if (cfg.simpleImpulseMode) {
            powSamples = Math.pow((1 - (rev / sampleLen)), cfg.decay);
        }
        else {
            // 使用非简单算法，再加个 rev 指数计算，加大回响衰减时长，以模拟在大空间时距离空间感
            // 类似音乐厅等这种大空间场景
            powSamples = Math.pow((Math.pow(powBase, (1 / sampleLen))), rev);
        }
        return random * powSamples;
    };
    /**
     * 根据mix值计算干湿音数值
     */
    ReverbEffector.prototype.getDryWetValue = function (mix) {
        var cfgMix = mix;
        // mix 在 0~1 范围内
        if (mix < 0 || mix > 1) {
            cfgMix = 0;
        }
        if (cfgMix <= this.dryWetConstant) {
            return { dry: 1, wet: 1 - (2 * (this.dryWetConstant - cfgMix)) };
        }
        return { dry: 1 - (2 * (cfgMix - this.dryWetConstant)), wet: 1 };
    };
    ReverbEffector.effectorName = 'Reverb';
    return ReverbEffector;
}(MultiNodesEffector));
/**
 * Reverb 音效预制数据
 */
var RVB_PRECFG_LIST = [
    {
        name: AudioEffectName.CONCERT_HALL,
        label: '音乐厅',
        mix: 0.5,
        time: 1.8,
        decay: 15,
        reverse: false,
        simpleImpulseMode: false,
    }, {
        name: AudioEffectName.LIVING_ROOM,
        label: '客厅',
        mix: 0.5,
        time: 1.4,
        decay: 5,
        reverse: false,
        simpleImpulseMode: true,
    }, {
        name: AudioEffectName.LIVE,
        label: '演唱会现场',
        mix: 0.3,
        time: 3,
        decay: 5,
        reverse: false,
        simpleImpulseMode: true,
    },
];

/**
 * 声音空间效果，其实就是 3D 环绕
 */
var SpatialStereoEffector = /** @class */ (function (_super) {
    __extends(SpatialStereoEffector, _super);
    function SpatialStereoEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 更新 panner 位置时间间隔
        _this.intervalTime = 300;
        _this.startTimeStamp = 0;
        // 3D 环绕半径
        _this.radius = 3;
        // 旋转速度，单位度数
        _this.degreeSpeed = 4;
        // 旋转开始位置
        _this.degreeStart = 0;
        // 旋转最大度数
        _this.degreeMax = 360;
        // 相关文档较少，设置空间定位音频的算法，HRTF 含义为：Head-related transfer function
        _this.panningModel = 'HRTF';
        // 使用 linear 算法来降低音频源远离听众时的音量
        _this.distanceModel = 'linear';
        _this.pannerNode = _this.audioCtx.createPanner();
        _this.pannerNode.panningModel = _this.panningModel;
        _this.pannerNode.distanceModel = _this.distanceModel;
        // 音源参考距离
        _this.pannerNode.refDistance = 1;
        // 指定音源发出的位置
        _this.pannerNode.coneInnerAngle = 360;
        _this.pannerNode.coneOuterAngle = 0;
        // 音源增益为 0
        _this.pannerNode.coneOuterGain = 1;
        _this.isConnected = false;
        return _this;
    }
    SpatialStereoEffector.prototype.connectBy = function (node) {
        if (!node || !this.pannerNode) {
            return null;
        }
        node.connect(this.pannerNode);
        this.isConnected = true;
        return this.pannerNode;
    };
    SpatialStereoEffector.prototype.disconnect = function () {
        var _a, _b;
        (_a = this.pannerNode) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.isConnected = false;
        (_b = this.logger) === null || _b === void 0 ? void 0 : _b.log("".concat(this.getEffectorName(), " disconnect()"));
    };
    SpatialStereoEffector.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.pannerNode = null;
    };
    SpatialStereoEffector.prototype.getEffectorName = function () {
        return SpatialStereoEffector.effectorName;
    };
    /**
     * 更新 Loop 时间间隔，保持默认 300ms 更新一次
     */
    SpatialStereoEffector.prototype.updateLoop = function () {
        // 如果没有连接音效，不需要更新位置
        if (!this.isConnected) {
            return false;
        }
        var curTimeStamp = +new Date();
        if (curTimeStamp - this.startTimeStamp > this.intervalTime) {
            this.updatePanningPosition();
            this.startTimeStamp = curTimeStamp;
        }
        return true;
    };
    /**
     * 更新音效空间位置
     */
    SpatialStereoEffector.prototype.updatePanningPosition = function () {
        var rl = this.degreeStart * Math.PI / 180;
        this.pannerNode.positionX.value = this.radius * Math.cos(rl);
        this.pannerNode.positionZ.value = this.radius * Math.sin(rl);
        this.degreeStart += this.degreeSpeed;
        // 超过最大度数就恢复为初始位置
        if (this.degreeStart >= this.degreeMax) {
            this.degreeStart = this.degreeStart - this.degreeMax;
        }
    };
    SpatialStereoEffector.effectorName = 'SpatialStereo';
    return SpatialStereoEffector;
}(BaseAudioEffector));

/**
 * 震音效果，给人声或者乐器声添加起伏变化
 */
var TremoloEffector = /** @class */ (function (_super) {
    __extends(TremoloEffector, _super);
    function TremoloEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 干湿混音 mix 系数
        _this.mix = 0.2;
        // 默认 LFO 频率，暂时不需要外部传入，默认配置即可
        _this.lfoFrequency = 10;
        // 信号以正弦波形方式周期振荡
        _this.lfoType = 'sine';
        _this.wetGainNode = audioCtx.createGain();
        _this.dryGainNode = audioCtx.createGain();
        _this.dryGainNode.gain.value = 1 - _this.mix;
        _this.wetGainNode.gain.value = _this.mix;
        _this.tremoloGainNode = audioCtx.createGain();
        _this.tremoloGainNode.gain.value = 1;
        _this.lfoNode = audioCtx.createOscillator();
        _this.lfoNode.type = _this.lfoType;
        _this.lfoNode.frequency.value = _this.lfoFrequency;
        _this.lfoNodeRunning = false;
        return _this;
    }
    TremoloEffector.prototype.destroy = function () {
        // super.destroy 会调用 disconnect
        _super.prototype.destroy.call(this);
        if (this.lfoNode && this.lfoNodeRunning) {
            this.lfoNodeRunning = false;
            // destory 了就调用 OscillatorNode.stop
            this.lfoNode.stop();
        }
        this.lfoNode = null;
        this.wetGainNode = null;
        this.dryGainNode = null;
        this.tremoloGainNode = null;
    };
    TremoloEffector.prototype.getEffectorName = function () {
        return TremoloEffector.effectorName;
    };
    /**
     * 重新建立节点连接，如果使用默认则头尾 input 链接 output 即可
     */
    TremoloEffector.prototype.connectInnerNodes = function () {
        this.disconnectInnerNodes();
        // 连接干音通路，此通路保持原音，无需处理直接连接即可
        this.inputNode.connect(this.dryGainNode);
        this.dryGainNode.connect(this.outputNode);
        // 连接湿音通路
        if (!this.lfoNodeRunning) {
            this.lfoNodeRunning = true;
            this.lfoNode.start(0);
        }
        this.lfoNode.connect(this.tremoloGainNode.gain);
        this.inputNode.connect(this.tremoloGainNode);
        this.tremoloGainNode.connect(this.wetGainNode);
        this.wetGainNode.connect(this.outputNode);
    };
    /**
     * 断开内部节点连接
     */
    TremoloEffector.prototype.disconnectInnerNodes = function () {
        _super.prototype.disconnectInnerNodes.call(this);
        this.dryGainNode.disconnect();
        this.wetGainNode.disconnect();
        this.tremoloGainNode.disconnect();
        // 断开连接后振荡器会自动暂停，如果只是断开连接无需调用 stop 方法
        // 原因是 WebAudio API 里设计 OscillatorNode.start 和 stop 只能调用一次，二次调用会报错
        this.lfoNode.disconnect();
    };
    TremoloEffector.effectorName = 'Tremolo';
    return TremoloEffector;
}(MultiNodesEffector));

/**
 * 声音控制模块，包括音效和音量增益等
 *
 * @export
 * @class AudioController
 * @typedef {AudioController}
 */
var AudioController = /** @class */ (function () {
    function AudioController(media, logger) {
        // 所有使用到的音效类型
        this.effectorType = [
            GainEffector, // 音量增益效果
            SpatialStereoEffector, // 立体声效果器
            EqualizerEffector, // 滤波器效果器
            CompressorEffector, // 压缩器效果器
            ReverbEffector, // 混响效果器
            ReceiverEffector, // 听筒效果器
            TremoloEffector, // 震音效果器
            ChorusEffector, // 和声效果器
        ];
        this.currEffect = AudioEffectName.DEFAULT;
        this.currGain = 0;
        this.media = media;
        this.logger = logger;
        this.effectorMap = new Map();
    }
    AudioController.prototype.onPlay = function () {
        // 创建 AudioContext 并初步创建连接
        this.createContextAndConnect();
    };
    /**
    * 断开声音播放通路并销毁
    */
    AudioController.prototype.destroy = function () {
        // 将各个效果器销毁
        this.effectorMap.forEach(function (audioEffect) {
            audioEffect.destroy();
        });
        this.effectorMap.clear();
        this.effectorMap = null;
        if (this.audioSource) {
            this.audioSource.disconnect();
            this.audioSource = null;
        }
        // 关闭 Context
        if (this.audioCtx) {
            if (this.audioCtx.state === AudioContextState.RUNNING) {
                // audioCtx 一旦接管 video 播放后，如果 audioCtx.stop 后在 Chrome 会永久影响声音无法播放
                // 所以即使 destory 也只能 suspend (暂停)
                this.audioCtx.suspend();
            }
            this.audioCtx = null;
        }
        this.media = null;
        this.logger = null;
        this.currEffect = AudioEffectName.DEFAULT;
        this.currGain = 0;
    };
    /**
     * 设置增益百分比，范围[0,2]
     * 比如传入0.5，意味在当前音量大小下，增益50%，最大增益到200%，可能会出现破音
     * @param value 增益值
     */
    AudioController.prototype.setGainValue = function (value) {
        if (!isEnvSupport() || !this.isMediaSupport()) {
            this.logger.warn("setGainValue(), not supported, envi= ".concat(isEnvSupport(), " ,media= ").concat(this.isMediaSupport()));
            return;
        }
        if (!this.isContextRunning()) {
            this.logger.warn('setGainValue(), AudioContext is not running');
            return;
        }
        // 用于增益音效是否启用均衡器判断
        this.currGain = value;
        var gainEffector = this.effectorMap.get(GainEffector.effectorName);
        if (!gainEffector) {
            this.connectAudioPath();
        }
        gainEffector.setGainValue(value);
    };
    /**
     * 获取增益百分比，范围[0,2]，即0~200%
     */
    AudioController.prototype.getGainValue = function () {
        // 不直接返回 currGain 原因是：currGain 并没有经过范围校验
        var gainEffector = this.effectorMap.get(GainEffector.effectorName);
        if (!gainEffector) {
            this.logger.warn('getGainValue(),gainEffector is null');
            return 0;
        }
        return gainEffector.getGainValue();
    };
    /**
     * 设置效果，目前同时只支持一种效果，暂无需求支持多种效果混合
     * @param effectName 效果器名称
     */
    AudioController.prototype.setEffect = function (effectName) {
        if (!isEnvSupport() || !this.isMediaSupport()) {
            this.logger.warn("setEffect(), not supported, envi= ".concat(isEnvSupport(), " ,media= ").concat(this.isMediaSupport()));
            return;
        }
        if (!this.isContextRunning()) {
            this.logger.warn('setEffect(), AudioContext is not running');
            return;
        }
        if (this.currEffect === effectName) {
            // 不需要重复设置了
            this.logger.log("setEffect(), this.currEffect === effectName, effectName=".concat(effectName));
            return;
        }
        this.currEffect = effectName;
        this.connectAudioPath();
    };
    /**
     * 获取当前效果
     */
    AudioController.prototype.getEffect = function () {
        return this.currEffect;
    };
    /**
     * 使用播放器主循环调用此函数，目前只有立体声环绕需要，这里就先只写 SpatialStereo
     */
    AudioController.prototype.loop = function () {
        var spatialStereo = this.effectorMap.get(SpatialStereoEffector.effectorName);
        if (spatialStereo === null || spatialStereo === void 0 ? void 0 : spatialStereo.using) {
            spatialStereo.updateLoop();
        }
    };
    /**
     * 创建 AudioContext 并初步创建连接
     * 如果 audioSourceNodes 里有 AudioContext 和 AudioSourceNode ，需要优先复用
     */
    AudioController.prototype.createContextAndConnect = function () {
        var _this = this;
        var _a;
        if (!isEnvSupport() || !this.isMediaSupport()) {
            // 如果不支持就不执行下去了
            return;
        }
        if (audioSourceNodes.has(this.media)) {
            // 此处需要注意：
            // 使用 audioSourceNodes 存储的原因是，一旦 audioSource 接管了 video 元素的声音，就必须使用该 audioSoure 才能播放出声音，否则出现无法播放卡住的问题
            // 所以在 BaseVideoNode 被销毁时或者 AudioContext 被关闭，需要 video 元素复用的情况时，只能找回该对应 audioSoure 才能正常播放
            this.audioSource = audioSourceNodes.get(this.media);
            this.audioCtx = this.audioSource.context;
            if (((_a = this.audioCtx) === null || _a === void 0 ? void 0 : _a.state) === AudioContextState.SUSPENDED) {
                // 复用 audioSource 需要创建声音连接，否则会没有声音
                this.audioCtx.resume().then(function () { return _this.connectAudioPath(); });
            }
        }
        else {
            // 如果没有，就创建新的 AudioContext 和 AudioSourceNode
            this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            this.audioSource = this.audioCtx.createMediaElementSource(this.media);
            audioSourceNodes.set(this.media, this.audioSource);
            // audioSource 接管声音后，需要创建声音连接，否则会没有声音
            this.connectAudioPath();
        }
    };
    /**
     * 创建声音通路
     */
    AudioController.prototype.connectAudioPath = function () {
        // 创建效果器
        this.createAudioEffectors();
        // 先断开上次已经连接上的设备
        this.disconnect();
        // 激活对应效果器
        this.activeEffects();
        // 更新连接效果器
        this.reconnect();
    };
    /**
     * 创建 audioContext , audioSource 和各个效果器
     */
    AudioController.prototype.createAudioEffectors = function () {
        var _this = this;
        this.logger.log('audioController createAudioEffectors()');
        // 如果效果数组已经存在，则无需再创建
        if (this.effectorMap.size === 0) {
            // 按 effectType 数组依次创建
            this.effectorType.forEach(function (EffectorType) {
                var effector = new EffectorType(_this.audioCtx, _this.logger);
                _this.effectorMap.set(effector.getEffectorName(), effector);
            });
        }
    };
    /**
     * 需要 media 是否为 HTMLMediaElement 和是否允许跨域判断
     * WASM 使用 Canvas 实现的 FakeHTMLMediaElement 暂不支持音效
     * 不支持跨域则会出现 WebAudio 劫持 Video 后无法出声音情况
     */
    AudioController.prototype.isMediaSupport = function () {
        // 如果 media 不是真实的 video 元素，不支持
        if (!this.media || !(this.media instanceof HTMLMediaElement)) {
            return false;
        }
        // 如果视频文件没有设置跨域，会出现W ebAudio 劫持 Video 后无法出声音情况，浏览器会报如下错误：
        // MediaElementAudioSource outputs zeroes due to CORS access restrictions for https://xxx.mp4
        // 需要给 SuperPlayer 加上设置跨域，例如：
        // videoElementConfig: {
        //     crossorigin: true,
        // }
        if (!this.media.crossOrigin) {
            return false;
        }
        return true;
    };
    /**
     * 判断 audioCtx 是否为空或者被关闭
     */
    AudioController.prototype.isContextRunning = function () {
        return this.audioCtx && this.audioCtx.state === AudioContextState.RUNNING;
    };
    /**
    * 建立声音播放通路
    */
    AudioController.prototype.reconnect = function () {
        var _this = this;
        // audioSource（音源) -> 各个音效节点 -> destination (输出目标)
        var currNode = this.audioSource;
        var nodesName = 'audioSource -> ';
        this.effectorMap.forEach(function (audioEffect) {
            if (audioEffect.using) {
                currNode = audioEffect.connectBy(currNode);
                audioEffect.setPreConfigName(_this.currEffect);
                nodesName += "".concat(audioEffect.getEffectorName(), " -> ");
            }
        });
        currNode.connect(this.audioCtx.destination);
        this.logger.log("audioController reconnect(), using audioEffect = ".concat(nodesName, " destination"));
    };
    /**
     * 断开声音播放通路
     */
    AudioController.prototype.disconnect = function () {
        this.audioSource.disconnect();
        this.effectorMap.forEach(function (audioEffect) {
            if (audioEffect.using) {
                audioEffect.disconnect();
                audioEffect.using = false;
            }
        });
        this.logger.log('audioController disconnect()');
    };
    /**
     * 按 currEffect 激活对应效果器
     */
    AudioController.prototype.activeEffects = function () {
        // 增益效果器常起用
        this.effectorMap.get(GainEffector.effectorName).using = true;
        // 压缩效果器在有音效时或者默认音效有增益都需要起用，以防止破音
        var compressorEffector = this.effectorMap.get(CompressorEffector.effectorName);
        compressorEffector.using = true;
        switch (this.currEffect) {
            case AudioEffectName.SPATIAL_STEREO:
                // SPATIAL_STEREO 使用立体声效果器
                this.effectorMap.get(SpatialStereoEffector.effectorName).using = true;
                break;
            case AudioEffectName.CONCERT_HALL:
            case AudioEffectName.LIVING_ROOM:
            case AudioEffectName.LIVE:
                // CONCERT_HALL 和 LIVE_HOUSE 、 LIVE 属于混响效果器
                this.effectorMap.get(ReverbEffector.effectorName).using = true;
                break;
            case AudioEffectName.RECEIVER:
                // 听筒效果
                this.effectorMap.get(ReceiverEffector.effectorName).using = true;
                break;
            case AudioEffectName.TREMOLO:
                this.effectorMap.get(TremoloEffector.effectorName).using = true;
                break;
            case AudioEffectName.CHORUS:
                this.effectorMap.get(ChorusEffector.effectorName).using = true;
                break;
            case AudioEffectName.DEFAULT:
                // 选择默认效果并且无增益时，则去掉压缩器效果恢复原有音效
                if (this.currGain === 0) {
                    compressorEffector.using = false;
                }
                break;
            default:
                // 其余都是 EQ 均衡效果器
                this.effectorMap.get(EqualizerEffector.effectorName).using = true;
                break;
        }
    };
    return AudioController;
}());

var logMethodCall$6 = logMethodCallDecoratorCreator('BaseVideoNode');
var BaseVideoNode = /** @class */ (function (_super) {
    __extends(BaseVideoNode, _super);
    function BaseVideoNode(config) {
        var _a;
        var _this = _super.call(this) || this;
        _this._played = false;
        _this._evtBlocking = false;
        _this._pauseCloseToEndStateCheckTimeoutId = 0;
        /** seek操作的目标播放点 */
        _this._targetSeekTime = -1;
        /** 外部传入的startTime，起播后置0 */
        _this._userStartTime = 0;
        /** 是否是用户seek */
        _this._isUserSeek = false;
        _this.isUserSwitchAudioTrack = false;
        /** 首次缓冲超时的计时器id */
        _this.loadTimeoutId = 0;
        _this.levelSwitchTargetPlaytime = -1;
        /** 切换清晰度方式 */
        _this.setLevelMode = SetLevelMode.SOFT;
        /** 是否存在外挂音轨 */
        _this.altAudio = false;
        /** 直播延迟控制器 */
        _this.latencyController = null;
        _this._logger = new Logger(config.instanceId, 'BaseVideoNode');
        _this._config = config;
        _this.stateMgr = new StateMgr(_this);
        _this.checkPlayHealth = new CheckHealth(_this);
        _this.loading = new Loading(_this);
        _this.setHealthEvents();
        _this.mainTaskLoop = new TaskLoop(_this.mainLoopInProcess.bind(_this), LoopMode.RAF);
        var _b = _this._config, container = _b.container, enableAudioEffect = _b.enableAudioEffect;
        _this._video = _this.findFreeVideoElement();
        _this._autoPlayPolicy = new AutoPlayPolicy(_this._video, { instanceId: config.instanceId });
        _this._state = VideoState.IDLE;
        _this._playbackRate = 1;
        _this._idx = 0;
        _this._videoInfo = null;
        _this._pauseType = void 0;
        // 绑定各种VideoNode播放事件
        _this._videoEventMap = (_a = {},
            _a[VideoEvts.loadstart] = _this.onVideoEventLoadStart.bind(_this),
            _a[VideoEvts.timeupdate] = _this.onVideoEventTimeUpdate.bind(_this),
            _a[VideoEvts.durationchange] = _this.onVideoEventDurationChange.bind(_this),
            _a[VideoEvts.volumechange] = _this.onVideoEventVolumeChange.bind(_this),
            _a[VideoEvts.canplay] = _this.onVideoEventCanplay.bind(_this),
            _a[VideoEvts.playing] = _this.onVideoEventPlaying.bind(_this),
            _a[VideoEvts.pause] = _this.onVideoEventPause.bind(_this),
            _a[VideoEvts.waiting] = _this.onVideoEventWaiting.bind(_this),
            _a[VideoEvts.seeking] = _this.onVideoEventSeeking.bind(_this),
            _a[VideoEvts.seeked] = _this.onVideoEventSeeked.bind(_this),
            _a[VideoEvts.loadeddata] = _this.onVideoEventLoadeddata.bind(_this),
            _a[VideoEvts.loadedmetadata] = _this.onVideoEventLoadedmetadata.bind(_this),
            _a[VideoEvts.ended] = _this.onVideoEventEnded.bind(_this),
            _a[VideoEvts.error] = _this.onVideoEventError.bind(_this),
            _a[VideoEvts.progress] = _this.onVideoEventProgress.bind(_this),
            _a[VideoEvts.ratechange] = _this.onVideoEventRateChange.bind(_this),
            _a[VideoEvts.resize] = _this.onVideoEventResize.bind(_this),
            _a);
        _this._drm = new DRM(_this._video, config.drmConfig, config.instanceId);
        _this._drm.on('error', _this.onDrmError.bind(_this));
        _this._eventMap = {
            video: _this.onVideoEvents.bind(_this),
        };
        _this._eventAddedMap = {};
        _this._videoElementContainer = domTool.getElementFromConfig(container).querySelector(".".concat(VIDEO_CONTAINER_CLASS));
        videoTool.appendElement(_this._video, _this._videoElementContainer);
        _this.performanceMonitor = new PerformanceMonitor(_this._video);
        _this.videoResizeAutoFill = new VideoResizeAutoFill(_this._video, _this._config.minFillBlackBorder);
        _this.vnStatusChecker = new CheckVideoNodeStatus(_this);
        if (enableAudioEffect) {
            _this.audioController = new AudioController(_this._video, new Logger(config.instanceId, 'AudioController'));
        }
        if (config.type === PlayMode.LIVE) {
            _this.latencyController = new LatencyController(_this._video, config, _this.onLatencyExceeded.bind(_this), _this.onLatencyDropped.bind(_this), _this.latencyCalculationMethod.bind(_this));
        }
        return _this;
    }
    /** 第一次播放时（此时必须是用户触发），在js的同一个事件循环里直接调用一次video标签的play方法。*/
    BaseVideoNode.prototype.triggerAutoplay = function () {
        var _this = this;
        // 触发自动播放时候会调用video的play和pause方法，这时候的调用发出的事件需要丢弃
        this._evtBlocking = true;
        return this._autoPlayPolicy.userTrigger()
            .then(function () { return _this._evtBlocking = false; })
            .catch(function (e) {
            _this._evtBlocking = false;
            // 抛出错误让调用方catch
            throw e;
        });
    };
    BaseVideoNode.prototype.videoplay = function () {
        var _this = this;
        var _a, _b;
        this._logger.log("videoplay(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/state=").concat(this.state, "/idx=").concat(this.idx));
        var playPromise = this._video.play();
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        if (playPromise) {
            playPromise.catch(function (e) {
                _this._logger.warn("".concat(_this.idx, " play() catch: ").concat(e.name, ", ").concat(e.message));
                var isAutoPlayBlocked = videoTool.isAutoPlayBlockedMessage(e.message);
                if (isAutoPlayBlocked) {
                    // 自动播放被阻止一定无法起播，可能用户在等待状态，此时要去掉loading动画
                    _this.loading.hide();
                }
                _this.emit(VideoNodeEvent.PLAY_PROMISE_CATCHED, { videoInfo: _this._videoInfo, isAutoPlayBlocked: isAutoPlayBlocked });
            });
        }
        else {
            // 兼容 IE，play 返回 undefined 的情况下，直接返回一个 resolve 的 Promise
            playPromise = Promise.resolve();
        }
        (_b = this.audioController) === null || _b === void 0 ? void 0 : _b.onPlay();
        this._video.playbackRate = this._playbackRate;
        this.playPromise = playPromise;
        return playPromise;
    };
    BaseVideoNode.prototype.pause = function (type) {
        if (type === void 0) { type = PauseType.USER; }
        if (!this._played) {
            this._logger.warn('pause(), VideoNode has not been played');
            return;
        }
        if (!this.stateMgr.validCallState(VideoState.PAUSE)) {
            this._logger.log("call pause in invaild state ".concat(this._state));
            return;
        }
        this.pauseInner(type);
    };
    BaseVideoNode.prototype.resume = function () {
        throw new Error('not implements');
    };
    BaseVideoNode.prototype.stop = function () {
        this.stopInner();
    };
    BaseVideoNode.prototype.destroy = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.stopInner();
        (_a = this.latencyController) === null || _a === void 0 ? void 0 : _a.destroy();
        this.latencyController = null;
        if (this._video) {
            if (this._eventMap) {
                this.setVideoEvents(false);
                this._eventMap = null;
            }
            videoTool.clear(this._video);
            videoTool.removeElement(this._video, this._videoElementContainer);
            this._video.dataset.used = VideoElementState.FREE;
        }
        (_b = this._autoPlayPolicy) === null || _b === void 0 ? void 0 : _b.destroy();
        this._autoPlayPolicy = null;
        (_c = this.stateMgr) === null || _c === void 0 ? void 0 : _c.destroy();
        this.stateMgr = null;
        this.removeAllListeners();
        (_d = this._drm) === null || _d === void 0 ? void 0 : _d.destroy();
        this._drm = null;
        this._video = null;
        this._videoInfo = null;
        this._videoElementContainer = null;
        this._played = false;
        this._config = null;
        (_e = this.checkPlayHealth) === null || _e === void 0 ? void 0 : _e.destroy();
        this.checkPlayHealth = null;
        (_f = this.loading) === null || _f === void 0 ? void 0 : _f.clearDelay();
        this.loading = null;
        (_g = this.mainTaskLoop) === null || _g === void 0 ? void 0 : _g.destroy();
        this.mainTaskLoop = null;
        this.performanceMonitor = null;
        (_h = this.videoResizeAutoFill) === null || _h === void 0 ? void 0 : _h.destroy();
        this.videoResizeAutoFill = null;
        (_j = this.vnStatusChecker) === null || _j === void 0 ? void 0 : _j.destroy();
        this.vnStatusChecker = null;
        (_k = this.audioController) === null || _k === void 0 ? void 0 : _k.destroy();
        this.audioController = null;
        this._logger.log('VideoNode has been destroyed!');
    };
    BaseVideoNode.prototype.setLevel = function (mode) {
        if (mode === void 0) { mode = SetLevelMode.HARD; }
        if (!this.checkCanSetLevel()) {
            return Promise.reject(new Error('setLevel can\'t start'));
        }
        this._logger.log('setLevel(), succ exec: ', this._videoInfo);
        var levelSwitchTargetPlaytime = this._videoInfo.playtime;
        this.load(this._videoInfo, { startTime: levelSwitchTargetPlaytime });
        this.play();
        var defer = new SimpleDefer();
        this._levelSwitchingDefer = defer;
        this.levelSwitchTargetPlaytime = levelSwitchTargetPlaytime;
        this.loading.show();
        this.emit(VideoNodeEvent.SETLEVEL_START, { videoInfo: this._videoInfo, mode: mode });
        return defer.promise;
    };
    /** 是否正在切换清晰度 */
    BaseVideoNode.prototype.getLevelSwitching = function () {
        return !!this._levelSwitchingDefer;
    };
    BaseVideoNode.prototype.setAudioTrack = function (_id) {
        if (!this.checkCanSetAudioTrack()) {
            return Promise.reject(AudioTrackErrorMsg.STATE_INVALID);
        }
        // base不支持切换音轨
        return Promise.reject(AudioTrackErrorMsg.NOT_SUPPORT);
    };
    /** 是否存在外挂音轨 */
    BaseVideoNode.prototype.hasAltAudio = function () {
        return this.altAudio;
    };
    /** 当前播放的资源是否是DRM加密的 */
    BaseVideoNode.prototype.isCurrentContentDRMEncrypted = function () {
        // 没有播放内容的话默认是不加密的
        if (this._state === VideoState.IDLE) {
            return false;
        }
        return this._drm.hasStarted();
    };
    Object.defineProperty(BaseVideoNode.prototype, "volume", {
        get: function () {
            if (this._video.muted) {
                return 0;
            }
            return this._video.volume;
        },
        set: function (value) {
            var _a;
            if (value < 0 || value > 1) {
                this._logger.warn('The volume value range is [0,1]');
                return;
            }
            var change2Unmute = this._video.muted && value > 0;
            this._video.volume = value;
            this._video.muted = value <= 0;
            if (this._played && change2Unmute) {
                // 如果是静音状态下，可能能自动播放视频，但是AudioContext已经被阻止了:
                // The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page. https://goo.gl/7K7WLu
                // 此种状态如果恢复静音，需要调用一下AudioContext的resume
                (_a = this.audioController) === null || _a === void 0 ? void 0 : _a.onPlay();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "volumeGain", {
        get: function () {
            var _a;
            return (_a = this.audioController) === null || _a === void 0 ? void 0 : _a.getGainValue();
        },
        set: function (gain) {
            var _a, _b;
            if (gain < 0 || gain > 2) {
                this._logger.warn('The volume gain range is [0,2]');
                return;
            }
            // 如果没有context或者video尚未起播，webaudio会存在自动起播问题，所以需要在起播后设置
            if (!((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.hasFirstPlaying)) {
                return;
            }
            (_b = this.audioController) === null || _b === void 0 ? void 0 : _b.setGainValue(gain);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "audioEffect", {
        get: function () {
            var _a;
            return (_a = this.audioController) === null || _a === void 0 ? void 0 : _a.getEffect();
        },
        set: function (effectName) {
            var _a, _b;
            // 如果没有context或者video尚未起播，webaudio会存在自动起播问题，所以需要在起播后设置
            if (!((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.hasFirstPlaying)) {
                return;
            }
            (_b = this.audioController) === null || _b === void 0 ? void 0 : _b.setEffect(effectName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "playtime", {
        /** 播放进度（不一定是video标签的currentTime，如果是不间断播放，video标签时间不断增长，但该属性只是单个播放段上的偏移播放时间）*/
        get: function () {
            return this._videoInfo ? this._videoInfo.playtime : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (value) {
            var _a;
            if (this._state === value) {
                return;
            }
            var oldState = this._state;
            this._state = value;
            if (this._videoInfo) {
                this._videoInfo.state = this._state;
            }
            this._logger.log("set state(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/idx=").concat(this._idx, "/old=").concat(oldState, "/new=").concat(value));
            var evtData = {
                videoInfo: this._videoInfo,
                new: value,
                old: oldState,
            };
            // 以下状态需要增加特殊字段派发出去
            if (value === VideoState.PAUSE) {
                evtData.pauseType = this._pauseType || PauseType.SYS; // 既不是程序触发也不是用户触发（那就是系统莫名其妙触发）
                this._pauseType = void 0;
            }
            else if (value === VideoState.SEEKING) {
                evtData.seekingTime = this._targetSeekTime;
                evtData.isUserSeek = this._isUserSeek;
                this._targetSeekTime = -1;
            }
            else if (value === VideoState.SEEKED) {
                evtData.isUserSeek = this._isUserSeek;
            }
            this.setLoadingOnStateChange();
            this.emit(VideoNodeEvent.STATE_CHANGE, evtData);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "played", {
        /** 获取当时视频播放是否已经起播过 */
        get: function () {
            return this._played;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "useWorker", {
        /** 是否使用了worker来进行流的处理。各个内核需要复写，所以不能通过readonly方式写成属性，先eslint-disalbe吧 */
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "idx", {
        get: function () {
            return this._idx;
        },
        set: function (value) {
            this._idx = value;
            this._video.dataset.idx = "".concat(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoElement", {
        get: function () {
            return this._video;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoSize", {
        get: function () {
            return { width: this._video.videoWidth, height: this._video.videoHeight };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "videoBuffered", {
        get: function () {
            return videoTool.getBuffered(this._video);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "playbackRate", {
        get: function () {
            return this._video.playbackRate;
        },
        set: function (value) {
            this._playbackRate = value;
            // 如果不支持倍速的浏览器，会出现: "NotSupportedError" DOMException
            try {
                this._video.playbackRate = value;
            }
            catch (e) {
                this._logger.warn("set playbackRate: ".concat(e === null || e === void 0 ? void 0 : e.message));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "currentVideoInfo", {
        get: function () {
            return this._videoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "supportPlaybackRate", {
        get: function () {
            // x5的mse不支持倍速
            return !uaTool.browser.x5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseVideoNode.prototype, "duration", {
        get: function () {
            var vduration = this._videoInfo ? this._videoInfo.duration : 0;
            // 没有赋值src的时候HTMLVIDEOELEMENT.duration可能返回NaN
            return Number.isNaN(vduration) ? 0 : vduration;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 计算当前直播延迟
     *
     * @protected
     */
    BaseVideoNode.prototype.latencyCalculationMethod = function (_currentTime, _buffered) {
        // base未实现，子类实现
        return -1;
    };
    /**
     * 当前直播延迟超出期望延迟时的回调
     *
     * @protected
     */
    BaseVideoNode.prototype.onLatencyExceeded = function (_currentTime, _latency, _media) {
        // base未实现，子类实现
    };
    /**
     * 当前直播延迟回落到期望延迟时的回调
     *
     * @protected
     */
    BaseVideoNode.prototype.onLatencyDropped = function (_currentTime, _latency, _media) {
        // base未实现，子类实现
    };
    BaseVideoNode.prototype.setHealthEvents = function () {
        var _this = this;
        var healthEvtHandler = function (e) {
            _this._logger.warn("get health evt!!! evt=".concat(e.type, "/uid=").concat(_this._videoInfo.uid, "/idx=").concat(_this._idx, "/state=").concat(_this._state));
            _this.errorHandler(e.data);
        };
        this.checkPlayHealth.on(HEALTH_EVTS.STATE_STUCK, healthEvtHandler);
        this.checkPlayHealth.on(HEALTH_EVTS.PLAYTIME_STUCK, healthEvtHandler);
    };
    /** 设置video标签的事件监听 */
    BaseVideoNode.prototype.setVideoEvents = function (value) {
        var _this = this;
        var _a;
        if (this._eventAddedMap.videoEventAdded === value) {
            return;
        }
        this._logger.log("setVideoEvents(), idx=".concat(this._idx, "/value=").concat(value, "/uid=").concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid));
        this._eventAddedMap.videoEventAdded = value;
        Object.keys(this._videoEventMap).forEach(function (key) {
            if (value) {
                _this._video.addEventListener(key, _this._eventMap.video);
            }
            else {
                _this._video.removeEventListener(key, _this._eventMap.video);
            }
        });
    };
    /**
     * 对video标签的事件做处理
     * @param e 播放事件参数
     */
    BaseVideoNode.prototype.onVideoEvents = function (e) {
        var _this = this;
        var _a;
        // 这些条件下，事件都丢弃（evtBlocking会在自动播放触发前设置，自动播放触发结束后恢复）
        if (this.state === VideoState.IDLE || !this._videoInfo || this._evtBlocking) {
            this._logger.log("videoevt discard, idx=".concat(this._idx, "/uid=").concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/evttype=").concat(e.type, "/")
                + "state=".concat(this.state, "/evtBlocking=").concat(this._evtBlocking));
            return;
        }
        if (!IGNORE_VIDEO_EVT.includes(e.type)) {
            this._logger.log("videoevt, uid=".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/type=").concat(e.type, "/")
                + "time=".concat(this._video.currentTime, "/duration=").concat(this._video.duration));
        }
        // 由于状态机会过滤掉很多事件，因此额外将video标签的所有事件抛出
        this.emit(VideoNodeEvent.ELEMENT_EVTS, { videoInfo: this._videoInfo, elementEvtType: e.type });
        var closeToEnd = Math.abs(this._videoInfo.duration - this._videoInfo.playtime) < 0.1
            && this._videoInfo.duration > 0;
        if (e.type === 'pause' && closeToEnd) {
            // 某些浏览器会在结束之前抛出pause事件，如果原封不动的抛出事件可能会导致引用方误判。因此做一个延迟，如果马上收到ended事件，则不会派发。
            this._pauseCloseToEndStateCheckTimeoutId = window.setTimeout(function () {
                if (_this._videoEventMap[e.type]) {
                    _this._videoEventMap[e.type](e);
                }
            }, 0);
            return;
        }
        if (e.type === 'ended' && this._pauseCloseToEndStateCheckTimeoutId > 0) {
            window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
            this._pauseCloseToEndStateCheckTimeoutId = 0;
        }
        if (this._videoEventMap[e.type]) {
            this._videoEventMap[e.type](e);
        }
    };
    BaseVideoNode.prototype.onVideoEventPlaying = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setCheckLoadTimeoutEnable(false);
                        // 起播后要重置seeking标记
                        this._isUserSeek = false;
                        // 移动端chrome播放直播貌似收到loadedmetadata事件时候还可能为0，因此在这里再赋值一次给videoinfo
                        this.updateVideoSize();
                        if (uaTool.browser.x5) {
                            // 如果是先调用video.load()，x5浏览器在playing之前获取到的duration一直是0，包括在durationchange事件里面
                            // 所以这里在playing的时候再获取一遍了，出bug的ua：
                            // Mozilla/5.0 (Linux; Android 9; Redmi Note 7 Pro Build/PKQ1.181203.001; wv) AppleWebKit/537.36
                            // (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045224
                            this.onVideoEventDurationChange();
                        }
                        if (!uaTool.browser.safari) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.playPromise];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        // playPromise reject，不继续进行操作
                        return [2 /*return*/];
                    case 4:
                        if (!this._videoInfo.hasFirstPlaying) {
                            this.emit(VideoNodeEvent.FIRST_PLAYING, { videoInfo: this._videoInfo });
                        }
                        this.stateMgr.receiveVideoEvt(VideoEvts.playing);
                        // 在事件中videoInfo可能已被销毁，所以判断一下是否存在
                        if (this._videoInfo) {
                            // 在firstPlaying事件发出后、状态修改以后，再修改此变量。因为外部判断首次播放可能使用的!videoNode.hasFirstPlaying
                            this._videoInfo.hasFirstPlaying = true;
                            this._videoInfo.stateWhenErrorHappen = null;
                        }
                        this._userStartTime = 0;
                        this.checkSetLevelOver(VideoEvts.playing);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseVideoNode.prototype.onVideoEventCanplay = function () {
        this.setCheckLoadTimeoutEnable(false);
        if (!this._videoInfo) {
            return;
        }
        if (!this._videoInfo.qualityInfo.canplaytime) {
            this._videoInfo.qualityInfo.canplaytime = videoTool.getBuffered(this._video);
        }
        this.stateMgr.receiveVideoEvt(VideoEvts.canplay);
    };
    BaseVideoNode.prototype.onVideoEventPause = function () {
        if (this._pauseType !== PauseType.INNER) {
            // 过滤掉播放器内部调用的pause，例如切清晰度前程序调用的pause
            this.stateMgr.receiveVideoEvt(VideoEvts.pause);
        }
    };
    BaseVideoNode.prototype.onVideoEventEnded = function () {
        this._logger.log('setEndInner(), reason=endedEvt');
        this.setEndInner();
    };
    BaseVideoNode.prototype.onVideoEventSeeked = function () {
        this.stateMgr.receiveVideoEvt(VideoEvts.seeked);
        this.checkSetLevelOver(VideoEvts.seeked);
        this.resumeAfterSeek();
        // 重置userSeek标签
        this._isUserSeek = false;
    };
    /** 提供给有需要的继承类复写 */
    BaseVideoNode.prototype.onVideoEventLoadStart = function () {
    };
    BaseVideoNode.prototype.onVideoEventWaiting = function () {
        this.stateMgr.receiveVideoEvt(VideoEvts.waiting);
    };
    BaseVideoNode.prototype.onVideoEventSeeking = function () {
        this.stateMgr.receiveVideoEvt(VideoEvts.seeking);
    };
    BaseVideoNode.prototype.onVideoEventProgress = function () {
        this.emit(VideoNodeEvent.VIDEO_BUFFER_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventLoadedmetadata = function () {
        this.updateVideoSize();
        this.emit(VideoNodeEvent.METADATA_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventResize = function () {
        this.updateVideoSize(true);
    };
    BaseVideoNode.prototype.onVideoEventRateChange = function () {
        var playbackRate = this._video.playbackRate;
        this._playbackRate = playbackRate;
        this.emit(VideoNodeEvent.RATE_CHANGE, { playbackRate: playbackRate, videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventDurationChange = function () {
        if (this._video.duration > 0 && this._video.duration !== this._videoInfo.duration) {
            this._videoInfo.duration = this._video.duration;
            this._logger.log("onVideoEventDurationChange(), uid=".concat(this._videoInfo.uid, "/duration=").concat(this._videoInfo.duration, "/")
                + "idx=".concat(this.idx));
            this.emit(VideoNodeEvent.DURATION_CHANGE, { videoInfo: this._videoInfo });
        }
    };
    BaseVideoNode.prototype.onVideoEventVolumeChange = function () {
        this.emit(VideoNodeEvent.VOLUME_CHANGE, { volume: this.volume, videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventTimeUpdate = function () {
        if (this._video.currentTime === 0) {
            return;
        }
        this.updatePlaytime(this._video.currentTime);
        this.checkSetLevelOver(VideoEvts.timeupdate);
        // 部分浏览器中直播状态下出现buffer后只抛出canplay事件，不抛出playing事件
        // 导致状态扭转出现异常，所以我们在timeupdate中检查，如果处于buffering状态
        // 且readystate >=3，强制扭转为playing，避免被识别为卡死
        if (this._state === VideoState.BUFFERING && this._video.readyState >= VideoReadyState.HAVE_FUTURE_DATA) {
            this.stateMgr.setPlaying();
        }
    };
    BaseVideoNode.prototype.onAudioTrackSwitched = function (id, fail) {
        if (fail === void 0) { fail = false; }
        if (this.audioTrackSwitchingDefer) {
            this.audioTrackSwitchingDefer.resolve({ userTrigger: this.isUserSwitchAudioTrack, id: id, fail: fail });
            this.audioTrackSwitchingDefer = null;
            this.emit(VideoNodeEvent.SET_AUDIO_TRACK_OVER, {
                videoInfo: this._videoInfo,
                id: id,
                fail: fail,
                userTrigger: this.isUserSwitchAudioTrack,
            });
        }
    };
    BaseVideoNode.prototype.onVideoEventLoadeddata = function () {
        this.emit(VideoNodeEvent.VIDEO_BUFFER_CHANGE, { videoInfo: this._videoInfo });
    };
    BaseVideoNode.prototype.onVideoEventError = function () {
        this.errorHandler();
    };
    BaseVideoNode.prototype.onDrmError = function (event) {
        var _a = event.data, code = _a.code, message = _a.message, detail = _a.detail;
        var error = PlayerError.EncryptionError({
            code: code,
            detail: detail,
            message: message,
        });
        this._videoInfo.error = error;
        this.stopInner(false, this._videoInfo);
    };
    /** 检查是否能切换清晰度 */
    BaseVideoNode.prototype.checkCanSetLevel = function () {
        var setLevelDetail = this.vnStatusChecker.checkCanSetLevel();
        if (setLevelDetail.canSetLevel) {
            return true;
        }
        this._logger.warn(setLevelDetail.message);
        return false;
    };
    /**
     * 检查切换清晰度是否结束
     * @param evtName 事件名，切换清晰度完成可能在多个事件中检查。
     */
    BaseVideoNode.prototype.checkSetLevelOver = function (evtName) {
        var setLevelDetail = this.vnStatusChecker.checkIsSetLevelOver(evtName, this.levelSwitchTargetPlaytime);
        if (setLevelDetail) {
            this._logger.log('setLevelOver(), reason: '
                + "succOnPlaying=".concat(setLevelDetail.succInPlaying, "/succOnSeeked=").concat(setLevelDetail.succInSeeked, "/succOnTimeupdate=").concat(setLevelDetail.succInTimeupdate));
            this.setLevelOver();
        }
    };
    /** 切换清晰度结束 */
    BaseVideoNode.prototype.setLevelOver = function () {
        if (!this._levelSwitchingDefer) {
            return;
        }
        this._levelSwitchingDefer.resolve();
        this._levelSwitchingDefer = null;
        this.levelSwitchTargetPlaytime = -1;
        this.loading.hide();
        this.stateMgr.onSetLevelOver();
        this.emit(VideoNodeEvent.SETLEVEL_OVER, { videoInfo: this._videoInfo });
    };
    /**
   * 检查是否可以切换清晰度。
   * @param time 切换时间
   * @returns 是否可执行切换动作
   */
    BaseVideoNode.prototype.checkCanSeek = function (time, userActivation) {
        if (userActivation === void 0) { userActivation = false; }
        var seekDetail = this.vnStatusChecker.checkCanSeek({
            seektime: time,
            userActivation: userActivation,
            setLevelMode: this.setLevelMode,
        });
        if (seekDetail.canSeek) {
            return true;
        }
        this._logger.warn(seekDetail.message);
        return false;
    };
    /** 检查是否可以切换音轨 */
    BaseVideoNode.prototype.checkCanSetAudioTrack = function () {
        var setAudioTrackDetail = this.vnStatusChecker.checkCanSetAudioTrack(this.audioTrackSwitchingDefer);
        if (setAudioTrackDetail.canSetAudioTrack) {
            return true;
        }
        this._logger.warn(setAudioTrackDetail.message);
        return false;
    };
    /** 从config传入的video标签数组查找未使用的video标签（是否在文档流中），提供标准查找方法但部分内核需要复写 */
    BaseVideoNode.prototype.findFreeVideoElement = function () {
        return findFreeBaseVideoElement(this._config.videoElements);
    };
    /** 设置播放主循环是否启用。用于每帧检查播放进度、监控缓冲状态下是否卡死等 */
    BaseVideoNode.prototype.setMainLoopEnable = function (value) {
        if (value) {
            this.mainTaskLoop.start();
        }
        else {
            this.mainTaskLoop.stop();
        }
    };
    /** 主循环执行函数 */
    BaseVideoNode.prototype.mainLoopInProcess = function () {
        var _a;
        this.updateAccuratePlaytime();
        this.checkPlayHealth.loop();
        (_a = this.audioController) === null || _a === void 0 ? void 0 : _a.loop();
    };
    /** 更新更精确的时间，普通video事件的间隔时间精确到0.2~0.3s，此函数中精确到0.0167s */
    BaseVideoNode.prototype.updateAccuratePlaytime = function () {
        var _a;
        // 这里有3个条件，不满足任意case，跳过检查
        // 1. 播放器要处于playing状态，我们认为是在“播放中”
        // 2. video的duration要为正（兼容wasm内核没有ready state的情况）
        // 3. video的ready state小于4（兼容不存在ready state的case，不能使用 !== 4)
        if (this._state !== VideoState.PLAYING
            || this._video.duration <= 0
            || this._video.readyState < VideoReadyState.HAVE_ENOUGH_DATA) {
            return;
        }
        // 如果外部有传入回调函数用于播放时间粒度更小的事务执行，在此调用外部回调
        (_a = this.onAccurateTimeupdate) === null || _a === void 0 ? void 0 : _a.call(this, this._video.currentTime, this._video.duration);
        // 更新更精确的时间
        this.updatePlaytime(this._video.currentTime, true);
    };
    BaseVideoNode.prototype.updatePlaytime = function (value, silentEvt) {
        if (silentEvt === void 0) { silentEvt = false; }
        if (!this._videoInfo) {
            return;
        }
        var _a = this.performanceMonitor.report(), totalVideoFrames = _a.totalVideoFrames, droppedVideoFrames = _a.droppedVideoFrames, frameDroppedInPercentage = _a.frameDroppedInPercentage;
        this._videoInfo.qualityInfo.droppedVideoFrames = droppedVideoFrames;
        this._videoInfo.qualityInfo.totalVideoFrames = totalVideoFrames;
        this._videoInfo.qualityInfo.frameDroppedInPercentage = frameDroppedInPercentage;
        if (this._videoInfo.playtime !== value) {
            this._videoInfo.playtime = value;
        }
        if (!silentEvt) {
            this.emit(VideoNodeEvent.TIME_UPDATE, { videoInfo: this._videoInfo });
        }
    };
    BaseVideoNode.prototype.setCheckLoadTimeoutEnable = function (isSetTimer) {
        var _this = this;
        this.loadTimeoutId && clearTimeout(this.loadTimeoutId);
        if (!isSetTimer)
            return;
        var maxPreloadTimeout = this._config.maxPreloadTimeout;
        if (maxPreloadTimeout <= 0)
            return;
        this.loadTimeoutId = setTimeout(function () {
            if (document.visibilityState === 'hidden') {
                return;
            }
            _this.errorHandler(PlayerError.NativeError({
                code: 104 /* PlaybackErrorCode.ORG_LOAD_TIMEOUT */,
                detail: commonTool.isPageHidden(),
                fatal: false,
                message: compile(i18nConfig.core.ERROR_PRELOAD_VIDEO_TIMEOUT),
            }));
        }, maxPreloadTimeout);
    };
    /** 拖动以后恢复播放或恢复播放状态 */
    BaseVideoNode.prototype.resumeAfterSeek = function () {
        if (!this._played || this._video.ended || !this._isUserSeek) {
            // 未开播前（比如只是预加载视频）or 视频已经播放结束 or 不是用户的seek操作，不需要在seek以后恢复播放
            return;
        }
        // 状态机定义中统一规定无论何种状态下seek，seek成功以后变为playing状态
        if (!this._video.paused) {
            // 如果不是暂停状态（播放状态下拖动），强行恢复到playing状态
            // （一般浏览器都会在seeked事件以后紧跟canplay、playing事件出来，少数浏览器保持seeked状态。但强行设置playing状态也没关系，如果后续
            // 又来canplay、playing状态都不会覆盖已经强行设置的playing状态，因为不符合状态表而被过滤）
            this.stateMgr.setPlaying();
            return;
        }
        // 如果是暂停状态下seek，结束以后也恢复播放
        if (!this._config.remainPauseStateAfterSeek) {
            // 但这里除开一种情况，外部指定要保留暂停状态！
            this.videoplay();
        }
    };
    BaseVideoNode.prototype.pauseInner = function (type) {
        var _a;
        if (type === void 0) { type = PauseType.INNER; }
        this._logger.log("pause(), uid=".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/state=").concat(this.state, "/idx=").concat(this.idx, "/type=").concat(type));
        this._pauseType = type;
        this._video.pause();
    };
    BaseVideoNode.prototype.setEndInner = function () {
        if (this._state !== VideoState.END && this._state !== VideoState.IDLE) {
            this._logger.log("setEndInner(), idx=".concat(this._idx, "/uid=").concat(this._videoInfo.uid, "/playtime=").concat(this._videoInfo.playtime)
                + "/duration=".concat(this._videoInfo.duration, "}"));
            // 这里不能直接停止（调用videoNode的stop），因为在列表播放时，即使当前视频停止，也可能会append地址进来继续播放，需要复用一些变量。
            // （参考代码位置①来理解）
            this.stateMgr.setEnded(); // 本段播放结束
            this.emit(VideoNodeEvent.PLAY_OVER, {
                isUserStop: false,
                endState: EndState.NORMAL,
                videoInfo: this._videoInfo,
            });
        }
    };
    BaseVideoNode.prototype.stopInner = function (keepState, videoInfo) {
        var _a;
        if (!this._video || !this._videoInfo) {
            return;
        }
        this.setMainLoopEnable(false);
        this.setCheckLoadTimeoutEnable(false);
        // 停掉之后直接重置seek标记
        this._isUserSeek = false;
        this._logger.log("stopInner(), uid/state/idx: ".concat((_a = this._videoInfo) === null || _a === void 0 ? void 0 : _a.uid, "/").concat(this.state, "/").concat(this.idx));
        this.setVideoEvents(false);
        if (this._config.clearVideoAfterStop) {
            // 调用videoTool.clear接口清除video标签画面
            videoTool.clear(this._video);
        }
        else {
            // 如果保留画面，播放结束仅暂停，等下一次load时才会清理
            this._video.pause();
        }
        if (this._config.createVideoNodeWhenLoad) {
            // 如果确定是load时会重新创建新的VideoNode，那么此VideoNode在停止时需要释放video标签。
            this._video.dataset.used = VideoElementState.FREE;
        }
        if (this._videoInfo) {
            this._videoInfo.extraVars.isLoadstarted = false;
            this._videoInfo = null;
        }
        if (this._pauseCloseToEndStateCheckTimeoutId > 0) {
            window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
            this._pauseCloseToEndStateCheckTimeoutId = 0;
        }
        if (this.state === VideoState.IDLE) {
            // 当前视频段已经播放结束，状态机被重置为idle。但是并没有清除videoInfo等变量。如果重播，会默认调用stop方法，导致
            // 重复的end、idle状态变化，类似end -> idle -> （重播）-> end -> idle。return语句排除这种情况。
            // （参考代码位置①）
            return;
        }
        if (!keepState) {
            this.stateMgr.setEnded();
            this._played = false;
            // 不保持状态的时候，才会清理正在切清晰度的变量。
            // （例如切换清晰度时出错，会重试备份地址，调用stopInner传入keepState为true，此时还在切清晰度，不能清理此变量）
            this._levelSwitchingDefer = null;
            if (videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error) {
                this.emit(VideoNodeEvent.ERROR, { videoInfo: videoInfo });
            }
        }
    };
    /** 更新视频尺寸 */
    BaseVideoNode.prototype.updateVideoSize = function (isNativeEvt) {
        if (isNativeEvt === void 0) { isNativeEvt = false; }
        var vw = this._video.videoWidth;
        var vh = this._video.videoHeight;
        if (this._videoInfo && (this._videoInfo.videoWidth !== vw || this._videoInfo.videoHeight !== vh)) {
            this._videoInfo.videoWidth = vw;
            this._videoInfo.videoHeight = vh;
            this.emit(VideoNodeEvent.VIDEO_RESIZE, { videoInfo: this._videoInfo, isNative: isNativeEvt });
            this.videoResizeAutoFill.resizeAutoFill();
        }
    };
    /** 当播放状态变化时设置loading动画是否展示 */
    BaseVideoNode.prototype.setLoadingOnStateChange = function () {
        // 未开播之前的状态变化，都不显示loading
        if (!this._played) {
            this.loading.hide();
            return;
        }
        // 播放中缓冲和开始Seek状态需要显示loading动画
        if ([VideoState.BUFFERING, VideoState.SEEKING].includes(this._state)) {
            var delayTimeMS = 500;
            // 变为seeking、buffering等状态，显示loading动画，但是延迟一定时间展示，避免出现loading动画很快出现又消失
            this.loading.show(delayTimeMS);
            return;
        }
        // 下面逻辑判断何时去掉loading动画
        if (
        // 直播只有canplay状态才去掉loading动画，[注意]直播时canplay不去掉loading动画的原因是：
        // 当某些浏览器（wechat-ios）不支持自动播放时调用load接口无法加载数据，BaseVideoNode会强行派发一个canplay状态出去，然后等用户点击
        // 用户点击播放以后调用play，此时才真正开始加载数据并播放。此种场景如果canplay状态去掉了loading动画，play以后就会有较长时间的黑屏而
        // 没有loading，体验较差。因此，直播在canplay的时候不去掉loading动画，而是在autoplayBlock/playing两种情况下去掉。这样可以保证体验
        (this._config.type === PlayMode.LIVE && VideoState.CANPLAY !== this._state)
            // 点播除了上面的buffering和seeking状态，都不显示
            || this._config.type === PlayMode.VOD) {
            this.loading.hide();
        }
    };
    /**
     * 出错时的处理函数
     * @param errorData 原始错误数据
     */
    BaseVideoNode.prototype.errorHandler = function (errorData) {
        var error = this.parseErrorData(errorData);
        this._logger.log('video encounter error', error);
        var isCurrentPositionBuffered = videoTool.isPositionBuffered(this._video);
        this._logger.log("current position buffered=".concat(isCurrentPositionBuffered));
        if (!isCurrentPositionBuffered) {
            this._logger.warn('current position is not buffered, check close range');
            this._logger.warn("next buffered start=".concat(videoTool.getNextBufferedStart(this._video)));
            this._logger.warn("last buffered end=".concat(videoTool.getLastBufferedEnd(this._video)));
        }
        // 开始执行重试
        this.retryWhenError(error);
    };
    BaseVideoNode.prototype.retryWhenError = function (error) {
        // 需要先存一下，避免stopInner()把this._videoInfo置空
        var nextVideoInfo = this._videoInfo;
        var retryUrlRet = this.setRetryUrl(nextVideoInfo);
        // 根据url上的过期时间戳判断urlconfig是否可用
        var expireTimeStamp = nextVideoInfo.config.expireTimeStamp;
        var isUrlExpired = typeof expireTimeStamp === 'undefined' ? false : (expireTimeStamp < +new Date());
        if (this._videoInfo.stateWhenErrorHappen === null) {
            // 连续重试只记录一次，因此要判断下null
            this._videoInfo.stateWhenErrorHappen = this._state;
        }
        // 不是最终错误 && urlconfig没有过期 && 有下一个重新地址，这几个条件满足时重试
        if (!error.fatal && !isUrlExpired && retryUrlRet) {
            var retryCount = nextVideoInfo.getRetryCount();
            this._logger.log('retryOnError(), retryCount=', retryCount);
            this.emit(VideoNodeEvent.RETRY, __assign({ error: error, retryCount: retryCount, videoInfo: nextVideoInfo }, retryUrlRet));
            this.stopInner(true);
            // 重试的话强行进入buffering状态
            this.stateMgr.setWaiting();
            // 上一句扭转的buffering状态可能不成功（例如是seeking状态卡死导致的重试），所以在出错重试时强制显示loading动画
            if (this._state !== VideoState.BUFFERING) {
                this.loading.show();
            }
            this.doRetry(nextVideoInfo);
            return;
        }
        this._logger.log('retryOnError(), fatal.');
        // 无法执行重试，最终失败
        this._videoInfo.error = error;
        // 如果正在切换清晰度，reject promise，抛出异常
        if (this._levelSwitchingDefer) {
            this._levelSwitchingDefer.reject(error);
        }
        this.stopInner(false, this._videoInfo);
    };
    /**
     * 从各种内核的原始信息中解析出的标准的错误信息，basenode只处理未知和标准video错误转换，其他内核需要自行复写
     * @param errorData 原始错误数据
     * @returns 处理过的错误信息
     */
    BaseVideoNode.prototype.parseErrorData = function (errorData) {
        var _a, _b;
        // 注意这里return IVideoError是为了兼容还没有实现ErrorBase的内核
        if (errorData) {
            // 这里将errorData全部标准化为ErrorBase的格式，方便后续处理
            return commonErrorParse(errorData);
        }
        // 如果没有任何错误信息，尝试从video标签上获取，如果还是没有则视为未知错误
        return (_b = getVideoError(this._video, (_a = this._config) === null || _a === void 0 ? void 0 : _a.instanceId)) !== null && _b !== void 0 ? _b : PlayerError.NativeError({
            code: 0 /* PlaybackErrorCode.UNKNOWN_ERR */,
            fatal: false,
            message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
            debugMessage: jsonTool.safelyStringify(this._video.error),
        });
    };
    /** 开始执行重试 */
    BaseVideoNode.prototype.doRetry = function (videoInfo) {
        // 重试的时间获取：
        // 如果video组建时间大于0先拿video组件上的时间，再拿videoInfo的playtime兜底。这是因为seek操作时候如果出现错误重试，videoInfo上的
        // playtime并没有更新，但是video.currentTime已经被设置过来了，video.currentTime就是重试后真实起播点
        var playtime = videoInfo.playtime, stateWhenErrorHappen = videoInfo.stateWhenErrorHappen;
        var retryPlaytime = this._video.currentTime > 0 ? this._video.currentTime : playtime;
        var startTime = this._played ? retryPlaytime : this._userStartTime;
        this._logger.log("do retry [url], stateWhenErrorHappen=".concat(stateWhenErrorHappen));
        // 注意，这个地方要把重试的时间复制回videoInfo上，避免连续失败无法获取时间的问题
        videoInfo.playtime = startTime;
        if (!this._played || stateWhenErrorHappen === VideoState.PAUSE) {
            this.load(videoInfo, { startTime: startTime });
        }
        else {
            this.play(videoInfo, { startTime: startTime });
        }
    };
    /**
     * 给IVideoInfo设置准备重试的地址
     * @param vinfo IVideoInfo对象
     * @returns 返回设置重试地址的结果，其中包含设置前和设置后的地址。如果设置失败，返回null值
     */
    BaseVideoNode.prototype.setRetryUrl = function (vinfo) {
        var loadingUrl = vinfo.loadingUrl;
        var prevUrl = loadingUrl;
        var hasNextBackup = vinfo.setNextBackUrl();
        if (hasNextBackup) {
            return { prevUrl: prevUrl, curUrl: vinfo.loadingUrl };
        }
        return null;
    };
    /**
     * 转发内核特殊事件，例如hls内核中，外部可能会监听hls.js事件抛出的一些数据。
     * <br>[注意]需要说明的是，我们使用全局的evtBus来派发内核特殊事件，为了避免多个播放器实例的事件串了，我们会在抛出的数据中携带播放器实例的id
     * @param evt 事件名称
     * @param data 事件数据
     */
    BaseVideoNode.prototype.emitKernelEvt = function (evt, data) {
        kernelEvtBus.emit(evt, __assign(__assign({}, data), { playerInstanceId: this.config.instanceId }));
    };
    BaseVideoNode.prototype.adjustSeekTime = function (time) {
        var targetTime = time;
        if ((uaTool.browser.x5 || uaTool.browser.safari) && Math.abs(targetTime - this._videoInfo.duration) <= 1) {
            // bug：
            // safari / x5下可能出现直接seek到视频的最结尾（seek时间等于视频时长）后，video不发出end事件出来，所以检测如果这种情况，把time值回退1s
            targetTime = this._videoInfo.duration - 1;
        }
        return targetTime;
    };
    __decorate([
        logMethodCall$6,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "pause", null);
    __decorate([
        logMethodCall$6,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "stop", null);
    __decorate([
        logMethodCall$6,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "destroy", null);
    __decorate([
        logMethodCall$6
        /**  切换清晰度，这里的mode是为了其他内核的video-node扩展用*/
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], BaseVideoNode.prototype, "setLevel", null);
    __decorate([
        logMethodCall$6,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BaseVideoNode.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall$6
        /** 设置检测首缓超时的计时器，在canplay和playing中都会尝试清除计时器 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "setCheckLoadTimeoutEnable", null);
    __decorate([
        logMethodCall$6
        /** 内部在实现逻辑时调用pause方法，例如切换清晰度可能会先暂停视频，再跳到下一个视频播放，此时收到的pause事件不需要对外抛出。 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "pauseInner", null);
    __decorate([
        logMethodCall$6
        /** 根据某些条件设置视频播放结束并做一些处理 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "setEndInner", null);
    __decorate([
        logMethodCall$6
        /** 内部停止播放，如果keepState为true，既不会扭转状态，也不会对外发出事件。如有错误信息则会对外抛出错误事件 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Object]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "stopInner", null);
    __decorate([
        logMethodCall$6
        /**
         * 在播放出错时尝试执行重试，如果超过最大重试次数则停止播放
         * @param error 错误信息
         */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BaseVideoNode.prototype, "retryWhenError", null);
    return BaseVideoNode;
}(EvtEmitter));

var logMethodCall$5 = logMethodCallDecoratorCreator('OrgVideoNode');
/**
 * 使用原生的video标签播放单个视频。
 */
var OrgVideoNode = /** @class */ (function (_super) {
    __extends(OrgVideoNode, _super);
    function OrgVideoNode(config) {
        var _this = _super.call(this, config) || this;
        _this._logger = new Logger(config.instanceId, 'OrgVideoNode');
        return _this;
    }
    OrgVideoNode.prototype.onVideoEventCanplay = function () {
        var _a;
        (_a = this.canplayDefer) === null || _a === void 0 ? void 0 : _a.resolve();
        _super.prototype.onVideoEventCanplay.call(this);
    };
    OrgVideoNode.prototype.onVideoEventLoadedmetadata = function () {
        _super.prototype.onVideoEventLoadedmetadata.call(this);
        if ((uaTool.os.ios || uaTool.browser.safari)
            && [PreloadType.META_DATA, PreloadType.AUTO].includes(this._config.preloadType)) {
            // ios和mac safari如果是只加载头部数据，不会发出canplay事件。这时候就需要强制成canplay，然后才可以清除预加载超时，并能触发播放
            this.onVideoEventCanplay();
        }
    };
    OrgVideoNode.prototype.onVideoEventLoadeddata = function () {
        _super.prototype.onVideoEventLoadeddata.call(this);
        // ios要在canplay以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
        this.checkPlayInitSeek();
    };
    OrgVideoNode.prototype.onVideoEventTimeUpdate = function () {
        _super.prototype.onVideoEventTimeUpdate.call(this);
        // x5要在timeupdate以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
        this.checkPlayInitSeek();
    };
    OrgVideoNode.prototype.onVideoEventLoadStart = function () {
        this.resolveWaitVideoLoadStartEvt();
    };
    OrgVideoNode.prototype.load = function (videoInfo, opts) {
        var _this = this;
        if (!videoInfo.loadingUrl) {
            return false;
        }
        this.stopInner(true);
        this._drm.init(videoInfo.config.drmConfig);
        this._videoInfo = videoInfo;
        this._videoInfo.extraVars.isLoadstarted = true;
        this.setVideoEvents(true);
        this.stateMgr.setLoadStart();
        this.assignStartTime((opts === null || opts === void 0 ? void 0 : opts.startTime) || 0);
        NetTiming.observer(this._config.instanceId, {
            url: this._videoInfo.loadingUrl,
            tag: "".concat(this._videoInfo.uid, "_video"),
            callback: function (entry) {
                _this._logger.log('loading url perf entry, ', entry);
            },
        });
        this._video.src = this._videoInfo.loadingUrl;
        this._logger.log("load(), uid=".concat(this._videoInfo.uid));
        if (this._config.preloadType === PreloadType.AUTO_LOAD) {
            this._video.load();
        }
        this.setCheckLoadTimeoutEnable(true);
        this.canplayDefer = new SimpleDefer();
        this.waitVideoLoadStartEvt()
            .then(function () {
            // 收到了loadStart事件
            _this._logger.log('load(), video load succ...');
        })
            .catch(function () {
            _this._logger.error('load(), video load cannot be trigger...');
            // 没收到loadStart事件，等待超时
            _this.onVideoEventCanplay();
        });
        return true;
    };
    OrgVideoNode.prototype.play = function (videoInfo, opts) {
        var _this = this;
        this._logger.log("play(), uid=".concat(videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.uid, "/idx=").concat(this.idx, "/state=").concat(this.state));
        this._played = true;
        if (videoInfo && !videoInfo.extraVars.isLoadstarted) {
            // 如果没有开始加载，尝试加载视频
            this.load(videoInfo, opts);
        }
        var playPromise = null;
        if (uaTool.browser.safari && this.canplayDefer) {
            // 调用load以后，如果马上play，目前safari会无法检测到自动播放，因此safari的话等canplay后再调用play播放
            // 看下面示例代码在safari中的运行可以看到这里修改的原因
            // var videoTag = document.querySelector('video');
            // videoTag.src = '//' + location.host + '/assets/u3139lwnb4l.mp4'
            // videoTag.load();
            // // 如果马上调用
            // videoTag.play().catch(function (e) {
            //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);// AbortError, The operation was aborted
            // });
            // // 如果在canplay后调用
            // videoTag.addEventListener('canplay', function() {
            //   videoTag.play().catch(function (e) {
            // NotAllowedError, The request is not allowed by ...
            //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);
            // });
            // // })
            this.canplayDefer.promise.then(function () {
                _this.videoplay();
            });
        }
        else {
            playPromise = this.videoplay();
        }
        this.setMainLoopEnable(true);
        return playPromise;
    };
    /**
     * 指定起播时间
     * @param startTime 起播时间点
     * @returns void
     */
    OrgVideoNode.prototype.assignStartTime = function (startTime) {
        if (this._config.type === PlayMode.LIVE) {
            // 指定起播点只有点播模式下才生效
            return;
        }
        this._userStartTime = startTime;
        var playtime = !Number.isNaN(startTime) && startTime >= 0 ? startTime : 0;
        if (playtime <= 0) {
            return;
        }
        if (videoTool.supportMediaFragmentsURISpec(this._config.enableMediaFragmentsURI)
            && !this._videoInfo.loadingUrl.startsWith('blob:')) {
            this._logger.log('assignStartTime by #t');
            // url直接指定#t参数，但blob地址不支持指定播放起点
            this._videoInfo.setLoadingUrlStartTime(playtime);
        }
        else {
            this._logger.log('assignStartTime with seek()');
            // 开播以后seek到目标点
            this.needPlaySeektime = playtime;
        }
    };
    OrgVideoNode.prototype.checkPlayInitSeek = function () {
        if (this.needPlaySeektime > 0 && this._videoInfo && this._video.duration > 0) {
            // 判断的最后一个条件是因为一般video的duration<=0时都无法seek
            this._logger.log("checkPlayInitSeek(), idx=".concat(this.idx, "/seektime=").concat(this.needPlaySeektime));
            this.seek(this.needPlaySeektime);
            this.needPlaySeektime = 0;
        }
    };
    OrgVideoNode.prototype.stopInner = function (keepState, videoInfo) {
        this.canplayDefer = null;
        this.needPlaySeektime = 0;
        if (this._config && this._videoInfo) {
            NetTiming.unobserver(this._config.instanceId, {
                tag: "".concat(this._videoInfo.uid, "_video"),
            });
        }
        _super.prototype.stopInner.call(this, keepState, videoInfo);
    };
    OrgVideoNode.prototype.seek = function (value, isUser) {
        if (isUser === void 0) { isUser = false; }
        var time = value;
        if (!this.checkCanSeek(time, isUser)) {
            return false;
        }
        time = this.adjustSeekTime(time);
        this._isUserSeek = isUser;
        this._logger.log("seek(), uid".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/time=").concat(time, "/duration=").concat(this._video.duration, "/")
            + "state=".concat(this.state));
        this._targetSeekTime = time;
        this._video.currentTime = time;
        return true;
    };
    OrgVideoNode.prototype.updateAccuratePlaytime = function () {
        _super.prototype.updateAccuratePlaytime.call(this);
        var leftTime = Math.abs(this._video.duration - this._video.currentTime);
        var advanceEndTime = this._config.originKernelConfig.advanceEndTime;
        if (advanceEndTime > 0 && leftTime <= advanceEndTime) {
            // 根据配置的时间提前结束当前的播放
            this._logger.log('setEndInner(), reason=leftTimeCheck');
            this.setEndInner();
        }
    };
    OrgVideoNode.prototype.setEndInner = function () {
        if (this.state !== VideoState.END && this.state !== VideoState.IDLE) {
            if (this.onAccurateTimeupdate) {
                this.onAccurateTimeupdate(0);
            }
            this.updatePlaytime(this._video.currentTime); // 更新更精确的时间
        }
        _super.prototype.setEndInner.call(this);
    };
    /**
   * ios的微信浏览器和x5浏览器在没有用户手势之前，调用video.load()接口，并不会有数据请求，也不会收到video组件的loadStart、canplay事件。
   * 因此我们等待一下video组件的loadStart事件，如果收到了，说明触发了数据加载，可以成功触发后续的canplay事件。但是如果一定时间后没有收到
   * loadStart事件，那么可以判断video.load()接口调用并没有任何反应。
   */
    OrgVideoNode.prototype.waitVideoLoadStartEvt = function () {
        var _this = this;
        this.waitVideoLoadStartEvtDefer = new SimpleDefer();
        // 50ms后都没有收到loadStart事件，说明video组件在调用load以后并不会触发加载行为
        var WAIT_TIME_MS = 50;
        window.setTimeout(function () {
            if (_this.waitVideoLoadStartEvtDefer.state !== 'rejected') {
                _this.waitVideoLoadStartEvtDefer.reject();
            }
        }, WAIT_TIME_MS);
        return this.waitVideoLoadStartEvtDefer.promise;
    };
    OrgVideoNode.prototype.resolveWaitVideoLoadStartEvt = function () {
        if (this.waitVideoLoadStartEvtDefer) {
            this.waitVideoLoadStartEvtDefer.resolve();
        }
    };
    __decorate([
        logMethodCall$5,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "play", null);
    __decorate([
        logMethodCall$5,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "stopInner", null);
    __decorate([
        logMethodCall$5
        /**
         * seek操作。
         * 【注意】修改：调用load，未调用play，此时played为false，此时也允许seek
         */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number, Object]),
        __metadata("design:returntype", void 0)
    ], OrgVideoNode.prototype, "seek", null);
    return OrgVideoNode;
}(BaseVideoNode));

var logMethodCall$4 = logMethodCallDecoratorCreator('OrgIOSVideoNode');
// 暂停的阈值时长
var PAUSE_TIME_THRESHOLD = 5 * 1000;
/**
 * iOS 原生播放专用 VideoNode，用于兼容 iOS 播放中的 bug
 */
var OrgIOSVideoNode = /** @class */ (function (_super) {
    __extends(OrgIOSVideoNode, _super);
    function OrgIOSVideoNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 上次调用 pause 时的播放时间 */
        _this.lastPausePlayTime = null;
        /** 上次调用 pause 时的时间戳 */
        _this.lastPauseTimeStamp = null;
        /** 是否屏蔽 seek 事件 */
        _this.disableSeekEvt = false;
        return _this;
    }
    Object.defineProperty(OrgIOSVideoNode, "shouldUseResumeFix", {
        /**
         * 是否启用 Bug 兼容处理：https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
         * iOS 15 ，如果 < iOS 15.0 则不做处理
         */
        get: function () {
            return uaTool.os.ios
                && commonTool.compareVersion(uaTool.os.version, '15.0') >= 0;
        },
        enumerable: false,
        configurable: true
    });
    OrgIOSVideoNode.prototype.setLevel = function (mode) {
        if (mode === void 0) { mode = SetLevelMode.HARD; }
        this.clearPauseMemTime();
        return _super.prototype.setLevel.call(this, mode);
    };
    OrgIOSVideoNode.prototype.onVideoEventPause = function () {
        /**
         * Webkit Bug:
         * 这里 iOS 15 存在一个 Bug，当暂停播放后，将浏览器切换到后台约 10s，再切回来播放
         * 则起播时间和上次暂停的不一致，起播时间可能会增加 0.5 ~ 3分钟
         * @see https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
         */
        if (this.isOriginHlsPlaying()) {
            this.lastPausePlayTime = this._video.currentTime;
            this.lastPauseTimeStamp = Date.now();
        }
        return _super.prototype.onVideoEventPause.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventSeeking = function () {
        this.clearPauseMemTime();
        if (this.disableSeekEvt) {
            return;
        }
        return _super.prototype.onVideoEventSeeking.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventSeeked = function () {
        if (this.disableSeekEvt) {
            this.disableSeekEvt = false;
            return;
        }
        _super.prototype.onVideoEventSeeked.call(this);
    };
    OrgIOSVideoNode.prototype.onVideoEventPlaying = function () {
        // 如果是特定版本的 iOS 设备，在起播时，如果 pause 的时间超过阈值，则强行 seek 回来
        if (OrgIOSVideoNode.shouldUseResumeFix
            && this.lastPausePlayTime
            && Date.now() - this.lastPauseTimeStamp > PAUSE_TIME_THRESHOLD) {
            this.disableSeekEvt = true;
            this._video.currentTime = this.lastPausePlayTime;
        }
        this.clearPauseMemTime();
        return _super.prototype.onVideoEventPlaying.call(this);
    };
    OrgIOSVideoNode.prototype.clearPauseMemTime = function () {
        this.lastPausePlayTime = null;
        this.lastPauseTimeStamp = null;
    };
    /**
     * 从 loadingURL 判断是否在原生播放 HLS
     * @return 是否为 hls
     */
    OrgIOSVideoNode.prototype.isOriginHlsPlaying = function () {
        var loadingUrl = this.currentVideoInfo.loadingUrl;
        var ext = urlTool.getFileExtension(loadingUrl);
        return fileExtension2VideoType(ext) === VideoType.HLS;
    };
    __decorate([
        logMethodCall$4,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], OrgIOSVideoNode.prototype, "setLevel", null);
    return OrgIOSVideoNode;
}(OrgVideoNode));

/**
 * 播放的视频流流探测
 */
function detectStream(url) {
    return __awaiter(this, void 0, void 0, function () {
        var detectData, _a, data, target, startTimestamp, downloadSize, downloadCostTime, e_1, catchData, error, target;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    detectData = { httpCode: -1 };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, netTool.xhr({
                            url: url,
                            retryCount: 0,
                            responseType: 'arraybuffer',
                            range: [0, 102400],
                        })];
                case 2:
                    _a = _b.sent(), data = _a.data, target = _a.target, startTimestamp = _a.startTimestamp;
                    detectData.httpCode = target.status;
                    downloadSize = data.byteLength / 1024;
                    downloadCostTime = (+new Date() - startTimestamp) / 1000;
                    detectData.downloadSpeed = "".concat(Math.floor(downloadSize / downloadCostTime), "kb/s");
                    try {
                        detectData.headers = target.getAllResponseHeaders();
                    }
                    catch (e) { }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    catchData = e_1 || {};
                    error = catchData.error, target = catchData.target;
                    detectData.httpCode = target === null || target === void 0 ? void 0 : target.status;
                    detectData.error = error;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, detectData];
            }
        });
    });
}

var i18nCore = i18nConfig.core;
/**
 * basePlayer播放状态检查类
 */
var CheckPlayerStatus = /** @class */ (function () {
    function CheckPlayerStatus(player) {
        var _this = this;
        this.setLevelValidator = {
            NOT_INITIALIZED: function () {
                if (!_this.player) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_NOT_INITIALIZED) };
                }
                return VALIDATE_PASS_RESULT;
            },
            NOT_PLAYING: function () {
                if (!_this.player.played) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_NOT_PLAYING) };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_URL: function (setLevelUrl) {
                if (!setLevelUrl) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_EMPTY_URL) };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_VIDEO_INFO: function () {
                if (!_this.player.currentVideoInfo) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_VIDEO_INFO) };
                }
                return VALIDATE_PASS_RESULT;
            },
            PLAYTIME_CHECK: function () {
                if (_this.player.currentVideoInfo.playtime <= 0) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_PLAYTIME_CHECK) };
                }
                return VALIDATE_PASS_RESULT;
            },
            CLOSE_TO_END: function () {
                var videoInfo = _this.player.currentVideoInfo;
                if (_this.player.config.type === PlayMode.VOD
                    && videoInfo.playtime + 1 >= videoInfo.duration
                    && videoInfo.duration !== Infinity) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_CLOSE_TO_END) };
                }
                return VALIDATE_PASS_RESULT;
            },
            TARGET_NOT_CHANGE: function (setLevelUrl) {
                var currentVideoInfo = _this.player.currentVideoInfo;
                if (setLevelUrl === currentVideoInfo.loadingUrl) {
                    return { isValid: false, message: compile(i18nCore.ERROR_STATUS_TARGET_UNCHANGED) };
                }
                return VALIDATE_PASS_RESULT;
            },
        };
        this.player = player;
    }
    /**
     * 默认选择清晰度切换模式
     * @param vnlistLen videoNode列表个数
     * @param forceSetLevelMode 外部强制指定的清晰度切换模式
     * @returns 清晰度切换模式
     */
    CheckPlayerStatus.prototype.checkSetLevelMode = function (vnlistLen, forceSetLevelMode) {
        if (vnlistLen < 2) {
            // 如果小于两个video标签，只能黑屏切换清晰度
            return SetLevelMode.HARD;
        }
        if (forceSetLevelMode) {
            return forceSetLevelMode;
        }
        return SetLevelMode.SOFT;
    };
    /**
     * 检测是否当前满足append环境条件
     * @param urlConfig 待append的视频URL对象
     * @returns {canAppend:boolean,message:string}canAppend表示是否支持Append，message表示具体信息描述和不能append原因
     */
    CheckPlayerStatus.prototype.checkCanAppend = function (urlConfig) {
        var _a;
        // basePlayer或相关配置为空，不能拼接或者预加载
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.config)) {
            return {
                canAppend: false,
                message: 'BasePlayer or basePlayer.config is null',
            };
        }
        // 如果不是List播放，不能拼接或者预加载
        if (!this.player.config.isPlayList) {
            return {
                canAppend: false,
                message: 'Only supported when [isPlayList] is true',
            };
        }
        // 如果尚未起播过，不能拼接或者预加载
        if (!this.player.played) {
            return {
                canAppend: false,
                message: 'Player has not been played',
            };
        }
        // 检查UrlConfig作为参数时是否是合法的，如果返回错误，也不能拼接或者预加载
        var checkUrlConfigError = checkUrlConfigVailed(urlConfig);
        if (checkUrlConfigError) {
            return {
                canAppend: false,
                message: "urlconfig err=".concat(checkUrlConfigError),
            };
        }
        return {
            canAppend: true,
            message: 'Can append video now',
        };
    };
    /**
     * 检测是否当前满足preload环境条件
     * @param urlConfigs 待preload的视频UrlConfig数组对象
     * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
     */
    CheckPlayerStatus.prototype.checkCanPreloadEnvi = function (urlConfigs) {
        // 判断条件与checkCanAppend相同，复用逻辑
        var preloadDetail = this.checkCanAppend(urlConfigs);
        if (!preloadDetail.canAppend) {
            return {
                canPreload: false,
                message: preloadDetail.message,
            };
        }
        // 继承是否支持逻辑判断
        if (!this.player.supportPreload) {
            return {
                canPreload: false,
                message: 'preloadNext() fail, browser not support preload.',
            };
        }
        return {
            canPreload: true,
            message: 'Can preload video now',
        };
    };
    /**
     * 检查单个UrlConfig是否当前满足preload播放条件
     * @param urlConfig 待preload的视频URL对象
     * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
     */
    CheckPlayerStatus.prototype.checkCanPreloadEachConfig = function (urlConfig) {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.videoInfos)) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, because player or videoInfo is null.',
            };
        }
        var idx = this.player.videoInfos.findIndex(function (value) { return compareUrlConfig(value.config, urlConfig); });
        // 已经播放过了，没必要预加载了
        if (idx !== -1 && idx <= this.player.curUrlIdx) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, because this videoInfo has been played.',
            };
        }
        // 如果跨过下一个视频预加载下下个，或者下下下个视频，是不允许的
        if (idx !== -1 && idx > this.player.curUrlIdx + 1) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, can not skip next to preload.',
            };
        }
        // 如果列表中有下一个播放地址，而预加载的又不是下一个，那就没必要了吧
        // 如果basePlayer.nextVideoInfo为空，可能存在新的视频信息逻辑，所以此处nextVideoInfo必须存在
        if (this.player.nextVideoInfo && !compareUrlConfig(this.player.nextVideoInfo.config, urlConfig)) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, the next has been appended, you only can preload next.',
            };
        }
        // 已经在预加载列表中了
        var index = this.player.preloadVideoInfos.findIndex(function (value) { return compareUrlConfig(value.config, urlConfig); });
        var hasPreload = index !== -1;
        if (hasPreload) {
            return {
                canPreload: false,
                message: 'preloadInner() fail, the VideoInfo has been preloaded.',
            };
        }
        return {
            canPreload: true,
            message: 'Can preload video now',
        };
    };
    /**
     * 判断当前播放器切换清晰度外在条件是否满足，并返回对应信息（展示在tips上）
     * @param levelUrl 切换的目标URL
     * @returns 返回描述信息，如果为null代表满足条件
     */
    CheckPlayerStatus.prototype.checkSetLevelError = function (levelUrl) {
        var validateResult = runValidators(Object.values(this.setLevelValidator), function (validatorRunner) { return validatorRunner(levelUrl); });
        if (!validateResult.isValid) {
            return validateResult.message;
        }
        return null;
    };
    /**
     * 检查列表播放是否需要继续播放下一个视频
     * @returns {canPlayNext:boolean,message:string} 是否可以继续播放下一个视频
     */
    CheckPlayerStatus.prototype.checkCanPlayNext = function () {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.videoInfos)) {
            return {
                canPlayNext: false,
                message: 'Player or player.videoInfo is null',
            };
        }
        if (!this.player.played) {
            return {
                canPlayNext: false,
                message: 'Player has not been played',
            };
        }
        if (!this.player.nextVideoInfo) {
            // list播放完毕
            return {
                canPlayNext: false,
                message: "Playlist over>>>, total len: ', ".concat(this.player.videoInfos.length),
            };
        }
        return {
            canPlayNext: true,
            message: "checkPlayNext(), curUrlIdx=".concat(this.player.curUrlIdx, "/urlLength=").concat(this.player.videoInfos.length, "/")
                + "nextStartTime: ".concat(this.player.nextVideoInfo.playtime),
        };
    };
    /**
     * 检查是否自动预加载下一个视频
     * @param leftTime 离上一个视频播放的结束时间
     * @returns {canPreload:boolean,message:string} 是否可预加载下一个视频
     */
    CheckPlayerStatus.prototype.checkAutoPreloadNext = function (leftTime) {
        var _a;
        if (!((_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)) {
            return {
                canPreload: false,
                message: 'Player or player.currentVideoInfo is null',
            };
        }
        if (!this.player.nextVideoInfo || this.player.preloadVideoInfos.indexOf(this.player.nextVideoInfo) !== -1) {
            return {
                canPreload: false,
                message: 'nextVideoInfo is null or nextVideoInfo is already preload now',
            };
        }
        var autoPreloadLeftTime = this.player.currentVideoInfo.config.autoPreloadLeftTime;
        if (autoPreloadLeftTime <= 0) {
            return {
                canPreload: false,
                message: 'Can not preload,autoPreloadLeftTime <= 0',
            };
        }
        // 如果指定的时间大于等于时长，那么只要当前视频时间大于0就会尝试预加载下一个
        if ((autoPreloadLeftTime >= this.player.currentVideoInfo.duration && this.player.currentVideoInfo.playtime > 0)
            || autoPreloadLeftTime >= leftTime) {
            return {
                canPreload: true,
                message: 'Can preload now',
            };
        }
        return {
            canPreload: false,
            message: 'Can not preload,autoPreloadLeftTime is illegal',
        };
    };
    /** 销毁 */
    CheckPlayerStatus.prototype.destroy = function () {
        this.player = null;
    };
    return CheckPlayerStatus;
}());

/**
 * 激活屏幕常亮管理类，确保在播放过程中不息屏
 */
var ScreenWakeLock = /** @class */ (function () {
    function ScreenWakeLock() {
        this.wakeLock = null;
    }
    Object.defineProperty(ScreenWakeLock.prototype, "isAlive", {
        /**
         * 获取当前是否激活睡眠锁状态
         */
        get: function () {
            return !!this.wakeLock;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 设置激活睡眠锁状态
     */
    ScreenWakeLock.prototype.keepAlive = function (alive) {
        if (alive) {
            return this.requestWakeLock();
        }
        return this.realseWakeLock();
    };
    /**
     * 激活机器睡眠锁，避免息屏，保持观看中屏幕常亮
     */
    ScreenWakeLock.prototype.requestWakeLock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.wakeLock) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, window.navigator.wakeLock.request('screen')];
                    case 2:
                        _a.wakeLock = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        // 在某些情况下保持常亮会失败，例如低电量模式等
                        // 但即使失败也无需处理，因为用户不感知，也无需提示
                        this.wakeLock = null;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * 释放机器睡眠锁
    */
    ScreenWakeLock.prototype.realseWakeLock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.wakeLock) {
                    return [2 /*return*/];
                }
                this.wakeLock.release();
                this.wakeLock = null;
                return [2 /*return*/];
            });
        });
    };
    return ScreenWakeLock;
}());

/** guid随机串的长度 */
var GUID_LEN = 8;
/**
 * 一个url地址对应的播放对象
 * @class
 */
var VideoInfo = /** @class */ (function () {
    /**
     * 视频信息。在播放列表中，每个播放节点都对应一个视频信息。
     */
    function VideoInfo(opts, playerConfig) {
        this.playtime = 0;
        this.currentAudioTrack = NaN;
        this.duration = 0;
        this.performance = {};
        this.startTime = 0;
        this.state = VideoState.IDLE;
        this.fileSize = 0;
        this.videoWidth = 0;
        this.videoHeight = 0;
        this.hasFirstPlaying = false;
        this.startPts = 0;
        this.discontinuityTimeRanges = [];
        this.videoFrameRate = 0;
        this.audioTracks = [];
        this.currentLevelIndex = -1;
        this.levels = [];
        this.currentLevel = null;
        this.isAutoLevel = false;
        this.stateWhenErrorHappen = null;
        this.logger = new Logger(playerConfig.instanceId, 'VideoInfo');
        this.extraVarsInner = {};
        this.qualityInfoInner = {};
        this.uidInner = commonTool.createGUID(GUID_LEN);
        this.configInner = opts;
        this.playerConfigInner = playerConfig;
        this.codecs = this.configInner.codec ? __assign({}, this.configInner.codec) : { video: '', audio: '' };
        this.reset();
        this.logger.log("new VideoInfo(), uid: ".concat(this.uid));
    }
    VideoInfo.prototype.toJSON = function () {
        return this.serializedString();
    };
    VideoInfo.prototype.toString = function () {
        return this.serializedString();
    };
    Object.defineProperty(VideoInfo.prototype, "config", {
        get: function () {
            return this.configInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "qualityInfo", {
        get: function () {
            return this.qualityInfoInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "uid", {
        get: function () {
            return this.uidInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "loadingUrl", {
        get: function () {
            return this.loadingUrlInner;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoInfo.prototype, "extraVars", {
        get: function () {
            return this.extraVarsInner;
        },
        enumerable: false,
        configurable: true
    });
    VideoInfo.prototype.reset = function () {
        // 重置地址索引
        this.nextBackUrlIdxInner = 0;
        // 重置重试次数限制
        this.retryCountInner = 0;
        this.performance = {};
        // 先使用传入的url开始加载，后续可能会换成备份地址列表中的地址
        this.loadingUrlInner = this.configInner.url;
        // reset的时候同时清理音轨信息
        this.audioTracks = [];
    };
    VideoInfo.prototype.setLoadingUrlStartTime = function (startTime) {
        if (this.loadingUrlInner && startTime > 0) {
            this.loadingUrlInner = "".concat(this.loadingUrlInner.split('#t=')[0], "#t=").concat(startTime);
        }
    };
    VideoInfo.prototype.setDependVideoInfo = function (preVideoInfo) {
        this.startTime = preVideoInfo ? (preVideoInfo.startTime + preVideoInfo.duration) : 0;
        this.logger.log("setDependVideoInfo succ, uid/starttime: ".concat(this.uid, "/").concat(this.startTime));
        return true;
    };
    /**
     * 切换下一个备用地址
     */
    VideoInfo.prototype.setNextBackUrl = function () {
        var _a;
        var backupUrlLen = ((_a = this.configInner.backupUrls) === null || _a === void 0 ? void 0 : _a.length) || 0;
        var maxRetryCount = Math.max(this.playerConfigInner.backupUrlsMaxRetryCount, backupUrlLen);
        if (!this.configInner.url || this.retryCountInner >= maxRetryCount)
            return false;
        this.retryCountInner++;
        if (backupUrlLen > 0) {
            // 有重试地址，循环重试备用地址列表，直到maxRetryCount
            if (this.nextBackUrlIdxInner >= backupUrlLen) {
                this.loadingUrlInner = this.configInner.backupUrls[0];
                this.nextBackUrlIdxInner = 0;
            }
            else {
                this.loadingUrlInner = this.configInner.backupUrls[this.nextBackUrlIdxInner];
                this.nextBackUrlIdxInner++;
            }
        }
        else {
            // 没有备用地址，直接用当前地址重试多次
            this.loadingUrlInner = this.configInner.url;
        }
        return true;
    };
    VideoInfo.prototype.getRetryCount = function () {
        return this.retryCountInner;
    };
    /**
     * videoinfo销毁（需要注意的是，作为信息载体，很多信息在销毁后不需要清空，因为播放器或者引用方仍然需要知道）
     */
    VideoInfo.prototype.destroy = function () {
        this.extraVarsInner = null;
    };
    VideoInfo.prototype.serializedString = function () {
        var _a, _b;
        return "VideoInfo{u:".concat(this.loadingUrlInner, ",t:").concat(this.playtime, ",s:").concat(this.state, ",ec:").concat(((_a = this.error) === null || _a === void 0 ? void 0 : _a.code) || '', ",em:").concat(((_b = this.error) === null || _b === void 0 ? void 0 : _b.message) || '', ",r:").concat(this.nextBackUrlIdxInner, "}");
    };
    return VideoInfo;
}());

var logMethodCall$3 = logMethodCallDecoratorCreator('BasePlayer');
var BasePlayer = /** @class */ (function (_super) {
    __extends(BasePlayer, _super);
    function BasePlayer(opts) {
        var _a;
        var _this = _super.call(this) || this;
        _this._firstPlaying = false;
        /** 是否具有用户手势（跟自动播放相关的一个名词，具体google。这个变量在视频首帧起播以后变为true，只有destroy以后会重置） */
        _this._hasUserGestures = false;
        _this._volume = 1;
        _this.volumeGainInner = 0;
        _this.audioEffectInner = AudioEffectName.DEFAULT;
        _this._playbackRate = 1;
        /** 播放被阻止的状态中 */
        _this._playBlocking = false;
        /** 最后一次播放的video info，允许在播放器stop后外部依然可以访问currentVideoInfo */
        _this.lastVideoInfo = null;
        _this.setAudioEffectTimeoutId = 0;
        _this.destroyed = false;
        _this._logger = new Logger(opts.instanceId, 'BasePlayer');
        _this._config = opts;
        _this._videoInfos = []; // 地址列表
        _this._curUrlIdx = -1; // 当前的播放地址索引
        _this._curVideoNode = null;
        _this._preloaders = [];
        _this._vnList = [];
        _this._eventMap = {
            videonode: _this.videonodeEventHandler.bind(_this),
            document: _this.visibilityChangeHandler.bind(_this),
        };
        _this._played = false;
        _this.videoEvtHandlerMap = (_a = {},
            _a[VideoNodeEvent.RATE_CHANGE] = _this.onVideoNodeRateChange.bind(_this),
            _a[VideoNodeEvent.STATE_CHANGE] = _this.onVideoNodeStateChange.bind(_this),
            _a[VideoNodeEvent.PLAY_PROMISE_CATCHED] = _this.onVideoNodePlayPromiseCatched.bind(_this),
            _a[VideoNodeEvent.FIRST_PLAYING] = _this.onVideoNodeFirstPlaying.bind(_this),
            _a[VideoNodeEvent.PLAY_OVER] = _this.onVideoNodePlayOver.bind(_this),
            _a[VideoNodeEvent.ERROR] = _this.onVideoNodeError.bind(_this),
            _a);
        _this.screenWakeLock = new ScreenWakeLock();
        _this.playerStatusChecker = new CheckPlayerStatus(_this);
        document.addEventListener('visibilitychange', _this._eventMap.document);
        if (!_this._config.createVideoNodeWhenLoad) {
            _this.createVideoNodes(_this._config.maxVideoNodeCount);
        }
        return _this;
    }
    BasePlayer.prototype.load = function (value, extra) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!value || (value instanceof Array && value.length <= 0)) {
                    this.clearBeforeLoad();
                    return [2 /*return*/];
                }
                this.loadInner(value, extra);
                return [2 /*return*/];
            });
        });
    };
    BasePlayer.prototype.play = function (value, extra) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._logger.log('play()');
                        if (this.state === VideoState.IDLE && !value) {
                            // idle状态，没有参数时候直接return
                            this._logger.warn('play(), no urlConfig when idle state');
                            return [2 /*return*/];
                        }
                        this._checkPlayBlocked = true;
                        if (!(this._vnList.length <= 1 || this._hasUserGestures)) return [3 /*break*/, 1];
                        this._logger.log('play(), skip triggerAutoplay().');
                        this.triggerPlayResolve(value, extra);
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.triggerAutoplay()];
                    case 2:
                        _a.sent();
                        this.triggerPlayResolve(value, extra);
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        if (this.destroyed) {
                            return [2 /*return*/];
                        }
                        // 如果在点播模式下，调用play接口的时候自动播放被阻止，那就默认给调用一下load方法，此时应用方只需要在点击事件中空调用一下play接口
                        if (this._config.type === PlayMode.VOD && value) {
                            this.loadInner(value, extra);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BasePlayer.prototype.triggerAutoplay = function () {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        if (this._triggerAutoplayPromise) {
            return this._triggerAutoplayPromise;
        }
        this._logger.log('triggerAutoplay(), start');
        var allPromise = [];
        var len = this._vnList.length;
        for (var i = 0; i < len; i++) {
            var videoNodePromise = this._vnList[i].triggerAutoplay();
            allPromise.push(videoNodePromise);
        }
        this._triggerAutoplayPromise = Promise.all(allPromise);
        this._triggerAutoplayPromise.catch(function (e) {
            _this._logger.log('play() triggerAutoplay catched: ', e);
            _this.playBlocked();
        });
        return this._triggerAutoplayPromise;
    };
    BasePlayer.prototype.seek = function (time) {
        var _a;
        if (this.state === VideoState.IDLE) {
            // 播放idle状态，即使seek回去，也没法调用play()继续播放了。这里就直接return掉了。想播放结束了seek回去播，那不如重新播放并指定位置？
            return false;
        }
        if (time < 0 || !((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)) {
            return false;
        }
        // 通过接口调用的seek都应该视为用户行为
        return this._curVideoNode.seek(time, true);
    };
    BasePlayer.prototype.pause = function (pauseType) {
        if (!this._played) {
            this._logger.warn('pause(), player has not been played');
            return;
        }
        this.pauseInner(pauseType || PauseType.USER);
    };
    BasePlayer.prototype.stop = function (endState) {
        if (endState === void 0) { endState = EndState.INTERRUPT; }
        if (this.state === VideoState.IDLE) {
            return;
        }
        this.stopInner(endState, true);
    };
    BasePlayer.prototype.setLevel = function (urlOrUrlConfig, backupUrls, extraConfig) {
        var url;
        if (typeof urlOrUrlConfig === 'string') {
            url = urlOrUrlConfig;
        }
        else {
            url = urlOrUrlConfig.url;
            backupUrls = urlOrUrlConfig.backupUrls;
            extraConfig = urlOrUrlConfig;
        }
        var errMag = this.playerStatusChecker.checkSetLevelError(url);
        if (errMag) {
            this._logger.warn("setLevel(), ".concat(errMag));
            return Promise.reject(new Error(errMag));
        }
        this._urlBeforeSetLevel = { url: url, backupUrls: backupUrls };
        this.currentVideoInfo.config.url = url;
        if (backupUrls) {
            this.currentVideoInfo.config.backupUrls = backupUrls;
        }
        if (extraConfig) {
            Object.assign(this._urlBeforeSetLevel, extraConfig);
            Object.assign(this.currentVideoInfo.config, extraConfig);
        }
        this.currentVideoInfo.reset();
        return this.setLevelInner(this.currentVideoInfo.config);
    };
    BasePlayer.prototype.appendNext = function (urlConfig) {
        // 预检查是否当前播放环境是否支持append
        var appendDetail = this.playerStatusChecker.checkCanAppend(urlConfig);
        if (!appendDetail.canAppend) {
            this._logger.warn(appendDetail.message);
            return false;
        }
        // 播放列表中已经存在该视频配置
        var existVideoInfo = this._videoInfos.find(function (e) { return compareUrlConfig(e.config, urlConfig); });
        if (existVideoInfo) {
            this._logger.warn("appendNext(), duplicate append! uid[".concat(existVideoInfo.uid, "]"));
            return false;
        }
        // 判断预加载列表中是否有一样的url地址，没有则创建新的IVideoInfo
        var appendVideoInfo = this.preloadVideoInfos.find(function (e) { return compareUrlConfig(e.config, urlConfig); });
        if (!appendVideoInfo) {
            appendVideoInfo = new VideoInfo(urlConfig, this._config);
        }
        // 除了即将添加的播放数据保留，其他的预加载全部清理掉
        this.clearAllPreloadInner(appendVideoInfo);
        // 覆盖式添加到当前播放地址的下一个
        this._videoInfos = this._videoInfos.slice(0, this._curUrlIdx + 1);
        this._videoInfos = this._videoInfos.concat(appendVideoInfo);
        this._logger.log('appendNext() succ, appendVideoInfo=', appendVideoInfo);
        this.emit(PlayEvent.LIST_CHANGE);
        // append以后可能需要判断是否马上播放下一个等操作
        this.appendAfter(appendVideoInfo);
        return true;
    };
    BasePlayer.prototype.preloadNext = function () {
        var _this = this;
        var confs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            confs[_i] = arguments[_i];
        }
        // 预检查是否当前播放环境是否支持preload
        var preloadDetail = this.playerStatusChecker.checkCanPreloadEnvi(confs);
        if (!preloadDetail.canPreload) {
            this._logger.warn(preloadDetail.message);
            return false;
        }
        var preloadVideoInfos = [];
        confs.forEach(function (conf) {
            var preloadEachUrlDetail = _this.playerStatusChecker.checkCanPreloadEachConfig(conf);
            if (!preloadEachUrlDetail.canPreload) {
                _this._logger.warn(preloadEachUrlDetail.message);
                return;
            }
            if (_this.nextVideoInfo && compareUrlConfig(conf, _this.nextVideoInfo.config)) {
                // 预加载的地址中已经有播放列表中的下一个（可能先appendNext到播放列表中了，稍后才调用preloadNext接口预加载）
                preloadVideoInfos.push(_this.nextVideoInfo);
            }
            else {
                // 否则创建一个新的视频信息，开始预加载
                preloadVideoInfos.push(new VideoInfo(conf, _this._config));
            }
        });
        this.preloadInner.apply(this, __spreadArray([false, { startTime: 0, kernelName: this.kernelName }], preloadVideoInfos, false));
        return true;
    };
    BasePlayer.prototype.clearAllPreload = function () {
        this.clearAllPreloadInner();
    };
    BasePlayer.prototype.playNext = function (_opts) {
        if (!this._played) {
            this._logger.warn('playNext(), player has not been played');
            return;
        }
        this.playNextInner({ isInterrupt: true });
    };
    BasePlayer.prototype.hasAppended = function (value) {
        return !!this._videoInfos.find(function (e) { return compareUrlConfig(e.config, value); });
    };
    BasePlayer.prototype.hasPreloaded = function (value) {
        return !!this.preloadVideoInfos.find(function (e) { return compareUrlConfig(e.config, value); });
    };
    BasePlayer.prototype.setAudioTrack = function (_id) {
        return Promise.reject(AudioTrackErrorMsg.NOT_SUPPORT);
    };
    BasePlayer.prototype.getAudioTrackList = function () {
        if (!this.currentVideoInfo)
            return [];
        return this.currentVideoInfo.audioTracks;
    };
    BasePlayer.prototype.getCurrentAudioTrack = function () {
        if (!this.currentVideoInfo)
            return NaN;
        return this.currentVideoInfo.currentAudioTrack;
    };
    BasePlayer.prototype.resizeVideoElements = function (value) {
        var videoElements = this.videoElements;
        if (!value || !videoElements || videoElements.length <= 0) {
            return;
        }
        videoElements.forEach(function (videoElement) {
            videoTool.resizeElement(videoElement, value);
        });
        this.emit(PlayEvent.RESIZE, value);
    };
    BasePlayer.prototype.resize = function (value) {
        this.resizeVideoElements(value);
    };
    BasePlayer.prototype.captureVideo = function (dx, dy, dw, dh) {
        var _a;
        var video = this.currentVideoElement;
        if (!video)
            return;
        if (video instanceof HTMLVideoElement) {
            try {
                var data = videoTool.captureVideo(video, { dx: dx, dy: dy, dw: dw, dh: dh });
                return Promise.resolve(data);
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
        return (_a = video.captureVideo) === null || _a === void 0 ? void 0 : _a.call(video, dx, dy, dw, dh);
    };
    BasePlayer.prototype.destroy = function () {
        var _a, _b;
        this.stopInner();
        if (this._vnList) {
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].destroy();
            }
        }
        if (this._preloaders) {
            this._preloaders.forEach(function (preloader) {
                preloader.clear();
            });
            this._preloaders = null;
        }
        document.removeEventListener('visibilitychange', this._eventMap.document);
        this.removeAllListeners();
        // 释放屏幕常亮
        (_a = this.screenWakeLock) === null || _a === void 0 ? void 0 : _a.keepAlive(false);
        this.screenWakeLock = null;
        this._videoInfos = null;
        this._curVideoNode = null;
        this._vnList = null;
        this._eventMap = null;
        this.lastVideoInfo = null;
        (_b = this.playerStatusChecker) === null || _b === void 0 ? void 0 : _b.destroy();
        this.playerStatusChecker = null;
        this.destroyed = true;
    };
    Object.defineProperty(BasePlayer.prototype, "duration", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.duration : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "playtime", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.playtime : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "state", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.state : VideoState.IDLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "played", {
        get: function () {
            return this._played;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "playbackRate", {
        get: function () {
            return this._playbackRate;
        },
        set: function (value) {
            this._playbackRate = value;
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].playbackRate = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "supportPlaybackRate", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "supportPreload", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            this._volume = value;
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                this._vnList[i].volume = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "volumeGain", {
        get: function () {
            return this.volumeGainInner;
        },
        set: function (gain) {
            this.volumeGainInner = gain;
            if (this._curVideoNode) {
                this._curVideoNode.volumeGain = gain;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "audioEffect", {
        get: function () {
            return this.audioEffectInner;
        },
        set: function (effectName) {
            this.audioEffectInner = effectName;
            if (this._curVideoNode) {
                this._curVideoNode.audioEffect = effectName;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "useWorker", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.useWorker : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoElements", {
        get: function () {
            var _a;
            return (_a = this._vnList) === null || _a === void 0 ? void 0 : _a.map(function (vn) { return vn.videoElement; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoElement", {
        /** 获取当前videonode的video元素 */
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoElement : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoInfos", {
        get: function () {
            return this._videoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "preloadVideoInfos", {
        get: function () {
            return this._preloaders.map(function (preloader) { return preloader.videoInfo; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoSize", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoSize : { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "videoBuffered", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.videoBuffered : [{ start: 0, end: 0 }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoInfo", {
        get: function () {
            return this._curVideoNode ? this._curVideoNode.currentVideoInfo : this.lastVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "nextVideoInfo", {
        /** 列表播放的下一个视频信息，如果超限返回undefined */
        get: function () {
            return this._videoInfos[this._curUrlIdx + 1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "currentVideoInfoIdx", {
        get: function () {
            return this._curVideoNode ? this._videoInfos.indexOf(this._curVideoNode.currentVideoInfo) : -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "totalVideoInfoCount", {
        get: function () {
            return this._videoInfos.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "config", {
        /** 获取当前内核的配置信息 */
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlayer.prototype, "curUrlIdx", {
        /** 获取当前Url序号 */
        get: function () {
            return this._curUrlIdx;
        },
        enumerable: false,
        configurable: true
    });
    BasePlayer.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log.apply(_a, args);
    };
    /** 加载视频player内部实现方法，用于各个内核继承和内部调用 */
    BasePlayer.prototype.loadInner = function (value, extra) {
        var _this = this;
        // 调用播放器load方法，就一定会先停止先前的播放
        this.clearBeforeLoad();
        var checkUrlConfigError = checkUrlConfigVailed(value);
        if (checkUrlConfigError) {
            this.emit(PlayEvent.ERROR, { videoInfo: { error: checkUrlConfigError } });
            return false;
        }
        if (this._config.createVideoNodeWhenLoad) {
            this._vnList.forEach(function (videoNode) { return videoNode.destroy(); });
            this._vnList.length = 0;
            this.createVideoNodes(this._config.maxVideoNodeCount);
        }
        // 相当于重新开始播放，通知外部重新播放事件
        this.emit(PlayEvent.RESTART);
        var _a = (extra || {}).startTime, startTime = _a === void 0 ? 0 : _a;
        this._videoInfos = [].concat(value).map(function (conf) { return new VideoInfo(conf, _this._config); });
        this.emit(PlayEvent.LIST_CHANGE);
        // 第一个视频不管是否支持预加载，都可以调用load接口
        var firstVideoInfo = this._videoInfos[0];
        this.preloadInner(true, __assign(__assign({}, extra), { startTime: startTime, kernelName: this.kernelName }), firstVideoInfo);
        return true;
    };
    /** 暂停播放player内部实现方法，用于各个内核继承和内部调用 */
    BasePlayer.prototype.pauseInner = function (type) {
        if (type === void 0) { type = PauseType.INNER; }
        if (this.state === VideoState.PAUSE) {
            return;
        }
        if (this._curVideoNode) {
            this._curVideoNode.pause(type);
        }
    };
    BasePlayer.prototype.resumeInner = function () {
        var _a;
        if (!this._played) {
            return;
        }
        // duration为0的情况可能是video设置了src并且调用了播放，但是被阻止播放，此时duration是0
        // playtime < duration是限制只能在视频未结束调用（在视频结束调用play可能会从头开始播放）
        if (((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo)
            && (this._curVideoNode.duration === 0 || this._curVideoNode.playtime < this._curVideoNode.duration)) {
            this._curVideoNode.videoplay();
        }
    };
    BasePlayer.prototype.stopInner = function (endState, dispatchEvt, videoInfo) {
        var _a;
        if (endState === void 0) { endState = EndState.NORMAL; }
        if (dispatchEvt === void 0) { dispatchEvt = false; }
        if (videoInfo === void 0) { videoInfo = null; }
        // 要先清掉预加载，否则下面stop每个videonode的时候可能还会收到videonode的事件，例如end事件，然后这个end事件
        // 会触发尝试播放下一个视频，此时如果预加载信息还在，可能会使用未清除的预加载继续播放。
        if (((_a = this._config) === null || _a === void 0 ? void 0 : _a.type) === PlayMode.VOD) {
            this.clearAllPreloadInner();
        }
        // 存一下videoInfos数组，马上置空this._videoInfos。这里为了避免在列表播放时，当前videoNode播放时外部停止了播放，
        // 当前videoNode会发出end，idle事件，然后checkPlayNext里面尝试播放下一个videoNode。这不符合外部停止播放的预期。
        // 因此先置空videoInfos，此时this.nextVideoInfo为空，就不会继续尝试播放下一个videoNode了
        var videoInfos = this._videoInfos;
        // 缓存一下last video info
        this.lastVideoInfo = videoInfo !== null && videoInfo !== void 0 ? videoInfo : this.currentVideoInfo;
        this._videoInfos = [];
        if (this._vnList) {
            var len = this._vnList.length;
            for (var i = 0; i < len; i++) {
                // 先销毁videonode再移除videonode上的事件，便于销毁时仍能监听到videonode发出的idle等事件
                this._vnList[i].stop();
                this.setPlayEvents(this._vnList[i], false);
            }
        }
        this._curUrlIdx = -1;
        if (videoInfos) {
            videoInfos.forEach(function (vi) {
                vi.destroy();
            });
        }
        if (this.setAudioEffectTimeoutId > 0) {
            clearTimeout(this.setAudioEffectTimeoutId);
            this.setAudioEffectTimeoutId = 0;
        }
        this._firstPlaying = false;
        this._played = false;
        this._curVideoNode = null;
        var error = videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error;
        var endStateValue = error ? EndState.ERROR : endState;
        this._logger.log("stopInner(), endState=".concat(endStateValue));
        // 派发stop和error事件
        if (!dispatchEvt) {
            return;
        }
        this.emit(PlayEvent.STOPED, {
            videoInfo: videoInfo,
            isUserStop: endState === EndState.INTERRUPT,
            endState: endStateValue,
        });
        if (error) {
            this.emit(PlayEvent.ERROR, { videoInfo: videoInfo });
        }
    };
    /** 预加载播放player内部实现方法，用于各个内核继承和内部调用 */
    BasePlayer.prototype.preloadInner = function (isFirstLoad, extra) {
        var preloadVideoInfos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            preloadVideoInfos[_i - 2] = arguments[_i];
        }
        this._logger.log("preloadInner(".concat(isFirstLoad, ", extra)"));
        var preloaders = [];
        var len = preloadVideoInfos.length;
        if (len <= 0) {
            return;
        }
        for (var i = 0; i < len; i++) {
            if (!preloadVideoInfos[i]) {
                continue;
            }
            this.clearPreloader(preloadVideoInfos[i]);
            var preloader = this.preparePreloader(isFirstLoad, preloadVideoInfos[i]);
            if (preloader) {
                // 设置预加载的依赖
                preloadVideoInfos[i].setDependVideoInfo(this.currentVideoInfo);
                preloader.load(isFirstLoad, this, preloadVideoInfos[i], extra);
                preloaders.push(preloader);
            }
        }
        this._preloaders = this._preloaders.concat(preloaders);
        this._logger.log('preload(), preloader\'s length: ', this._preloaders.length);
        // 最后才发出事件，避免外部监听预加载开始事件以后马上操作预加载列表。
        if (preloaders.length > 0) {
            this.emit(PlayEvent.PRELOAD_START, { preloadVideoInfos: preloaders.map(function (preloader) { return preloader.videoInfo; }) });
        }
    };
    BasePlayer.prototype.playNextInner = function (opts) {
        var isInterrupt = (opts || {}).isInterrupt;
        this._logger.log("playNextInner(), curUrlIdx=".concat(this._curUrlIdx, "/")
            + "urlLength=".concat(this._videoInfos.length, "/isInterrupt=").concat(isInterrupt));
        var isMinTime = Math.abs(this.playtime - this.duration) <= this._config.interruptPlayNextMinTime;
        if (isInterrupt && isMinTime && this.state === VideoState.PLAYING) {
            // 时间太短，马上会跳段了而不需要打断，所以这里加了一个判断
            this._logger.log('playNextInner(), playNext right now! return!');
            return;
        }
        if (this._curUrlIdx + 1 >= this._videoInfos.length) {
            this._logger.warn('There is no next VideoInfo.');
            return;
        }
        this._curUrlIdx += 1;
        this.setPlayEvents(this._curVideoNode, false);
        // 打断式切换要先停止当前的播放
        if (isInterrupt) {
            this._curVideoNode.pause(PauseType.INNER);
        }
        // 这个时候this._videoInfos[this._curUrlIdx]的值和this.currentVideoNode是不一样的。
        var videoInfo = this._videoInfos[this._curUrlIdx];
        // 除了即将播放的视频数据保留，其他的全部清理掉
        this.clearAllPreloadInner(videoInfo);
        if (isInterrupt) {
            // 如果是打断式切换，派发当前段播放结束。事件结束后再开始播下一个
            this.emit(PlayEvent.VIDEONODE_PLAY_OVER, { videoInfo: this.currentVideoInfo });
        }
        this.playInner();
    };
    /**
    * 清理所有预加载内部调用
    * @param exceptVideoInfo 保留的预加载视频
    */
    BasePlayer.prototype.clearAllPreloadInner = function (exceptVideoInfo) {
        var _this = this;
        if (!this._preloaders || this._preloaders.length <= 0) {
            return;
        }
        var removePreloaders = this._preloaders.filter(function (preloader) { return preloader.videoInfo !== exceptVideoInfo; });
        // 一个一个清理预加载列表中的视频数据
        removePreloaders.forEach(function (removePreloader) {
            _this.clearPreloader(removePreloader.videoInfo);
        });
    };
    /** 在视频加载前清理 */
    BasePlayer.prototype.clearBeforeLoad = function () {
        var _a;
        // 在重新load时清理所有video标签（当配置项clearVideoAfterStop为false时，在stop时可能并未清理video标签）
        (_a = this._vnList) === null || _a === void 0 ? void 0 : _a.forEach(function (videoNode) {
            videoTool.clear(videoNode.videoElement);
        });
        this.stopInner(this._played ? EndState.INTERRUPT : EndState.NORMAL, this._played, // 如果当前正在播放，还需要派发stop事件出去
        this._played ? this.currentVideoInfo : null);
    };
    /** 内部实现的清理单个视频的预加载, 会从预加载的数组删除预加载地址 */
    BasePlayer.prototype.clearPreloader = function (videoInfo, keepLoadedData) {
        if (!this._preloaders || this._preloaders.length <= 0) {
            return;
        }
        if (!videoInfo) {
            return;
        }
        var idx = this.findPreloadIdxByVideoInfo(videoInfo);
        if (idx === -1) {
            // 根本没有预加载过
            return;
        }
        var preloader = this._preloaders.splice(idx, 1)[0];
        preloader.clear(keepLoadedData);
    };
    /** 查找预加载VideoInfo序号 */
    BasePlayer.prototype.findPreloadIdxByVideoInfo = function (videoInfo) {
        if (!videoInfo) {
            return -1;
        }
        return this._preloaders.findIndex(function (preloader) { return preloader.videoInfo === videoInfo; });
    };
    /** 选择清晰度的切换模式，各个内核可以选择复写 */
    BasePlayer.prototype.decideSetLevelMode = function (forceSetLevelMode) {
        return this.playerStatusChecker.checkSetLevelMode(this._vnList.length, forceSetLevelMode);
    };
    /** 创建单个的VideoNode */
    BasePlayer.prototype.createVideoNode = function (conf) {
        return uaTool.os.ios ? new OrgIOSVideoNode(conf) : new OrgVideoNode(conf);
    };
    /**  创建VideoNode列表，每种内核的列表长度可能不一样。 */
    BasePlayer.prototype.createVideoNodes = function (count) {
        for (var i = 0; i < count; i++) {
            var vn = this.createVideoNode(this._config);
            vn.idx = i;
            // 如果有createVideoNodeWhenLoad配置项，VideoNode是在load接口中创建的，因此还需要再次赋值一次volume避免音量丢失
            vn.volume = this._volume;
            vn.playbackRate = this._playbackRate;
            if (vn.videoElement instanceof HTMLElement) {
                vn.videoElement.dataset.idx = "".concat(i);
            }
            this._vnList.push(vn);
        }
    };
    /** 给videoNode添加或者移除播放监听 */
    BasePlayer.prototype.setPlayEvents = function (vn, isSet) {
        var _this = this;
        if (!vn) {
            return;
        }
        if (isSet) { // 先移除，保证只有一次添加
            this.setPlayEvents(vn, false);
        }
        this._logger.log("set VideoNode evts, idx=".concat(vn.idx, "/isSet=").concat(isSet));
        Object.keys(VideoNodeEvent).forEach(function (k) {
            var evtHandler = isSet ? vn.on : vn.off;
            evtHandler.apply(vn, [VideoNodeEvent[k], _this._eventMap.videonode]);
        });
    };
    /** videoNode事件监听回调 */
    BasePlayer.prototype.videonodeEventHandler = function (e) {
        this.logVideoNodeEvts(e);
        // 是否需要将videoNode的事件转发为player的事件。默认需要转发。但执行每个对应事件回调时也会返回是否需要转发。
        var shouldDispatchPlayEvt = true;
        // 对videoNode发出的事件的内部处理
        if (this.videoEvtHandlerMap[e.type]) {
            shouldDispatchPlayEvt = this.videoEvtHandlerMap[e.type](e);
        }
        // 如果有对应的player事件，转发videonode事件
        if (shouldDispatchPlayEvt && (e.type in videoEvt2PlayerEvtMap)) {
            this.emit(videoEvt2PlayerEvtMap[e.type], e.data);
        }
    };
    BasePlayer.prototype.onVideoNodeRateChange = function (e) {
        var playbackRate = e.data.playbackRate;
        this._playbackRate = playbackRate;
        return true;
    };
    /** 处理videoNode播放状态变化 */
    BasePlayer.prototype.onVideoNodeStateChange = function (e) {
        if (e.data.new === VideoState.PAUSE && e.data.pauseType === PauseType.INNER) {
            this._logger.log('inner pause does not emit event.');
            return false;
        }
        if (e.data.new === VideoState.PLAYING) {
            this._checkPlayBlocked = false;
        }
        // 播放状态变为Playing时，设置屏幕常亮
        this.screenWakeLock.keepAlive(e.data.new === VideoState.PLAYING);
        return true;
    };
    /** 处理videoNode起播Promise捕获 */
    BasePlayer.prototype.onVideoNodePlayPromiseCatched = function (e) {
        if (this._checkPlayBlocked && e.data.isAutoPlayBlocked) {
            this._checkPlayBlocked = false;
            this.playBlocked();
        }
        return true;
    };
    /** 处理videoNode首次起播 */
    BasePlayer.prototype.onVideoNodeFirstPlaying = function (_e) {
        var _this = this;
        if (!this._firstPlaying) {
            // FIRST_PLAYING无论有多少个videonode，都只对外转发一次
            this.emit(PlayEvent.FIRST_PLAYING, { videoInfo: this.currentVideoInfo });
            this._firstPlaying = true;
            this._hasUserGestures = true;
        }
        // 同步音效状态（只能在每个VideoNode起播以后，才能有效设置）
        this.setAudioEffectTimeoutId = setTimeout(function () {
            // 这个setTimeout 0是因为VideoNode发出这个事件在修改videoNode.videoInfo.hasFirstPlaying之前，如果
            // 不延迟一下，设置volumeGain和audioEffect都会被return
            if (_this._curVideoNode.volumeGain !== _this.volumeGainInner) {
                _this.volumeGain = _this.volumeGainInner;
            }
            if (_this._curVideoNode.audioEffect !== _this.audioEffectInner) {
                _this.audioEffect = _this.audioEffectInner;
            }
        }, 0);
        return true;
    };
    /** 处理videoNode播放结束，检查下一个播放 */
    BasePlayer.prototype.onVideoNodePlayOver = function (_e) {
        if (!this._config.isPlayList && !this.nextVideoInfo) {
            var videoInfo = this.currentVideoInfo;
            // videonode里面正常结束，需要在player这一层调用stopInner重置一些变量，但如果是两个场景不需要stopInner
            // 1. 如果播放列表中还有下一个视频等待播放
            // 2. 如果是灵活的列表播放场景（isPlayList=true），播放器可能还会继续被append视频播放，因此不能被停止，而是等待用户添加视频
            this.stopInner(EndState.NORMAL, true, videoInfo);
            // 在停止当前播放以后，发出当前段播放结束事件
            this.emit(PlayEvent.VIDEONODE_PLAY_OVER, { videoInfo: videoInfo });
        }
        else {
            // 在播放下一段之前，发出当前段播放结束
            this.emit(PlayEvent.VIDEONODE_PLAY_OVER, { videoInfo: this.currentVideoInfo });
            this.checkPlayNext();
        }
        return false;
    };
    /** 处理videoNode播放错误 */
    BasePlayer.prototype.onVideoNodeError = function (e) {
        var videoInfo = (e.data || {}).videoInfo;
        // this.detectSourceOnError(videoInfo);
        this.stopInner(EndState.ERROR, true, videoInfo);
        // stopInner第二个参数为true，直接发出error和stop事件了，不需要派发事件
        return false;
    };
    /** 打印VideoNode事件关键信息，但排除开一些高频事件的打印 */
    BasePlayer.prototype.logVideoNodeEvts = function (e) {
        var _a, _b;
        // 过滤掉频繁产生的 VideoNode 事件
        if (IGNORE_EVT_TYPE.includes(e.type)) {
            return;
        }
        // 过滤掉频繁产生的 IVideoElement 事件
        if (e.type === VideoNodeEvent.ELEMENT_EVTS && IGNORE_VIDEO_EVT.includes(e.data.elementEvtType)) {
            return;
        }
        var logData = e.data;
        if (e.type === VideoNodeEvent.STATE_CHANGE) {
            logData = "[".concat(e.data.old, "->").concat(e.data.new, "]");
        }
        else if (e.type === VideoNodeEvent.ELEMENT_EVTS) {
            logData = "[elementEvtType=".concat(e.data.elementEvtType, "]");
        }
        this._logger.log("get VideoNode evt, type=".concat(e.type, "/uid=").concat((_b = (_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) === null || _b === void 0 ? void 0 : _b.uid, "/data="), logData);
    };
    BasePlayer.prototype.playBlocked = function () {
        var _this = this;
        this._playBlocking = true;
        this._triggerAutoplayPromise = null;
        setTimeout(function () {
            // setTimeout避免在block事件的监听回调里面调用play的时候还没有调用load而播放器状态为state
            // (修复autoblock事件太晚导致静音自动播不生效问题)
            _this.emit(PlayEvent.AUTOPLAY_BLOCKED, { videoInfo: _this.currentVideoInfo });
        }, 0);
        this.setLoading(false);
    };
    BasePlayer.prototype.checkPlayNext = function () {
        var playNextDetail = this.playerStatusChecker.checkCanPlayNext();
        this._logger.log(playNextDetail.message);
        if (playNextDetail.canPlayNext) {
            this.playNextInner();
        }
    };
    /**
    * 检查是否需要自动预加载下一个视频
    * @param leftTime 离视频播放的结束时间
    */
    BasePlayer.prototype.checkAutoPreloadNext = function (leftTime) {
        var preloadDetail = this.playerStatusChecker.checkAutoPreloadNext(leftTime);
        if (preloadDetail.canPreload) {
            this.preloadInner(false, { startTime: 0, kernelName: this.kernelName }, this.nextVideoInfo);
        }
    };
    /** 修改当前_curVideoNode指向 */
    BasePlayer.prototype.setCurVideoNode = function (vn, isForceSet) {
        if (isForceSet === void 0) { isForceSet = false; }
        if (this._curVideoNode === vn && !isForceSet) {
            return;
        }
        if (this._curVideoNode) {
            this._curVideoNode.onAccurateTimeupdate = null;
            this.setPlayEvents(this._curVideoNode, false);
        }
        if (vn) {
            this._curVideoNode = vn;
            this._curVideoNode.onAccurateTimeupdate = this.checkAccuratePlaytime.bind(this);
            this.setPlayEvents(this._curVideoNode, true);
        }
    };
    /** 在播放错误时，使用range请求获取当前播放的视频的一段数据用于探测远程资源 */
    BasePlayer.prototype.detectSourceOnError = function (videoInfo) {
        var _this = this;
        var _a = videoInfo || {}, loadingUrl = _a.loadingUrl, uid = _a.uid;
        if (!loadingUrl) {
            this._logger.error('detectSourceOnError, url=null');
            return;
        }
        detectStream(loadingUrl)
            .then(function (data) {
            _this._logger.error('detectSourceOnError=', __assign({ uid: uid }, data));
        })
            .catch(function (e) {
            _this._logger.error('detectSourceOnError err', e === null || e === void 0 ? void 0 : e.message);
        });
    };
    /** 在播放器层的loading动画展示时机逻辑 */
    BasePlayer.prototype.setLoading = function (show) {
        this.emit(PlayEvent.SET_LOADING, { show: show });
    };
    /** 在页面不可见时，出现状态切换，申请常亮可能被系统拒绝。因此在页面恢复可见时，重新设置屏幕常亮 */
    BasePlayer.prototype.visibilityChangeHandler = function () {
        this.screenWakeLock.keepAlive(this.state === VideoState.PLAYING);
    };
    /** 对播放列表Play方法的不同情况处理 */
    BasePlayer.prototype.triggerPlayResolve = function (urlConfig, extra) {
        var _this = this;
        if (urlConfig) {
            // 只要有urlConfig参数，需要重新开始播放
            if (this.loadInner(urlConfig, extra)) {
                this.setLoading(true);
                this.triggerPlayAfterLoad();
            }
            return;
        }
        // 没有urlConfig参数，需要按以下几个情况分别处理
        if (!this._played) {
            // 情况一：外部调用load后，再调用play(或点击play按钮)，需要显示下loading（可能是调用了load接口，但还没有预加载完）
            this.setLoading(true);
            this.triggerPlayAfterLoad();
            return;
        }
        if (this._playBlocking || videoTool.cannotDetectAutoPlayBlock()) {
            // 情况二：看看是否被自动播放阻止（或者根本就无法检测到自动播放被拦截），直接恢复播放即可
            this._playBlocking = false;
            // safari播放被阻止后，再次调用play接口会先走triggerAuthplay，再走到resumeInner，但是马上调用无效（原因未知），
            // setTimeout可解决。其他浏览器没有这个问题，因此这里干脆延迟一个循环再执行。
            setTimeout(function () {
                var _a, _b;
                if (((_b = (_a = _this._curVideoNode) === null || _a === void 0 ? void 0 : _a.videoBuffered) === null || _b === void 0 ? void 0 : _b.length) <= 0) {
                    // 可能是某些浏览器被自动播放阻止后，根本没有加载数据和派发loadStart事件（调用video.load()接口），点击恢复
                    // 播放需要继续加载数据才能看到画面，此时为黑屏状态，因此当没有buffer数据时，需要展示加载loading
                    _this.setLoading(true);
                }
                _this.resumeInner();
            }, 0);
            return;
        }
        if ([VideoState.PAUSE, VideoState.CANPLAY, VideoState.SEEKED].indexOf(this.state) !== -1) {
            // 情况三：（兜底逻辑）视频在以下状态【暂停、可以开播、seeked】，恢复播放即可
            this.resumeInner();
            return;
        }
        // 三种情况都不匹配，play接口做不了任何事情，已经兜底不会出现这种情况，打印日志以定位后续某情况走到该分支
        this._logger.log('play() has been called, but cannot do nothing.');
    };
    /** 如果预加载过第一个视频，那么等待预加载成功后开始播放 */
    BasePlayer.prototype.triggerPlayAfterLoad = function () {
        if (this._played || this._curUrlIdx !== -1) {
            return;
        }
        var firstVideoInfo = this._videoInfos[0];
        if (firstVideoInfo) {
            this._played = true;
            this._curUrlIdx = 0;
            this.playInner();
        }
    };
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "load", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "seek", null);
    __decorate([
        logMethodCall$3
        // endState参数默认值为`END_STATE.INTERRUPT`，外部调用stop接口都认为是打断播放。
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "stop", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array, Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "setLevel", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "appendNext", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "preloadNext", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playNext", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], BasePlayer.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "resizeVideoElements", null);
    __decorate([
        logMethodCall$3,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "destroy", null);
    __decorate([
        logMethodCall$3
        /** 恢复播放内部调用方法，用于各个内核继承和内部调用 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "resumeInner", null);
    __decorate([
        logMethodCall$3
        /**
         * 停止播放player内部实现方法，用于各个内核继承和内部调用
         * @param endState 结束状态，默认值为`END_STATE.NORMAL`
         * @param dispatchEvt 是否发出stop事件，error事件
         * @param videoInfo
         * @see 播放结束{@link PLAY_EVENT.STOPED}
         * @see 播放出错{@link PLAY_EVENT.ERROR}
         */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object, Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "stopInner", null);
    __decorate([
        logMethodCall$3
        /**
         * 播放下一个视频内部实现
         * @param opts.isInterrupt 用来区分是结束了切换还是打断式切换。如果是外部调用（即打断式切换）默认传这个参数为true，其他内部调用不会传true。
         */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playNextInner", null);
    __decorate([
        logMethodCall$3
        /** 播放器自动播放被阻止 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "playBlocked", null);
    __decorate([
        logMethodCall$3
        /** 检查列表播放是否需要继续播放下一个视频，各个内核按需要复写 */
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], BasePlayer.prototype, "checkPlayNext", null);
    return BasePlayer;
}(EvtEmitter));

var defaultOriginKernelConfig = {
    /**
     * @deprecated
     * 默认创建的最大VideoNode数量。此值会影响到可以同时预加载的视频数，例如如果需要同时预加载3个视频，这个值就需要指定为3+1
     * <br>【注】：仅原生播放内核时有效
     */
    maxVideoNodeCount: 1,
    /**
     * 提前结束播放的时间（考虑到某些视频最后只有音频，有需求需要剪掉视频最末尾的一段播放，x5浏览器是0.1s）
     * <br>【注】：仅原生播放内核时有效
     */
    advanceEndTime: 0,
    /**
     * 原生播放内核实现切换时，为了拼接顺畅，可能会把下一个视频提前一点点播放
     * <br>【注】：仅原生播放内核时有效
     */
    prePlayNextTime: 0,
};
function mergeKernelConfig(config) {
    return __assign(__assign({}, config), { originKernelConfig: __assign(__assign({}, defaultOriginKernelConfig), config.originKernelConfig) });
}

var logMethodCall$2 = logMethodCallDecoratorCreator('OrgPreLoader');
/**
 * 执行预加载
 */
var OrgPreLoader = /** @class */ (function () {
    function OrgPreLoader(playerConfig) {
        var _a;
        this.playerConfig = playerConfig;
        this.deferInner = new SimpleDefer();
        this.logger = new Logger(playerConfig.instanceId, 'OrgPreLoader');
        this.evtMaps = (_a = {},
            _a[VideoNodeEvent.STATE_CHANGE] = this.firstLoadStateChangeHandler.bind(this),
            _a[VideoNodeEvent.ERROR] = this.errorHandler.bind(this),
            _a);
    }
    Object.defineProperty(OrgPreLoader.prototype, "promise", {
        get: function () {
            return this.deferInner.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OrgPreLoader.prototype, "videoInfo", {
        get: function () {
            return this.videoInfoInner;
        },
        enumerable: false,
        configurable: true
    });
    OrgPreLoader.prototype.getVideoNode = function () {
        var _a;
        return (_a = this.videoInfoInner) === null || _a === void 0 ? void 0 : _a.extraVars.preloadVideoNode;
    };
    OrgPreLoader.prototype.errorHandler = function (e) {
        this.preloadFail(e.data.videoInfo.error);
    };
    OrgPreLoader.prototype.firstLoadStateChangeHandler = function (e) {
        if (e.data.new === VideoState.CANPLAY) {
            this.preloadSucc();
        }
    };
    OrgPreLoader.prototype.preloadSucc = function () {
        this.logger.log("preload url ready>>>>>> uid=".concat(this.videoInfoInner.uid));
        this.clearInner(true);
        this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_OVER, { videoInfo: this.videoInfoInner });
        this.deferInner.resolve();
    };
    OrgPreLoader.prototype.preloadFail = function (error) {
        this.logger.log("preload url fail>>>>>> uid: ".concat(this.videoInfoInner.uid));
        this.clearInner();
        this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_ERROR, { videoInfo: this.videoInfoInner });
        this.videoInfoInner.error = error;
        this.deferInner.reject(error);
    };
    OrgPreLoader.prototype.setVideoNodeEvents = function (value) {
        var _this = this;
        var videoNode = this.getVideoNode();
        Object.keys(this.evtMaps).forEach(function (key) {
            if (value) {
                videoNode.on(key, _this.evtMaps[key]);
            }
            else {
                videoNode.off(key, _this.evtMaps[key]);
            }
        });
    };
    OrgPreLoader.prototype.load = function (isFirstLoad, evtDispatcher, videoInfo, extra) {
        this.videoInfoInner = videoInfo;
        this.evtDispatcher = evtDispatcher;
        this.setVideoNodeEvents(true);
        this.logger.log("load(), isFirstLoad=".concat(isFirstLoad));
        this.getVideoNode().load(videoInfo, extra);
    };
    OrgPreLoader.prototype.clearInner = function (keepLoadedData, emitEvt) {
        if (!this.videoInfoInner) {
            return;
        }
        var videoNode = this.getVideoNode();
        if (!videoNode) {
            return;
        }
        this.logger.log("clear(), uid=".concat(this.videoInfoInner.uid, "/keep=").concat(keepLoadedData));
        this.setVideoNodeEvents(false);
        if (!keepLoadedData) {
            this.videoInfoInner.extraVars.preloadVideoNode = null;
            videoNode.stop();
        }
        if (emitEvt) {
            this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_CLEAR, { videoInfo: this.videoInfoInner });
        }
    };
    OrgPreLoader.prototype.clear = function (keepLoadedData) {
        this.clearInner(keepLoadedData, true);
    };
    __decorate([
        logMethodCall$2,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, EvtEmitter, Object, Object]),
        __metadata("design:returntype", void 0)
    ], OrgPreLoader.prototype, "load", null);
    __decorate([
        logMethodCall$2,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], OrgPreLoader.prototype, "clear", null);
    return OrgPreLoader;
}());

var logMethodCall$1 = logMethodCallDecoratorCreator('MultiPlayer');
/**
 * 用多个video标签切换播放一个列表。
 */
var MultiPlayer = /** @class */ (function (_super) {
    __extends(MultiPlayer, _super);
    function MultiPlayer(conf) {
        var _a;
        var _this = _super.call(this, mergeKernelConfig(conf)) || this;
        _this._needHideVideoNode = null;
        _this._videonodeEventMap = (_a = {},
            _a[VideoNodeEvent.STATE_CHANGE] = _this.onCurVideoNodeStateChange.bind(_this),
            _a);
        return _this;
    }
    Object.defineProperty(MultiPlayer, "canPlayType", {
        get: function () {
            return videoTool.supportVideoFormat();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiPlayer.prototype, "supportPreload", {
        get: function () {
            return videoTool.supportSameTimePlay();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiPlayer.prototype, "kernelName", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return KernelName.ORIGIN;
        },
        enumerable: false,
        configurable: true
    });
    MultiPlayer.prototype.seek = function (time) {
        if (this.getLevelSwitching()) {
            // multiplayer内切换清晰度为soft切换，这种也是暂停切换，过程中无法seek
            return false;
        }
        return _super.prototype.seek.call(this, time);
    };
    MultiPlayer.prototype.createVideoNodes = function (count) {
        _super.prototype.createVideoNodes.call(this, count);
        for (var i = 0; i < this._vnList.length; i++) {
            var vn = this._vnList[i];
            if (i === 0) {
                // 第一个video标签直接显示出来（如果有设置poster，可以展示）
                this._firstVideoNode = vn;
            }
            else {
                this.visibleVideoNode(vn, false);
            }
        }
    };
    MultiPlayer.prototype.videonodeEventHandler = function (e) {
        // 先进行内部事件处理，完了以后再发出事件（因为发出事件以后外部可能stop或者销毁事件）
        if (this._videonodeEventMap[e.type]) {
            this._videonodeEventMap[e.type](e);
        }
        _super.prototype.videonodeEventHandler.call(this, e);
    };
    MultiPlayer.prototype.onCurVideoNodeStateChange = function (e) {
        if (e.data.new !== VideoState.PLAYING) {
            return;
        }
        this.switchVideoNode();
        // 通知外部当前视频已经开播了
        if (!this.currentVideoInfo.extraVars.isStartPlay) {
            this.currentVideoInfo.extraVars.isStartPlay = true;
            var uid = this.currentVideoInfo ? this.currentVideoInfo.uid : null;
            this._logger.log("videoNodeStartPlay: uid[".concat(uid, "]"));
            this.emit(PlayEvent.VIDEONODE_START_PLAY, { videoInfo: this.currentVideoInfo });
        }
    };
    MultiPlayer.prototype.onVideoNodeStateChange = function (e) {
        if (this.getLevelSwitching() && !VALID_STATE_IN_LEVEL_SWITCHING.includes(e.data.new)) {
            // 在multiplayer里切换清晰度触发时，已经将下一个VideoNode设置为currentVideoNode（开始监听此VideoNode事件）。在切换过程中，需要
            // 过滤掉currentVideoNode的状态变化。
            return false;
        }
        return _super.prototype.onVideoNodeStateChange.call(this, e);
    };
    MultiPlayer.prototype.pauseInner = function (type) {
        if (type === void 0) { type = PauseType.INNER; }
        if (this._prePlayNext) {
            // 提前开始播放下一个，就是在准备切换了。这个极短的时间里面，不允许暂停了
            this._logger.warn('pause when preplaynext, return!!');
            return;
        }
        _super.prototype.pauseInner.call(this, type);
    };
    MultiPlayer.prototype.resumeInner = function () {
        if (this.getLevelSwitching()) {
            // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
            this._setLevelVideoNode.play();
            return;
        }
        _super.prototype.resumeInner.call(this);
    };
    MultiPlayer.prototype.loadInner = function (value, extra) {
        var _a;
        var vnLen = ((_a = this._vnList) === null || _a === void 0 ? void 0 : _a.length) || 0;
        for (var i = 0; i < vnLen; i++) {
            this.visibleVideoNode(this._vnList[i], false);
        }
        return _super.prototype.loadInner.call(this, value, extra);
    };
    MultiPlayer.prototype.playInner = function (startTime) {
        if (!this.checkBeforePlay()) {
            return;
        }
        this.playStartTime = startTime;
        var videoInfo = this._videoInfos[this._curUrlIdx];
        var preloaderIdx = this.findPreloadIdxByVideoInfo(videoInfo);
        if (preloaderIdx !== -1) {
            // 如果有预加载，处理preload后进入play
            this.preloadToPlay(videoInfo, preloaderIdx);
        }
        else if (videoInfo.error) {
            // 如果加载出错，进入错误处理
            this._logger.log('play(), got preload error');
            this.stopInner(EndState.ERROR, true, videoInfo);
        }
        else {
            // 如果没有预加载，直接进入播放调用
            this.enterVideoNodePlay(videoInfo);
        }
    };
    MultiPlayer.prototype.visibleVideoNode = function (vn, value) {
        var _a;
        if (!(vn === null || vn === void 0 ? void 0 : vn.videoElement)) {
            return;
        }
        this.setVideoElementState(vn.videoElement, value);
        this._logger.log(">>>visibleVideoNode<<<, value=".concat(value, "/uid=").concat((_a = vn.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.uid));
    };
    MultiPlayer.prototype.setVideoElementState = function (videoElement, value) {
        var tarVolume = value ? this._volume : 0;
        if (videoElement.volume !== tarVolume) {
            videoElement.volume = tarVolume;
        }
        // 当video标签切换到前台准备播放，此时需要恢复静音，但一定要先看看当前音量是不是本来就是静音的（用户设置了静音）
        // 此时不需要恢复静音，而是继续保持静音状态
        var tarMuted = this._volume <= 0 || !value;
        if (videoElement.muted !== tarMuted) {
            videoElement.muted = tarMuted;
        }
        domTool.css(videoElement, 'zIndex', value ? '0' : '-1');
        domTool.css(videoElement, 'visibility', value ? 'inherit' : 'hidden');
    };
    MultiPlayer.prototype.switchVideoNode = function () {
        // 有需要隐藏的video标签 && 隐藏的目标video标签不是当前播放的video标签，才进行切换
        if (!this._needHideVideoNode || this._curVideoNode === this._needHideVideoNode) {
            return;
        }
        this._logger.log('>>>>>switchVideoNode<<<<<');
        this.visibleVideoNode(this._curVideoNode, true);
        // 被隐藏的延迟一下隐藏，不然ios可能会黑闪
        var vnn = this._needHideVideoNode;
        this.visibleVideoNode(vnn, false);
        if (vnn) {
            vnn.stop();
        }
        this._needHideVideoNode = null;
    };
    MultiPlayer.prototype.playNextInner = function (opts) {
        // 先记录一下需要隐藏的上一个播放控件（不立即隐藏的原因是移动端等平台可能会在切换video标签的过程中出现一下黑屏）
        this._needHideVideoNode = this._curVideoNode;
        this._prePlayNext = false;
        _super.prototype.playNextInner.call(this, opts);
    };
    MultiPlayer.prototype.appendAfter = function (videoInfo) {
        // 只需要检查被append进来的数组的第一个视频信息，看看是否需要马上播放她或者干点别的
        var isIdle = this._curVideoNode ? this._curVideoNode.state === VideoState.IDLE : true;
        // 如果被检查的视频信息就是当前播放的下一个视频信息
        if (this._played && this._curUrlIdx + 1 === this._videoInfos.indexOf(videoInfo) && isIdle) {
            this.playNextInner();
        }
    };
    MultiPlayer.prototype.preparePreloader = function (isFirstLoad, videoInfo) {
        this._logger.log('preparePreloader(), isFirstLoad=', isFirstLoad);
        var videoNode = this.getIdleVideoNode();
        if (!videoNode) {
            // 已经找不到空闲的IVideoNode了
            return null;
        }
        videoInfo.extraVars.preloadVideoNode = videoNode;
        // 如果是第一个预加载，直接显示出来并设置成当前播放的VideoNode(用于派发事件出去)
        if (isFirstLoad) {
            this.setCurVideoNode(videoNode);
            this.visibleVideoNode(videoNode, true);
        }
        return new OrgPreLoader(this._config);
    };
    MultiPlayer.prototype.getIdleVideoNode = function () {
        if (this._firstVideoNode) {
            // 有指定第一个使用的videonode，就直接返回
            var vn = this._firstVideoNode;
            this._firstVideoNode = null;
            return vn;
        }
        var ret = null;
        var len = this._vnList.length;
        for (var i = 0; i < len; i++) {
            if (this._vnList[i].state === VideoState.IDLE && this._vnList[i] !== this._curVideoNode) {
                var arr = this._vnList.splice(i, 1);
                ret = arr[0];
                break;
            }
        }
        if (ret) {
            this._vnList.push(ret);
        }
        return ret;
    };
    /** 是否正在切换清晰度（在multi-player中实现的soft切换）*/
    MultiPlayer.prototype.getLevelSwitching = function () {
        return !!this._setLevelVideoNode;
    };
    MultiPlayer.prototype.setLevelInner = function (value) {
        var setLevelMode = this.decideSetLevelMode(value === null || value === void 0 ? void 0 : value.setLevelMode);
        this._logger.log("setLevelMode=".concat(setLevelMode));
        if (setLevelMode === SetLevelMode.HARD || setLevelMode === SetLevelMode.SMOOTH) {
            // VideoNode自行处理硬切还是平滑切换
            return this._curVideoNode.setLevel(setLevelMode);
        }
        return this.setLevelSoftMode();
    };
    /**
     * 下一个清晰度的VideoNode播放ok以后，切换到前台开始播放
     * @param preVideoNode 上一个清晰度播放时使用的VideoNode
     */
    MultiPlayer.prototype.switchVideoNodeWhenSetLevelSucc = function (preVideoNode) {
        this._logger.log('>>>>>switchLevelVideoNode<<<<<');
        if (preVideoNode === this._curVideoNode) {
            // 下一个清晰度的VideoNode就是当前的VideoNode，直接显示出来
            this.visibleVideoNode(this._curVideoNode, true);
        }
        else {
            this.visibleVideoNode(this._curVideoNode, true);
            this.visibleVideoNode(preVideoNode, false);
            preVideoNode === null || preVideoNode === void 0 ? void 0 : preVideoNode.stop();
        }
    };
    MultiPlayer.prototype.checkAccuratePlaytime = function (videoElementTime, videoElementDuration) {
        var _a, _b;
        var prePlayNextTime = this._config.originKernelConfig.prePlayNextTime;
        var leftTime = Math.abs(videoElementDuration - videoElementTime);
        if (prePlayNextTime > 0 && leftTime < prePlayNextTime && !this._prePlayNext) { // 提前开播下一个
            this._prePlayNext = true;
            var preloaderIdx = this.findPreloadIdxByVideoInfo(this.nextVideoInfo);
            if (this.nextVideoInfo && preloaderIdx !== -1) {
                var existPreloadVideoNode = (_b = (_a = this._preloaders[preloaderIdx]) === null || _a === void 0 ? void 0 : _a.videoInfo) === null || _b === void 0 ? void 0 : _b.extraVars.preloadVideoNode;
                if (existPreloadVideoNode) {
                    this._logger.log("preplay next!! idx/state: ".concat(existPreloadVideoNode.idx, "/").concat(existPreloadVideoNode.state));
                    existPreloadVideoNode.play();
                }
            }
        }
        this.checkAutoPreloadNext(leftTime);
    };
    MultiPlayer.prototype.stopInner = function (endState, dispatchEvt, videoInfo) {
        if (endState === void 0) { endState = EndState.NORMAL; }
        if (dispatchEvt === void 0) { dispatchEvt = false; }
        if (videoInfo === void 0) { videoInfo = null; }
        this._firstVideoNode = null;
        this._prePlayNext = false;
        this.playStartTime = 0;
        // 如果有正在切换清晰度的videoNode，也得清理
        this.clearSetLevelThings(true);
        _super.prototype.stopInner.call(this, endState, dispatchEvt, videoInfo);
    };
    MultiPlayer.prototype.destroy = function () {
        this._needHideVideoNode = null;
        this._setLevelVideoNode = null;
        this._firstVideoNode = null;
        this.playStartTime = 0;
        // 缓存一下，避免super.destroy以后为空
        var videoElement = this.videoElements;
        _super.prototype.destroy.call(this);
        // 因video标签是外部传入并且复用的，不是本对象自己创建的，因此需要恢复原样
        videoElement.forEach(function (e) {
            if (!(e instanceof HTMLVideoElement)) {
                return;
            }
            // 切换video标签到后台预加载等逻辑时，可能会修改video标签的如下属性，恢复修改
            e.volume = 1;
            e.muted = false;
            domTool.css(e, {
                zIndex: '0',
                visibility: 'inherit',
            });
            e.dataset.idx = '0';
        });
    };
    /** 播放接口调用前置检查 */
    MultiPlayer.prototype.checkBeforePlay = function () {
        if (this.getLevelSwitching()) {
            // todo： 如果正在切换清晰度的时候，触发了打断式加载，怎么做？
            // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
            this._setLevelVideoNode.play();
            this._logger.log('play(), setlevel');
            return false;
        }
        if (this._videoInfos.length <= 0 || !this._videoInfos[this._curUrlIdx]) {
            this._logger.warn('play(), !videoInfo');
            return false;
        }
        return true;
    };
    /**
     * 发送STATE_CHANGE事件
     * @param videoInfo 发送对应的IVideoInfo信息对象
     * @param newState Change后播放状态
     */
    MultiPlayer.prototype.emitStateChange = function (videoInfo, newState) {
        this.emit(PlayEvent.STATE_CHANGE, {
            videoInfo: videoInfo,
            new: newState,
            old: this._curVideoNode ? this._curVideoNode.state : VideoState.IDLE,
        });
    };
    /**
     * 处理下一个视频从preload状态转化为play
     * @param videoInfo 预加载videoInfo对象
     * @param preloaderIdx 预加载loader序号
     */
    MultiPlayer.prototype.preloadToPlay = function (videoInfo, preloaderIdx) {
        var _this = this;
        var DELAY_BUFFERING_TIME = 200;
        var preloadBufferingTimeoutID = 0;
        // 如果即将播放下一个视频，但是又处于预加载中，需要给一个buffering事件出去
        if (videoInfo.hasFirstPlaying) {
            preloadBufferingTimeoutID = window.setTimeout(function () {
                _this.emitStateChange(videoInfo, VideoState.BUFFERING);
            }, DELAY_BUFFERING_TIME);
        }
        this._preloaders[preloaderIdx].promise.then(function () {
            clearTimeout(preloadBufferingTimeoutID);
            _this._logger.log("play(), preloadVideoNode succ, uid=".concat(videoInfo.uid));
            _this.enterVideoNodePlay(videoInfo, preloaderIdx);
        }).catch(function (error) {
            _this._logger.log("play(), preloadVideoNode error, uid=".concat(videoInfo.uid, "/error="), error);
            if (!(error.code in ErrorCode)) {
                // 所谓鸭子类型判断，因为可能有各种其他的不是播放器定义的错误
                return;
            }
            clearTimeout(preloadBufferingTimeoutID);
            // 预加载时候已经把备份地址重试完了，没必要继续了
            // 所以下面直接抛出错误
            videoInfo.error = error;
            _this.stopInner(EndState.ERROR, true, videoInfo);
        });
    };
    /**
     * 最终进入调用videonode的play逻辑
     * @param videoInfo 进入播放videoInfo对象
     * @param preloaderIdx 已经预加载序号
     */
    MultiPlayer.prototype.enterVideoNodePlay = function (videoInfo, preloaderIdx) {
        var _a, _b, _c;
        if (preloaderIdx === void 0) { preloaderIdx = -1; }
        var preloadSucc = preloaderIdx !== -1;
        this._logger.log("enterVideoNodePlay(), preloadSucc=".concat(preloadSucc));
        var existPreloadVideoNode = preloaderIdx !== -1
            ? (_b = (_a = this._preloaders[preloaderIdx]) === null || _a === void 0 ? void 0 : _a.videoInfo) === null || _b === void 0 ? void 0 : _b.extraVars.preloadVideoNode : null;
        this.findIdleVideoNode(existPreloadVideoNode);
        // 如果被预加载过，清理预加载信息，但是保留video上已加载的数据
        if (preloaderIdx !== -1) {
            var preloader = this._preloaders.splice(preloaderIdx, 1)[0];
            preloader.clear(true);
        }
        // 如果是自动播放的场景，这里有个注意点哦！
        // 我们需要在调用play之前就把videonode显示出来（调用visibleVideoNode传true使volume设置为正常状态），否则是静音状态的时候调用了
        // play方法（见下面代码的videonode.play方法）。如果是静音状态时候调用play就无法catch到自动播放被阻止的异常了。而是调用play再恢复音
        // 量时，会收到类似如下警告（chrome）：
        // Unmuting failed and the element was paused instead because the user didn't interact with the document before
        // 这种情况不是我们预期的检测自动播放结果。因此把下面这一段代码移上来了。
        if (!this._needHideVideoNode) {
            // 不需要等上一个隐藏，那就直接显示。否则需要等一定时机显示出来
            this.visibleVideoNode(this._curVideoNode, true);
            this._logger.log('visibleVideoNode, null need');
        }
        else if (this._needHideVideoNode === this._curVideoNode) {
            this.visibleVideoNode(this._curVideoNode, true);
            this._logger.log('visibleVideoNode, need==current');
        }
        else if (preloadSucc) {
            this.switchVideoNode();
        }
        if (this._curVideoNode.state !== VideoState.PLAYING) {
            this._curVideoNode.play(videoInfo, { startTime: this.playStartTime });
        }
        this.emit(PlayEvent.VIDEONODE_CHANGE, { videoInfo: this.currentVideoInfo });
        this._logger.log("enterMultiPlay(), uid=".concat((_c = this.currentVideoInfo) === null || _c === void 0 ? void 0 : _c.uid, "/")
            + "urlIdx=".concat(this._curUrlIdx, "/state=").concat(this._curVideoNode.state));
        if (!preloadSucc) {
            // 如果没有预加载，不需要补发事件了
            return;
        }
        // 如果不是第一个视频播放，并且被预加载过，可能需要补发一些事件
        if (this._videoInfos.indexOf(this.currentVideoInfo) !== 0) {
            // 如果url有预加载，duration变化事件已经错过了，这里补发一个事件给外部（放在videoNode.play以后触发，才能取到currentVideoInfo属性）
            this.emit(PlayEvent.DURATION_CHANGE, { videoInfo: this.currentVideoInfo });
            // 因为可能提前开播了，补一个playing事件
            this.emitStateChange(this.currentVideoInfo, this._curVideoNode.state);
        }
        // 通知外部当前视频已经开播了
        if (!this.currentVideoInfo.extraVars.isStartPlay) {
            this.currentVideoInfo.extraVars.isStartPlay = true;
            this._logger.log("videoNodeStartPlay: uid[".concat(this.currentVideoInfo.uid, "]"));
            this.emit(PlayEvent.VIDEONODE_START_PLAY, { videoInfo: this.currentVideoInfo });
        }
    };
    /** 查找当前空闲的VideoNode */
    MultiPlayer.prototype.findIdleVideoNode = function (existPreloadVideoNode) {
        // 下面开始选择一个播放控件
        var idleVideoNode;
        var forceSetVideoNode = false;
        // 先看是否有预加载
        idleVideoNode = existPreloadVideoNode;
        // 如果为空，再看是否有空闲videonode
        if (!idleVideoNode) {
            idleVideoNode = this.getIdleVideoNode();
        }
        // 如果为空，再看当前videonode是否是空闲状态
        if (!idleVideoNode && this._curVideoNode && this._curVideoNode.state === VideoState.IDLE) {
            idleVideoNode = this._curVideoNode;
            // 此时需要强制替换当前videonode
            forceSetVideoNode = true;
        }
        if (!idleVideoNode) {
            this._logger.warn('can not find idle videonode!');
            throw new Error('can not find idle videonode!');
        }
        this.setCurVideoNode(idleVideoNode, forceSetVideoNode);
    };
    /**
     * 实现soft模式的清晰度切换
     */
    MultiPlayer.prototype.setLevelSoftMode = function () {
        var _this = this;
        // 以下逻辑为multi-player实现soft模式的清晰度切换：
        var levelSwitchingDefer = new SimpleDefer();
        // 先把当前的VideoInfo存起来。因为如果找不到可以使用的空闲VideoNode，可能会销毁当前的VideoNode来实现清晰度切换，这样会导致
        // currentVideoInfo变量为空
        var videoInfo = this.currentVideoInfo;
        this._logger.log("setLevelInner(), uid: ".concat(videoInfo.uid));
        this.pauseInner();
        this.setPlayEvents(this._curVideoNode, false);
        this.emit(PlayEvent.SETLEVEL_START, { videoInfo: videoInfo, mode: SetLevelMode.SMOOTH });
        // multi-player切换清晰度不使用VideoNode的setLevel方法，而是自己实现的多video切换，因此切换前先显示loading动画
        this.setLoading(true);
        var targetPlaytime = this._curVideoNode.playtime;
        var videoNode = this.getIdleVideoNode();
        // 找一个空闲的videoNode来加载下一个清晰度，如果没有，只能清理当前的videoNode了（会黑屏）
        if (!videoNode) {
            this._curVideoNode.stop();
            videoNode = this._curVideoNode;
        }
        else {
            this.visibleVideoNode(videoNode, false);
        }
        // url需要重新加载
        videoInfo.extraVars.isLoadstarted = false;
        this._setLevelVideoNode = videoNode;
        this._setLevelVideoNode.setLevelEvtMap = {}; // 切换清晰度事件
        // 在触发切换的时候，就设置下一个清晰度的VideoNode为currentVideoNode，开始监听下一个清晰度的事件。而上一个清晰度的VideoNode仅为了保
        // 留画面，不再开始监听事件、控制其行为。
        var preVideoNode = this._curVideoNode;
        this.setCurVideoNode(videoNode, true);
        videoNode.setLevelEvtMap[VideoNodeEvent.STATE_CHANGE] = function (e) {
            // 下一个清晰度视频开播，代表切换成功
            if (e.data.new === VideoState.PLAYING) {
                _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer, preVideoNode);
            }
        };
        videoNode.setLevelEvtMap[VideoNodeEvent.ERROR] = function () {
            _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer);
        };
        // timeupdate是等待新的清晰度时间超过切换清晰度的时间时结束，这样可能会比较慢
        videoNode.on(VideoNodeEvent.STATE_CHANGE, videoNode.setLevelEvtMap[VideoNodeEvent.STATE_CHANGE]);
        videoNode.on(VideoNodeEvent.ERROR, videoNode.setLevelEvtMap[VideoNodeEvent.ERROR]);
        // 直接播放下一个清晰度的视频
        videoNode.play(videoInfo, { startTime: targetPlaytime });
        return levelSwitchingDefer.promise;
    };
    /** 清除预加载相关资源，包括移除事件和相关数据等，注意如果正在切换清晰度中不会执行清理  */
    MultiPlayer.prototype.clearSetLevelThings = function (keepdata) {
        if (!this.getLevelSwitching()) {
            return;
        }
        var videoNode = this._setLevelVideoNode;
        if (videoNode.setLevelEvtMap) {
            Object.keys(videoNode.setLevelEvtMap).forEach(function (evt) {
                videoNode.off(evt, videoNode.setLevelEvtMap[evt]);
            });
            videoNode.setLevelEvtMap = null;
        }
        if (!keepdata) {
            videoNode.stop();
        }
        // 清晰度切换成功以后，强制清理掉所有的预加载数据
        this.clearAllPreloadInner();
        this._setLevelVideoNode = null;
    };
    MultiPlayer.prototype.setLevelSoftModeHandler = function (videoInfo, levelDefer, preVNode) {
        var _a;
        if (preVNode === void 0) { preVNode = null; }
        var succ = !!preVNode;
        this._logger.log("setLevel succ>>>>>> ".concat(succ, " uid: ").concat(videoInfo.uid));
        this.clearSetLevelThings(succ);
        if (succ) {
            this.switchVideoNodeWhenSetLevelSucc(preVNode);
            levelDefer.resolve();
        }
        else {
            this.rollbackLevelVideoNode();
            levelDefer.reject(new Error("setLevel failed, ".concat((_a = videoInfo.error) === null || _a === void 0 ? void 0 : _a.message)));
        }
        this.emit(PlayEvent.SETLEVEL_OVER, { videoInfo: videoInfo, fail: !succ });
        this.setLoading(false);
    };
    /** 清晰度切失败了得回滚，不然就卡死了 */
    MultiPlayer.prototype.rollbackLevelVideoNode = function () {
        this._logger.log('>>>>>rollbackLevelVideoNode<<<<<');
        if (this._urlBeforeSetLevel) {
            // 回滚时候恢复切换之前的url地址（并重置loadingUrl等）
            Object.assign(this.currentVideoInfo.config, this._urlBeforeSetLevel);
            this.currentVideoInfo.reset();
            this._urlBeforeSetLevel = null;
        }
        this.setPlayEvents(this._curVideoNode, true);
        this.resumeInner();
    };
    // 原生播放返回true，如果继承MultiPlayer的内核需要重写该方法
    MultiPlayer.isEnvSupport = true;
    __decorate([
        logMethodCall$1,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], MultiPlayer.prototype, "playInner", null);
    __decorate([
        logMethodCall$1,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MultiPlayer.prototype, "switchVideoNode", null);
    return MultiPlayer;
}(BasePlayer));

/**
 * webpack编译时注入变量
 */
function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    }
    catch (_a) { }
    var VERSION = '';
    try {
        VERSION = "1.32.11";
    }
    catch (_b) { }
    var BUILD_TIME = '';
    try {
        BUILD_TIME = 1713846478159;
    }
    catch (_c) { }
    var LOCAL_DEV = false;
    try {
        LOCAL_DEV = "" === '1';
    }
    catch (_d) { }
    var IS_BETA = false;
    try {
        IS_BETA = "0" === '1';
    }
    catch (_e) { }
    return {
        CHANNEL: CHANNEL,
        VERSION: IS_BETA ? "".concat(VERSION, "-beta") : VERSION,
        BUILD_TIME: BUILD_TIME,
        LOCAL_DEV: LOCAL_DEV,
        IS_BETA: IS_BETA,
    };
}
var _a$1 = getEnvVals(), CHANNEL = _a$1.CHANNEL, BUILD_TIME = _a$1.BUILD_TIME, VERSION = _a$1.VERSION, LOCAL_DEV = _a$1.LOCAL_DEV, IS_BETA = _a$1.IS_BETA;

var BaseLivePlayer = /** @class */ (function (_super) {
    __extends(BaseLivePlayer, _super);
    function BaseLivePlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseLivePlayer.prototype.playInner = function (_startTime) {
        var videoInfo = this._videoInfos[0];
        this.setPlayEvents(this._curVideoNode, true);
        this._curVideoNode.play(videoInfo);
        this.emit(PlayEvent.VIDEONODE_CHANGE, { videoInfo: videoInfo });
    };
    BaseLivePlayer.prototype.resumeInner = function () {
        var _a;
        if (!this._played) {
            return;
        }
        if ((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) {
            this._curVideoNode.videoplay();
        }
    };
    BaseLivePlayer.prototype.loadInner = function (value, extra) {
        var ret = _super.prototype.loadInner.call(this, value, extra);
        if (!ret) {
            return false;
        }
        this.setCurVideoNode(this._vnList[0]);
        // videoInfos 由 super.loadInner 创建，这里没有了 preloader 手动 load
        this._curVideoNode.load(this._videoInfos[0]);
        return true;
    };
    BaseLivePlayer.prototype.appendAfter = function (_videoInfo) {
        // do nothing
    };
    BaseLivePlayer.prototype.checkAccuratePlaytime = function (_videoElementTime, _videoElementDuration) {
        // do nothing
    };
    BaseLivePlayer.prototype.preparePreloader = function (_isFirstLoad, _videoInfo) {
        // do nothing
        return null;
    };
    BaseLivePlayer.prototype.getIdleVideoNode = function () {
        return this._vnList[0];
    };
    BaseLivePlayer.prototype.setLevelInner = function (value) {
        return this._curVideoNode.setLevel(value.setLevelMode);
    };
    BaseLivePlayer.prototype.playBlocked = function () {
        _super.prototype.playBlocked.call(this);
        this.pause();
    };
    Object.defineProperty(BaseLivePlayer.prototype, "supportPreload", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLivePlayer.prototype, "supportPlaybackRate", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLivePlayer.prototype, "nextVideoInfo", {
        get: function () {
            return this.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    return BaseLivePlayer;
}(BasePlayer));
// 禁用直播用不到的一些方法
[
    'seek', 'hasAppended', 'hasPreloaded', 'playNext',
    'appendNext', 'preloadNext', 'clearAllPreload', 'appendAfter',
    'checkPlayNext', 'playNextInner', 'checkAutoPreloadNext', 'clearAllPreloadInner',
].forEach(function (keyName) {
    BaseLivePlayer.prototype[keyName] = function () {
        console.warn("[thumbplayer] ".concat(keyName, "() is not support due to live stream"));
    };
});

/**
 * 使用原生内核的简易直播播放器
 */
var LivePlayer = /** @class */ (function (_super) {
    __extends(LivePlayer, _super);
    function LivePlayer(conf) {
        return _super.call(this, mergeKernelConfig(conf)) || this;
    }
    Object.defineProperty(LivePlayer.prototype, "kernelName", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return KernelName.ORIGIN;
        },
        enumerable: false,
        configurable: true
    });
    return LivePlayer;
}(BaseLivePlayer));

/**
 * 原生内核播放器，vod为multiplayer，live为liveplayer
 */
var OrgPlayer = /** @class */ (function () {
    function OrgPlayer(opts) {
        return opts.type === PlayMode.LIVE ? new LivePlayer(opts) : new MultiPlayer(opts);
    }
    Object.defineProperty(OrgPlayer, "canPlayType", {
        get: function () {
            return videoTool.supportVideoFormat();
        },
        enumerable: false,
        configurable: true
    });
    OrgPlayer.isEnvSupport = true;
    // 历史原因，命名不符合tslint规范，但变量名可能已被外部使用。
    // eslint-disable-next-line @typescript-eslint/naming-convention
    OrgPlayer.VERSION = VERSION;
    // 历史原因，命名不符合tslint规范，但变量名可能已被外部使用。
    // eslint-disable-next-line @typescript-eslint/naming-convention
    OrgPlayer.BUILD_TIME = BUILD_TIME;
    return OrgPlayer;
}());

var defaultPlayerConfig = {
    /** 是点播模式还是直播模式 */
    type: PlayMode.VOD,
    /**
     * 如果是打断式切换，在视频播放接近结束时，是不需要马上跳转的。例如离播放结束只有1s了，那么打断式切换就没必要了。
     * <br>【注】：仅点播播放时候有效
     */
    interruptPlayNextMinTime: 1,
    /**
     * 播放出错时的重试次数，规则为：
     * 1. 当播放接口未传入备用地址列表(backupUrls)时，按此值重试当前地址n次，默认为0
     * 2. 当播放接口传入了备用地址列表时，按此值和备用地址的长度的最大值循环重试备用地址列表
     */
    backupUrlsMaxRetryCount: 0,
    /** 预加载的最大超时时间 */
    maxPreloadTimeout: 30000,
    /**
     * @deprecated
     */
    maxBufferingTimeout: 30000,
    /** 某些状态可停留的最大时间，例如缓冲状态。单位毫秒 */
    maxStateStalledTime: 30000,
    /** 在playing状态下，playtime最大停滞时间 */
    maxPlaytimeStalledTime: 10000,
    /**
     * 是否是列表播放
     * <br>注意：
     * <br>播放器的列表播放分两种场景：
     * <br>1. play接口传入UrlConfig数组的列表播放，播放以后无法干涉任何拼接播放逻辑
     * <br>2. 依赖preloadNext、appendNext接口的灵活的列表播放场景。此时需要传入此参数，播放器则永远在已播放状态（played为true），要想结束
     * 播放，需要手动调用stop接口
     */
    isPlayList: false,
    preloadType: PreloadType.AUTO_LOAD,
    /**
     * 默认创建的最大VideoNode数量。此值会影响到可以同时预加载的视频数，例如如果需要同时预加载3个视频，这个值就需要指定为3+1
     */
    maxVideoNodeCount: 1,
    /**
     * video渲染的视频画面和播放器高宽比不匹配时候，允许的黑边最小值。如果小于等于最小值，播放器会强制将视频画面会填充黑边。
     * 注意：如果传入值小于等于0，则播放器不会填充。
     */
    minFillBlackBorder: 10,
    minFragmentCountForSmoothLevelSwitching: 3,
    ignoreEndedWhenLive: true,
    /** 上报采样率，例如配置core引用上报的采样率 */
    rptRate: 0.2,
    /** video标签组容器的样式字符串 */
    videoContainerStyle: VIDEO_CONTAINER_STYLE,
};

/**
 * 根据用户传入的配置项生成播放器内部使用的配置项
 */
function createConfig(userConfig) {
    var _a, _b, _c, _d;
    return __assign(__assign(__assign({ instanceId: (_a = userConfig.instanceId) !== null && _a !== void 0 ? _a : commonTool.createGUID() }, defaultPlayerConfig), userConfig), { 
        // origin内核配置上的maxVideoNodeCount已废弃，所以先读播放器config上的maxVideoNodeCount
        maxVideoNodeCount: (_d = (_b = userConfig.maxVideoNodeCount) !== null && _b !== void 0 ? _b : (_c = userConfig.originKernelConfig) === null || _c === void 0 ? void 0 : _c.maxVideoNodeCount) !== null && _d !== void 0 ? _d : defaultPlayerConfig.maxVideoNodeCount });
}
/**
 * 根据用户传入的video标签配置项，转换为生成video标签属性和样式的配置
 * @param videoConfig 用户video标签配置项
 * @returns attrOpts为生成的attribute属性，cssOpts为生成的样式属性
 */
function convertVideoElementConfig(videoConfig) {
    var presetStyleMap = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        objectFit: 'contain',
    };
    var vaildStyleKeys = Object.keys(presetStyleMap);
    var presetAttrMap = {
        playsinline: { playsinline: 'isiPhoneShowPlaysinline', 'webkit-playsinline': 'isiPhoneShowPlaysinline' },
        airplay: { airplay: 'allow', 'x-webkit-airplay': 'allow' },
        crossorigin: { crossOrigin: 'anonymous' },
        'h5-page': { 'x5-video-player-type': 'h5-page' },
    };
    var presetAttrOpts = {
        playsinline: true, // 默认开启playsinline,避免ios播放被系统劫持
        'h5-page': true,
    };
    Object.keys(videoConfig).forEach(function (key) {
        if (vaildStyleKeys.indexOf(key) === -1) {
            // 不是css属性，才加入
            presetAttrOpts[key] = videoConfig[key];
        }
    });
    var attrOpts = Object.keys(presetAttrOpts).reduce(function (res, key) {
        if (presetAttrMap[key] && typeof presetAttrOpts[key] === 'boolean') {
            // 如果用户传入的key是预设里的某一个，并且为true，我们不添加用户的key而是展开预设内的属性
            res = __assign(__assign({}, res), (presetAttrOpts[key] ? presetAttrMap[key] : {}));
        }
        else {
            // 用户传入了预设参数外的值，直接赋值不做检查
            res[key] = presetAttrOpts[key];
        }
        return res;
    }, {});
    var cssOpts = vaildStyleKeys.reduce(function (res, key) {
        var _a;
        res[key] = (_a = videoConfig[key]) !== null && _a !== void 0 ? _a : presetStyleMap[key];
        return res;
    }, {});
    return {
        attrOpts: attrOpts,
        cssOpts: cssOpts,
    };
}

/** 引用方式枚举 */
var ChannelMap;
(function (ChannelMap) {
    ChannelMap[ChannelMap["npm"] = 0] = "npm";
    ChannelMap[ChannelMap["cdn"] = 1] = "cdn";
})(ChannelMap || (ChannelMap = {}));
/**
 * 播放器引用上报，用于内核、H5Player和Super层的引用统计
 */
var ReferenceReport = /** @class */ (function () {
    function ReferenceReport() {
        // 只上报一次
        this.isCollected = false;
        // 上报使用的atta信息
        this.attaid = '05700050920';
        this.token = '3619167286';
        this.timeout = 3000;
        /** 上报率，1为全量上报 */
        this.rptRate = 1;
    }
    /**
     * 获取引用上报ReferenceReport实例
     * @returns 引用上报ReferenceReport实例
     */
    ReferenceReport.getReporter = function () {
        if (!this.reporter) {
            this.reporter = new ReferenceReport();
        }
        return this.reporter;
    };
    /**
     * 引用上报，对多层只上报一次，只是取不同值用于上报区分
     * @param from 引用来源
     * @param channel 引用方式
     * @param platform 平台号
     */
    ReferenceReport.prototype.collectUsage = function (from, channel, platform) {
        if (from === void 0) { from = 0; }
        if (channel === void 0) { channel = CHANNEL; }
        if (platform === void 0) { platform = ''; }
        if (this.isCollected)
            return;
        this.isCollected = true;
        if (Math.random() > this.rptRate) {
            // 仅采样上报
            return;
        }
        // 取URL相关信息
        var topUrl = urlTool.getTopFrameUrl();
        var urlWithoutQuery = topUrl === null || topUrl === void 0 ? void 0 : topUrl.split('?')[0];
        var domain = urlTool.getDomainOfURL(topUrl);
        var reportInfo = {
            attaid: this.attaid,
            token: this.token,
            topUrl: "".concat(encodeURIComponent(topUrl)),
            pageUrl: "".concat(encodeURIComponent(urlWithoutQuery)),
            domain: "".concat(encodeURIComponent(domain)),
            channel: "".concat(ChannelMap[channel] || 0),
            from: "".concat(from),
            version: VERSION,
            platform: platform,
            kernel: Object.keys(KernelFactory$1.kernelMap).join('$'),
            _dc: "".concat(Math.random()),
        };
        this.send(reportInfo);
    };
    /**
     * 初始化时统计信息，这种不太重要的上报动作延迟到3S后，因为初始时候请求太多了
     */
    ReferenceReport.prototype.send = function (args) {
        setTimeout(function () {
            var img = new Image();
            // 这里用atta的单字段批量上报接口
            img.src = "https://h.trace.qq.com/kv?".concat(urlTool.object2string(__assign({}, args), '&'));
        }, this.timeout);
    };
    return ReferenceReport;
}());

var logMethodCall = logMethodCallDecoratorCreator('KernelProxy');
var performanceCost = performanceCostDecoratorCreator('KernelProxy');
/** 全局的内核加载map，用于记录内核的js加载。加载初记录到map中，加载完成后resolve */
var loadKernelDeferMap = {};
/** player.dataset[KEY] 的 key，用于判断是否重复创建了播放器 */
var CONTAINER_DATASET_KEY = 'tp';
/**
 * 代理播放内核，在内部实现播放内核的创建、切换、销毁，事件转发等。这里已经创建了一组video标签，然后通过config传给正在使用的播放内核。而且播放
 * 内核之间切换，video标签是复用的。
 */
var KernelProxy = /** @class */ (function (_super) {
    __extends(KernelProxy, _super);
    function KernelProxy(conf) {
        var _this = _super.call(this) || this;
        /** 音量值，用于没有创建内核也允许设置的临时保存*/
        _this.volumeInner = 1;
        _this.videoElementsInner = [];
        _this.addedEvts = [];
        _this.isDestroyed = false;
        _this.playerConfig = createConfig(conf);
        _this.logger = new Logger(_this.playerConfig.instanceId, 'KernelProxy');
        if (+lsTool.getData('dHAtbG9nLWxldmVs') > 0) {
            // 不传入参数时启用所有控制台输出
            enable();
        }
        if (!_this.playerConfig.videoElements) {
            _this.playerConfig.videoElements = _this.createVideoElements();
        }
        _this.setPlayerContainer();
        _this.createVideoElementsContainer();
        _this.kernelEvtFuncs = _this.kernelEvtHandler.bind(_this);
        // 引用上报
        if (!_this.playerConfig.isPrivateDeployment) {
            ReferenceReport.getReporter().rptRate = _this.playerConfig.rptRate;
            ReferenceReport.getReporter().collectUsage();
        }
        return _this;
    }
    Object.defineProperty(KernelProxy.prototype, "container", {
        get: function () {
            return this.containerEl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "config", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.config) || this.playerConfig;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "useWorker", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.useWorker);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "kernelName", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.kernelName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoElements", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoElements) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoElement", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "supportPreload", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.supportPreload);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "duration", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.duration) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "playtime", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playtime) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoInfos", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoInfos) || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "preloadVideoInfos", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.preloadVideoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoInfo", {
        get: function () {
            var _a;
            return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "currentVideoInfoIdx", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.currentVideoInfoIdx) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "totalVideoInfoCount", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.totalVideoInfoCount) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "supportPlaybackRate", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.supportPlaybackRate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "played", {
        get: function () {
            var _a;
            return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.played);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "state", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.state) || VideoState.IDLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoSize", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoSize) || { width: 0, height: 0 };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "videoBuffered", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.videoBuffered) || [];
        },
        enumerable: false,
        configurable: true
    });
    KernelProxy.prototype.captureVideo = function (dx, dy, dw, dh, extra) {
        var _a;
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.captureVideo(dx, dy, dw, dh, extra);
    };
    KernelProxy.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log.apply(_a, args);
    };
    KernelProxy.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.warn.apply(_a, args);
    };
    KernelProxy.prototype.error = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error.apply(_a, args);
    };
    KernelProxy.prototype.hasAppended = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.hasAppended(value));
    };
    KernelProxy.prototype.hasPreloaded = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.hasPreloaded(value));
    };
    Object.defineProperty(KernelProxy.prototype, "volume", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.volume) || this.volumeInner;
        },
        set: function (value) {
            this.volumeInner = value;
            if (this.kernel) {
                this.kernel.volume = value;
            }
            else {
                // load前设置音量补充发出事件，但没有videoInfo
                this.emit(PlayEvent.VOLUME_CHANGE, { volume: value });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "volumeGain", {
        get: function () {
            if (this.kernel) {
                return this.kernel.volumeGain;
            }
            return 0;
        },
        set: function (gain) {
            if (this.kernel) {
                this.kernel.volumeGain = gain;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "audioEffect", {
        get: function () {
            if (this.kernel) {
                return this.kernel.audioEffect;
            }
            return AudioEffectName.DEFAULT;
        },
        set: function (effectName) {
            if (this.kernel) {
                this.kernel.audioEffect = effectName;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KernelProxy.prototype, "playbackRate", {
        get: function () {
            var _a;
            return ((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playbackRate) || this.playbackRateInner;
        },
        set: function (value) {
            this.playbackRateInner = value;
            if (this.kernel) {
                this.kernel.playbackRate = value;
            }
            else {
                // load前设置倍速补充发出事件，但没有videoInfo
                this.emit(PlayEvent.RATE_CHANGE, { playbackRate: value });
            }
        },
        enumerable: false,
        configurable: true
    });
    KernelProxy.prototype.resizeVideoElements = function (value) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.resizeVideoElements(value);
    };
    KernelProxy.prototype.resize = function (value) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.resize(value);
    };
    KernelProxy.prototype.seek = function (time) {
        var _a;
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.seek(time);
    };
    KernelProxy.prototype.play = function (urlConfig, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log('play(urlConfig, ', extra, ')');
                        return [4 /*yield*/, this.checkConfigBeforeLoad(urlConfig, extra)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.play(urlConfig, extra)];
                }
            });
        });
    };
    KernelProxy.prototype.load = function (urlConfig, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.checkConfigBeforeLoad(urlConfig, extra)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.load(urlConfig, extra)];
                }
            });
        });
    };
    KernelProxy.prototype.playNext = function (opts) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.playNext(opts);
    };
    KernelProxy.prototype.pause = function (pauseType) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.pause(pauseType);
    };
    KernelProxy.prototype.stop = function (endState) {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.stop(endState);
    };
    KernelProxy.prototype.appendNext = function (value) {
        var _a;
        return !!((_a = this.kernel) === null || _a === void 0 ? void 0 : _a.appendNext(value));
    };
    KernelProxy.prototype.preloadNext = function () {
        var _a;
        var confs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            confs[_i] = arguments[_i];
        }
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.preloadNext.apply(_a, confs);
    };
    KernelProxy.prototype.clearAllPreload = function () {
        var _a;
        (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.clearAllPreload();
    };
    KernelProxy.prototype.triggerAutoplay = function () {
        var _this = this;
        var _a;
        if (!this.kernel) {
            this.logger.log('triggerAutoplay(), start');
            var func = function (el) {
                var autoplay = new AutoPlayPolicy(el, { instanceId: _this.playerConfig.instanceId });
                return autoplay.userTrigger();
            };
            var triggerPromises = this.videoElementsInner.map(func);
            return Promise.all(triggerPromises);
        }
        return (_a = this.kernel) === null || _a === void 0 ? void 0 : _a.triggerAutoplay();
    };
    KernelProxy.prototype.setAudioTrack = function (id) {
        if (!this.kernel) {
            return Promise.reject(new Error(AudioTrackErrorMsg.KERNEL_NOT_EXISTS));
        }
        return this.kernel.setAudioTrack(id);
    };
    KernelProxy.prototype.getAudioTrackList = function () {
        if (!this.currentVideoInfo)
            return [];
        return this.currentVideoInfo.audioTracks;
    };
    KernelProxy.prototype.getCurrentAudioTrack = function () {
        if (!this.currentVideoInfo)
            return NaN;
        return this.currentVideoInfo.currentAudioTrack;
    };
    KernelProxy.prototype.setLevel = function (urlOrUrlConfig, backupUrls, extraConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var nextLevelUrlConfig, preVideoInfo, _a, isKernelSwitched, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.kernel) {
                            return [2 /*return*/, Promise.reject(compile(i18nConfig.core.ERROR_KERNEL_NOT_FOUND))];
                        }
                        nextLevelUrlConfig = typeof urlOrUrlConfig === 'string'
                            // 这里要拼接extra，带上drm参数
                            ? __assign(__assign({}, extraConfig), { url: urlOrUrlConfig }) : urlOrUrlConfig;
                        preVideoInfo = this.currentVideoInfo;
                        return [4 /*yield*/, this.checkWhetherNeedToSwitchKernel(nextLevelUrlConfig, null, false)];
                    case 1:
                        _a = _b.sent(), isKernelSwitched = _a.isKernelSwitched, error = _a.error;
                        if (error === null || error === void 0 ? void 0 : error.message) {
                            return [2 /*return*/, Promise.reject(error === null || error === void 0 ? void 0 : error.message)];
                        }
                        if (isKernelSwitched) {
                            return [2 /*return*/, this.setLevelWhenKernelSwitched(__assign(__assign(__assign({}, nextLevelUrlConfig), { backupUrls: backupUrls }), extraConfig), preVideoInfo)];
                        }
                        // 直接在老的内核上切换清晰度
                        if (typeof urlOrUrlConfig === 'string') {
                            return [2 /*return*/, this.kernel.setLevel(urlOrUrlConfig, backupUrls, extraConfig)];
                        }
                        return [2 /*return*/, this.kernel.setLevel(urlOrUrlConfig)];
                }
            });
        });
    };
    KernelProxy.prototype.on = function (type, listener, priority) {
        _super.prototype.on.call(this, type, listener, priority);
        this.proxyEvent(type);
        return this;
    };
    KernelProxy.prototype.once = function (type, listener, priority) {
        _super.prototype.once.call(this, type, listener, priority);
        this.proxyEvent(type, true);
        return this;
    };
    /**
     * 销毁当前proxy
     */
    KernelProxy.prototype.destroy = function () {
        var _a, _b;
        this.unsetPlayerContainer();
        if (this.videoElementsInner) {
            this.videoElementsInner.forEach(function (videoElement) {
                closeAudioSourceNode(videoElement);
                videoTool.destroyElement(videoElement);
            });
            this.videoElementsInner = null;
        }
        if ((_a = this.videoElementsContainer) === null || _a === void 0 ? void 0 : _a.parentNode) {
            this.videoElementsContainer.remove();
        }
        NetTiming.disconnect((_b = this.playerConfig) === null || _b === void 0 ? void 0 : _b.instanceId);
        this.destroyKernel();
        this.removeAllListeners();
        this.kernelEvtFuncs = null;
        this.playerConfig = null;
        this.isDestroyed = true;
    };
    /**
     * 检查是否需要切换内核。如果需要，则会销毁旧的内核，并创建新的内核。
     * @param urlConfig 传入的播放地址
     * @param emitStopEvent 是否需要派发Stop事件
     * @returns 是否有切换内核，如果没有旧的内核而创建了新的内核，也算切换。
     */
    KernelProxy.prototype.checkWhetherNeedToSwitchKernel = function (urlConfig_1, extra_1) {
        return __awaiter(this, arguments, void 0, function (urlConfig, extra, emitStopEvent) {
            var checkUrlConfig, forceKernelName, selectedKernelName, kernelName;
            if (emitStopEvent === void 0) { emitStopEvent = true; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.log('check switch kernel');
                        checkUrlConfig = (urlConfig instanceof Array) ? urlConfig[0] : urlConfig;
                        forceKernelName = (extra === null || extra === void 0 ? void 0 : extra.kernelName) || checkUrlConfig.kernelName;
                        selectedKernelName = KernelFactory$1.selectKernel(urlConfig, forceKernelName, this.playerConfig.kernelPriority);
                        // KernelFactory.selectKernel返回类型是IVideoERROR，意味着强制内核是无法播放当前视频，直接提示错误
                        if (typeof selectedKernelName !== 'string') {
                            return [2 /*return*/, {
                                    isKernelSwitched: false,
                                    error: selectedKernelName,
                                }];
                        }
                        this.logger.log('kernel select:', selectedKernelName);
                        if (!(selectedKernelName && !KernelFactory$1.kernelMap[selectedKernelName])) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadKernel(selectedKernelName)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        kernelName = KernelFactory$1.kernelMap[selectedKernelName] ? selectedKernelName : KernelName.ORIGIN;
                        // 1.如果kernelName不一样，需要先销毁旧的
                        if (this.kernel && this.kernel.kernelName !== kernelName) {
                            // 如果已经触发播放（播放中），KernelProxy层需要补发STOPED事件出去，因为销毁当前内核的操作外部无法感知
                            if (this.kernel.played && emitStopEvent) {
                                this.emit(PlayEvent.STOPED, {
                                    videoInfo: this.kernel.currentVideoInfo,
                                    endState: EndState.INTERRUPT,
                                });
                            }
                            this.destroyKernel();
                        }
                        if (!!this.kernel) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.createKernel(kernelName)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, {
                                isKernelSwitched: true,
                            }];
                    case 4: return [2 /*return*/, {
                            isKernelSwitched: false,
                        }];
                }
            });
        });
    };
    /**
     * 尝试从远程加载内核文件。加载成功后会自动注册到window.ThumbplayerCore.KernelFactory
     * @param kernelName 内核名称
     * @param retryTimes 失败时重试次数
     * @returns 是否成功加载
     */
    KernelProxy.prototype.loadKernel = function (kernelName_1) {
        return __awaiter(this, arguments, void 0, function (kernelName, retryTimes) {
            var kernelCdnPath, loadSucc_1, loadSucc, loadOption, i;
            if (retryTimes === void 0) { retryTimes = 3; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 私有部署时不自动下载内核
                        if (this.config.isPrivateDeployment) {
                            return [2 /*return*/, false];
                        }
                        kernelCdnPath = getKernelCdnPath(kernelName, this.playerConfig.autoLoadKernelVerMap);
                        if (!kernelCdnPath) {
                            return [2 /*return*/, false];
                        }
                        if (!loadKernelDeferMap[kernelName]) return [3 /*break*/, 2];
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] has been started!"));
                        return [4 /*yield*/, loadKernelDeferMap[kernelName].promise];
                    case 1:
                        loadSucc_1 = _a.sent();
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=").concat(loadSucc_1));
                        return [2 /*return*/, loadSucc_1];
                    case 2:
                        loadKernelDeferMap[kernelName] = new SimpleDefer();
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "]"));
                        loadSucc = false;
                        loadOption = {};
                        if (this.playerConfig.crossOriginForScript) {
                            loadOption.crossOrigin = this.playerConfig.crossOriginForScript;
                        }
                        i = 0;
                        _a.label = 3;
                    case 3:
                        if (!(i < retryTimes)) return [3 /*break*/, 9];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, domTool.loadScript("".concat(CDN_PATH_PREFIX + kernelCdnPath, "?max_age=86400"), null, 10000, loadOption)];
                    case 5:
                        _a.sent();
                        if (this.isDestroyed) {
                            return [2 /*return*/, new Promise(function () { })];
                        }
                        this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=true"));
                        loadSucc = true;
                        return [3 /*break*/, 7];
                    case 6:
                        _a.sent();
                        loadSucc = false;
                        // 理论上加载失败也会走原生内核尝试播放，所以这里设计成不需要抛出异常，仅返回加载失败。
                        this.logger.error("auto download kernel [".concat(kernelCdnPath, "] failed"));
                        return [3 /*break*/, 7];
                    case 7:
                        if (loadSucc) {
                            return [3 /*break*/, 9];
                        }
                        _a.label = 8;
                    case 8:
                        i++;
                        return [3 /*break*/, 3];
                    case 9:
                        loadKernelDeferMap[kernelName].resolve(loadSucc);
                        return [2 /*return*/, loadSucc];
                }
            });
        });
    };
    /**
     * 创建内核实例。
     */
    KernelProxy.prototype.createKernel = function (kernelName) {
        this.kernel = KernelFactory$1.createKernel(kernelName, this.playerConfig);
        if (typeof this.volumeInner !== 'undefined') {
            this.kernel.volume = this.volumeInner;
        }
        if (typeof this.playbackRateInner !== 'undefined') {
            this.kernel.playbackRate = this.playbackRateInner;
        }
        this.setKernelEvts(true);
    };
    /**
     * 创建video标签，video标签需要提前在播放内核创建之前初始化。因为load或者play接口才会创建播放内核。但是触发自动播放等行为可能先于load或者
     * play接口，而这些行为依赖video标签的实例。这里创建的video标签在各种播放内核切换中，会做到复用。
     */
    KernelProxy.prototype.createVideoElements = function () {
        var _a = this.playerConfig, instanceId = _a.instanceId, videoElementConfig = _a.videoElementConfig, maxVideoNodeCount = _a.maxVideoNodeCount;
        var createVideoDomOptions = convertVideoElementConfig(__assign(__assign({ preload: this.playerConfig.preloadType === PreloadType.META_DATA ? 'metadata' : 'auto' }, videoElementConfig), { playerid: instanceId }));
        for (var i = 0; i < maxVideoNodeCount; i++) {
            var videoElement = domTool.createVideoDom(createVideoDomOptions);
            this.videoElementsInner.push(videoElement);
        }
        return this.videoElementsInner;
    };
    /**
     * 从初始化播放器的配置中获取播放器的容器元素实例，并设置到 this.container 中
     * 创建时，检测 container 是否存在有其他实例，如果有，则抛出异常
     */
    KernelProxy.prototype.setPlayerContainer = function () {
        var _a = this.playerConfig, container = _a.container, instanceId = _a.instanceId;
        var containerEl = domTool.getElementFromConfig(container);
        // 检查下能不能找到这个元素
        if (!containerEl) {
            throw new Error("Container ".concat(container, " is not found."));
        }
        // 检测是否有其他实例正在使用这个容器
        if (containerEl.dataset[CONTAINER_DATASET_KEY]) {
            // 有，抛出异常，终止此次初始化
            var msg = "Container ".concat(container, " is used by another player instance. Canceling initialization...");
            this.logger.error("@setPlayerContainer(): ".concat(msg));
            throw new Error(msg);
        }
        // 设置标记，用于防止多次初始化
        containerEl.dataset[CONTAINER_DATASET_KEY] = instanceId;
        this.containerEl = containerEl;
    };
    /**
     * 回滚所有对 Container 的操作，移除事件监听器，清理 Container 容器
     */
    KernelProxy.prototype.unsetPlayerContainer = function () {
        delete this.container.dataset[CONTAINER_DATASET_KEY];
        // ergou 遗留代码，本意是用于移除 container 上的所有事件监听器，但存在副作用以及其他问题（整合 Vue / React 时）
        // 这里最好的办法还是包装 container 上的 addEventListener 方法，记录下所有监听器的 callback，然后在这里 remove 掉
        // 这里先判断下，这个 DOM 在不在文档中，如果不在什么也不用做
        if (this.container.isConnected) {
            var newEmptyDom = this.container.cloneNode();
            this.container.parentNode.replaceChild(newEmptyDom, this.container);
            this.containerEl = newEmptyDom;
        }
        // 清理容器
        this.containerEl.innerHTML = '';
    };
    /**
     * 创建包裹video标签的容器。
     */
    KernelProxy.prototype.createVideoElementsContainer = function () {
        var _a = this, container = _a.container, playerConfig = _a.playerConfig;
        this.videoElementsContainer = domTool.createDom("\n      <div class=\"".concat(VIDEO_CONTAINER_CLASS, "\" style=\"").concat(playerConfig.videoContainerStyle, "\">\n      </div>\n    ").trim());
        domTool.append(container, this.videoElementsContainer);
    };
    /**
     * 代理kernel的事件，监听以后进行转发。（调用KernelProxy的once方法也完全没问题）
     */
    KernelProxy.prototype.setKernelEvts = function (value) {
        var _this = this;
        if (!this.kernel) {
            return;
        }
        if (value) {
            // 保证kernel对任何事件只监听一次
            this.setKernelEvts(false);
        }
        var func = value ? this.kernel.on : this.kernel.off;
        this.addedEvts.forEach(function (evtName) {
            func.apply(_this.kernel, [evtName, _this.kernelEvtFuncs]);
        });
    };
    KernelProxy.prototype.kernelEvtHandler = function (e) {
        if (this.setLevelWhenKernelSwitchedDefer) {
            // 如果是新内核播放实现切换清晰度的情况下，切换中所有事件都不发出去，等切换成功
            var isSetLevelOver = this.checkSetLevelOverWhenKernelSwitched(e);
            if (isSetLevelOver) {
                this.setLevelWhenKernelSwitchedDefer = null;
            }
        }
        else {
            var isIgnoreEvent = this.handlerInnerEvts(e);
            if (!isIgnoreEvent) {
                this.emit(e.type, e.data);
            }
        }
    };
    /**
     * 需要换内核场景下的切清晰度。此情况下使用新内核直接播放视频，而不是在老的内核上执行setLevel逻辑，因为老的内核已经被销毁。
     */
    KernelProxy.prototype.setLevelWhenKernelSwitched = function (urlConfig, preVideoInfo) {
        this.emit(PlayEvent.SETLEVEL_START, { videoInfo: preVideoInfo, mode: SetLevelMode.HARD });
        this.kernel.play(urlConfig, { startTime: (preVideoInfo === null || preVideoInfo === void 0 ? void 0 : preVideoInfo.playtime) || 0 });
        this.setLevelWhenKernelSwitchedDefer = new SimpleDefer();
        return this.setLevelWhenKernelSwitchedDefer.promise;
    };
    /**
     * 检查换内核方式下切换清晰度是否完成。
     * @returns 是否切换完成（无论成功还是失败）
     */
    KernelProxy.prototype.checkSetLevelOverWhenKernelSwitched = function (e) {
        var _a;
        if (e.type === PlayEvent.STATE_CHANGE && e.data.new === VideoState.PLAYING) {
            // 播放成功，代表切换成功
            this.setLevelWhenKernelSwitchedDefer.resolve();
            this.emit(PlayEvent.SETLEVEL_OVER, { videoInfo: this.currentVideoInfo });
            return true;
        }
        if (e.type === PlayEvent.ERROR) {
            // 播放出错，代表切换失败
            this.setLevelWhenKernelSwitchedDefer.reject((_a = e.data.videoInfo) === null || _a === void 0 ? void 0 : _a.error);
            this.emit(PlayEvent.SETLEVEL_OVER, { videoInfo: this.currentVideoInfo, fail: true });
            return true;
        }
        return false;
    };
    /**
     * 代理事件
     * @param type 事件类型
     * @param isOnce 是否只执行一次
     */
    KernelProxy.prototype.proxyEvent = function (type, isOnce) {
        if (isOnce === void 0) { isOnce = false; }
        // 1. 只要外部添加监听某个事件：
        // 首先会缓存事件名到数组中，其次当前播放内核就会添加该事件名的监听并在事件监听器中进行转发。转发者为kernel-proxy。
        // 2. 外部移除某个事件的监听：
        // 移除的是kernel-proxy上的监听，而不是kernel上的。kernel上的监听只在kernel被销毁的时候移除。
        if (this.addedEvts.includes(type))
            return;
        this.addedEvts.push(type);
        if (!this.kernel)
            return;
        if (isOnce) {
            this.kernel.once(type, this.kernelEvtFuncs);
            return;
        }
        this.kernel.on(type, this.kernelEvtFuncs);
    };
    /**
     * 执行urlConfig播放前的内核检查，如果更换了格式，需要切换内核否则抛错
     */
    KernelProxy.prototype.checkConfigBeforeLoad = function (urlConfig, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!urlConfig) {
                            return [2 /*return*/];
                        }
                        this.timeStart(CoreStepKey.SEL_KERNEL);
                        return [4 /*yield*/, this.checkWhetherNeedToSwitchKernel(urlConfig, extra)];
                    case 1:
                        error = (_a.sent()).error;
                        this.timeEnd(CoreStepKey.SEL_KERNEL);
                        if (error) {
                            this.emit(PlayEvent.ERROR, { videoInfo: { error: error } });
                            throw error;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * 销毁当前内核
    */
    KernelProxy.prototype.destroyKernel = function () {
        if (this.kernel) {
            this.emit(PlayEvent.KERNEL_DESTROY, { kernelName: this.kernel.kernelName });
            this.setKernelEvts(false);
            this.kernel.destroy();
            this.kernel = null;
        }
    };
    /**
     * 内部处理内核事件
     * @returns isIgnoreEvent 是否忽略事件，不对外转发
     */
    KernelProxy.prototype.handlerInnerEvts = function (e) {
        if (e.type === PlayEvent.ERROR && this.kernel.kernelName === KernelName.DEMUX_2_FMP4) {
            // 注意：这个demux2fmp4内核的回滚逻辑只能单个video播放有效，列表播放会有问题
            var videoInfo = e.data.videoInfo;
            var autoFallbackKernel = videoInfo.config.autoFallbackKernel;
            if (!!autoFallbackKernel) {
                this.logger.error("play err with ".concat(KernelName.DEMUX_2_FMP4, ", fallback to ").concat(KernelName.ORIGIN));
                // demux2fmp4和origin内核功能相等，如果demux2fmp4内核失败，回退到origin内核再播放一次
                this.play(videoInfo.config, { startTime: videoInfo.playtime, kernelName: KernelName.ORIGIN });
                return true;
            }
        }
        return false;
    };
    __decorate([
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "play", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "load", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "setAudioTrack", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Array, Object]),
        __metadata("design:returntype", Promise)
    ], KernelProxy.prototype, "setLevel", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "destroy", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], KernelProxy.prototype, "createKernel", null);
    KernelProxy = __decorate([
        stepTimerClassDecorator,
        __metadata("design:paramtypes", [Object])
    ], KernelProxy);
    return KernelProxy;
}(EvtEmitter));

/**
 * 结合浏览器环境能力和视频Meta信息判断内核类型是否可用，也控制在某些环境是否启用该内核，未引用内核也无需加载
 */
var kernelAvailable = {
    isHlsjsAvailable: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 非hls格式无法播放，如果加密内容是Fairplay目前只能使用原生内核所以HLSjs也无法播放
        if (metadata.videoType !== VideoType.HLS || metadata.drmType === DrmType.FAIRPLAY) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec === Codec.H265 && !videoTool.supportHevc()) {
            return false;
        }
        // 如果是视频AV1编码，必须检查浏览器是否支持AV1
        if (metadata.vcodec === Codec.AV1 && !videoTool.supportAV1()) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用hls
        return videoTool.supportMSE();
    },
    /**
     * 判断当前视频在Flvjs是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isFlvjsAvailable: function (metadata) {
        // 移动端不启用flv内核，尚无该场景使用需求，且没有验证过兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // 非flv格式、加密内容播放均无法播放
        if (metadata.videoType !== VideoType.FLV || metadata.drmType !== DrmType.NONE) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec === Codec.H265 && !videoTool.supportHevc()) {
            return false;
        }
        // 如果是视频AV1编码，必须检查浏览器是否支持AV1
        if (metadata.vcodec === Codec.AV1 && !videoTool.supportAV1()) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用flv
        return videoTool.supportMSE();
    },
    /**
     * 判断当前视频在Demux2fmp4内核是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isDemux2fmp4Available: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 只能播放MP4和MOV格式视频
        if (metadata.videoType !== VideoType.MP4 && metadata.videoType !== VideoType.MOV) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec !== undefined && metadata.vcodec !== Codec.H264) {
            return false;
        }
        // 如果环境支持MSE和流式fetch请求就可以使用2fmp4内核
        return videoTool.supportMSE() && videoTool.supportFetchStream();
    },
    /**
     * 判断当前视频在Webrtcplayer内核是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isWebrtcplayerAvailable: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 只能Webrtc协议能播放
        if (metadata.videoType !== VideoType.WEBRTC) {
            return false;
        }
        return videoTool.isWebRTCSupported();
    },
    /**
     * 判断当前视频在Wasmplayer是否可播
     * @param metadata 视频播放信息
     * @returns 是否可播
     */
    isWasmplayerAvailble: function (metadata) {
        // 移动端不能启用WASM，尚未验证兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // WASM理论上能播放所有格式，所以无需判断videoType
        return videoTool.isWasmKernelSupported();
    },
    /**
     *判断当前视频在Electron环境是否可播，原则上Electron能播放所有格式，所以判断环境即可
     * @param metadata
     */
    isElectronPlayerAailble: function () {
        return (/electron\//i).test(navigator.userAgent);
    },
};

/**
 * 通过urlConfig计算对应Metadata
 * @param urlConfig
 */
function createMetadata(urlConfig) {
    var metadata = {
        urlConfig: urlConfig,
        videoType: getUrlConfigVideoType(urlConfig),
        drmType: getDrmType(urlConfig),
        vcodec: urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.vcodec,
    };
    return metadata;
}
/**
 * 通过urlConfig检查当前的加密类型，以便于选择对应内核
 */
function getDrmType(urlConfig) {
    var _a;
    // 如果带有chacha参数，则是自研加密
    if (urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.chachaParam) {
        return DrmType.CHACHA;
    }
    var keySystem = (_a = urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.drmConfig) === null || _a === void 0 ? void 0 : _a.keySystem;
    // KeySystems包含FairPlay
    if ([KeySystems.FairPlay, KeySystems.FairPlayWebKit].includes(keySystem)) {
        return DrmType.FAIRPLAY;
    }
    // KeySystems包含Widevine
    if (KeySystems.Widevine === keySystem) {
        return DrmType.WIDEVINE;
    }
    return DrmType.NONE;
}

var _a;
/** URL注入参数key名 */
var UrlParamKey;
(function (UrlParamKey) {
    UrlParamKey["forceKernel"] = "__forceKernel";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 按优先级顺序排列的内核名称数组，从高到低依次判断
 * ORIGIN作为兜底内核使用，原则上来说没有匹配上的，都尝试使用origin方式播放
 * WASM内核很特殊且使用有限制，所以不在列表里，如果需要使用只能外部指定
 */
var KERNEL_NAME_BY_PRIORITY = [
    KernelName.HLS_JS,
    KernelName.FLV_JS,
    KernelName.WEBRTC,
    KernelName.ORIGIN,
];
/**
 * 从视频格式到内核名称的映射，这里是全量内核列表
 */
var VIDEO_TYPE_2_AVAILABEL_MAP = (_a = {},
    _a[KernelName.HLS_JS] = kernelAvailable.isHlsjsAvailable,
    _a[KernelName.FLV_JS] = kernelAvailable.isFlvjsAvailable,
    _a[KernelName.WEBRTC] = kernelAvailable.isWebrtcplayerAvailable,
    _a[KernelName.DEMUX_2_FMP4] = kernelAvailable.isDemux2fmp4Available,
    _a[KernelName.ORIGIN] = function () { return true; },
    _a[KernelName.WASM] = kernelAvailable.isWasmplayerAvailble,
    _a[KernelName.ELECTRON] = kernelAvailable.isElectronPlayerAailble,
    _a);
/*
 * 从视频格式到内核名称的映射
 */
({
    flv: KernelName.FLV_JS,
    hls: KernelName.HLS_JS,
    webrtc: KernelName.WEBRTC,
});
/**
 * 用于根据当前播放配置信息选择合适的播放内核名称
 */
var KernelSelector = /** @class */ (function () {
    function KernelSelector() {
    }
    KernelSelector.getSelector = function () {
        if (!this.selector) {
            this.selector = new KernelSelector();
        }
        return this.selector;
    };
    /**
    * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
    * @param urlConfig 播放配置信息
    * @param forceKernelName 强制使用某种内核
    * @param kernelPriority 自定义内核选择时的优先级
    * @returns 被选择的内核名称
    */
    KernelSelector.prototype.selectByURLConfig = function (urlConfig, forceKernelName, kernelPriority) {
        var metadata = createMetadata(urlConfig);
        // 优先级1：如果外部指定使用内核，一般用于debug或者引用方指定，所以优先级最高
        return this.selectKernelWithAssign(metadata, forceKernelName)
            // 优先级2：按优先级列表选择能播放对应格式的内核
            || this.selectKernelInPresetMap(metadata, kernelPriority);
    };
    /**
     * 如果外部指定使用内核，无论如何都立即返回该内核
     */
    KernelSelector.prototype.selectKernelWithAssign = function (metadata, forceKernelName) {
        var _a;
        var kernelName = forceKernelName;
        // 如果有通过url参数指定，无论如何都立即返回该内核，优先级比forceKernelName更高
        var kernelNameFromUrlParam = urlTool.getUrlParamByKey(location.href, UrlParamKey.forceKernel);
        // 指定内核在预设列表里才可以用
        if (kernelNameFromUrlParam && Object.keys(VIDEO_TYPE_2_AVAILABEL_MAP).includes(kernelNameFromUrlParam)) {
            kernelName = kernelNameFromUrlParam;
        }
        // 外部指定了内核名称，并且是因为播放地址无法确定后缀而指定的，直接返回（否则通不过`VIDEO_TYPE_2_AVAILABEL_MAP`的校验）
        if (forceKernelName && metadata.videoType === VideoType.OTHER) {
            return forceKernelName;
        }
        // forceKernel和URL都没有强制指定参数，直接返回走自动设定
        if (!kernelName) {
            return null;
        }
        // 如果指定的内核可以播放该视频
        if ((_a = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _a === void 0 ? void 0 : _a.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
            return kernelName;
        }
        // 强制指定内核不能播放，返回错误
        var suggestKernelName = this.suggestKernelNameByMetadata(metadata, KERNEL_NAME_BY_PRIORITY);
        var isHEVCSupportIssue = metadata.vcodec === Codec.H265
            && !videoTool.supportHevc()
            && (kernelName === KernelName.HLS_JS || kernelName === KernelName.FLV_JS); // 仅在HLS和FLV内核下才会出现HEVC支持问题
        var message = "".concat(kernelName !== KernelName.ORIGIN ? "".concat(kernelName, "\u5185\u6838") : '', "\u65E0\u6CD5\u64AD\u653E\u5F53\u524D\u683C\u5F0F")
            + "".concat(suggestKernelName && suggestKernelName !== KernelName.ORIGIN ? "\uFF0C\u8BF7\u5C1D\u8BD5\u4F7F\u7528".concat(suggestKernelName, "\u5185\u6838\u64AD\u653E") : '');
        var hevcMessage = '当前浏览器不支持HEVC编码, 请尝试使用最新版本Google Chrome进行播放并检查硬件加速是否开启';
        return {
            code: ErrorCode.MISSING_KERNEL,
            message: isHEVCSupportIssue ? hevcMessage : message,
        };
    };
    /**
     * 根据视频信息选择可用的内核
     * @param metadata 视频信息
     * @param kernelPriority 外部有要求调整制定的内核顺序
     * @returns 内核名称
     */
    KernelSelector.prototype.selectKernelInPresetMap = function (metadata, kernelPriority) {
        var kernelNames;
        // 如果有外部干预内核列表
        if (kernelPriority) {
            kernelNames = kernelPriority;
            // 把用户自定义列表中没有包含的内核也补上
            for (var i = 0; i < KERNEL_NAME_BY_PRIORITY.length; i++) {
                if (kernelPriority.indexOf(KERNEL_NAME_BY_PRIORITY[i]) === -1) {
                    kernelNames.push(KERNEL_NAME_BY_PRIORITY[i]);
                }
            }
        }
        else {
            kernelNames = KERNEL_NAME_BY_PRIORITY;
        }
        // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
        return this.suggestKernelNameByMetadata(metadata, kernelNames);
    };
    /**
    * 遍历当前所有的播放内核，看看哪个内核支持当前的视频类型
    * @param metadata 视频信息
    * @param kernelNames 内核列表
    */
    KernelSelector.prototype.suggestKernelNameByMetadata = function (metadata, kernelNames) {
        var _a;
        if (!metadata) {
            return null;
        }
        // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
        for (var i = 0; i < kernelNames.length; i++) {
            var kernelName = kernelNames[i];
            if ((_a = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _a === void 0 ? void 0 : _a.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
                return kernelName;
            }
        }
        return null;
    };
    /**
     * 根据kernelName和urlConfig验证该内核是否支持
     * @param kernelName 目标内核名称
     * @param urlConfig 视频信息
     * @returns 是否支持
     */
    KernelSelector.prototype.isKernelSupportByUrlConfig = function (kernelName, urlConfig) {
        var isKernelAvailable = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName];
        if (!isKernelAvailable) {
            return false;
        }
        var metadata = createMetadata(urlConfig);
        return isKernelAvailable(metadata);
    };
    return KernelSelector;
}());

/**
 * 用于注册播放内核的工厂方法
 */
var KernelFactory = /** @class */ (function () {
    function KernelFactory() {
    }
    /**
     * 注册播放内核
     * @param kernelName 内核名称
     * @param kernel 内核的实现（类对象），可传入undefined相当于取消注册
     */
    KernelFactory.registerKernel = function (kernelName, kernel) {
        var _a, _b, _c;
        if (this.kernelMap[kernelName]) {
            // 替换注册，执行注销 hook
            (_b = (_a = this.kernelMap[kernelName]).unregister) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else if (!this.kernelMap[kernelName] && kernel) {
            // 新注册播放内核时，执行内核注册 hook 方法
            (_c = kernel.register) === null || _c === void 0 ? void 0 : _c.call(kernel);
        }
        // 修改为可以重复注册、替换注册
        this.kernelMap[kernelName] = kernel;
    };
    /**
   * 创建播放内核
   * @ignore
   */
    KernelFactory.createKernel = function (kernelName, conf) {
        // 如果强制指定流类型的话
        if (kernelName) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            var KernelClass = KernelFactory.kernelMap[kernelName];
            // 先检查是否有播放内核
            if (!KernelClass) {
                throw new Error("Can't find [".concat(kernelName, "] kernel"));
            }
            // 再检查播放环境是否支持播放内核
            if (KernelClass.isEnvSupport) {
                var inst = new KernelClass(conf);
                if (KernelClass.exportApis) {
                    commonTool.assignApiToPrototype(inst, KernelProxy.prototype, KernelClass.exportApis);
                }
                return inst;
            }
            // 浏览器不支持
            window.console.log("Browser does not support kernelName[".concat(kernelName, "]"));
        }
        return new KernelFactory.kernelMap.origin(conf);
    };
    /**
     * @deprecated 创建thumbplayer-core实例，请使用new KernelProxy创建
     */
    KernelFactory.create = function (conf) {
        // 较早设计，因为目前有外部调用，先使用废弃方式提示
        return new KernelProxy(conf);
    };
    /**
     * 根据播放内核名称获取播放内核的类对象
     */
    KernelFactory.getKernelByName = function (kernelName) {
        return KernelFactory.kernelMap[kernelName];
    };
    /**
     * 检查某个播放内核是否支持指定的UrlConfig播放
     * @param kernelName 播放内核名称
     * @param urlConfig 指定的视频播放地址
     */
    KernelFactory.isKernelSupportByUrlConfig = function (kernelName, urlConfig) {
        return KernelSelector.getSelector().isKernelSupportByUrlConfig(kernelName, urlConfig);
    };
    /**
     * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
     * @param value 播放配置信息
     * @param forceKernelName 强制使用某种内核
     * @param kernelPriority 自定义内核选择时的优先级
     * @returns 被选择的内核名称
     */
    KernelFactory.selectKernel = function (value, forceKernelName, kernelPriority) {
        var checkValue = (value instanceof Array) ? value[0] : value;
        return KernelSelector.getSelector().selectByURLConfig(checkValue, forceKernelName, kernelPriority);
    };
    KernelFactory.kernelMap = {};
    return KernelFactory;
}());
var KernelFactory$1 = KernelFactory;
/**
 * 根据内核名称获取内核的cdn文件地址
 */
function getKernelCdnPath(kernelName, autoLoadKernelVerMap) {
    var _a;
    if (autoLoadKernelVerMap === void 0) { autoLoadKernelVerMap = {}; }
    var version = IS_BETA ? 'beta' : (autoLoadKernelVerMap[kernelName] || VERSION);
    var kernelCdnPrefix = "core/".concat(version);
    var kernelName2CdnPathMap = (_a = {},
        _a[KernelName.HLS_JS] = "".concat(kernelCdnPrefix, "/txhlsjs-kernel.js"),
        _a[KernelName.FLV_JS] = "".concat(kernelCdnPrefix, "/flvjs-kernel.js"),
        _a[KernelName.DEMUX_2_FMP4] = "".concat(kernelCdnPrefix, "/demux2fmp4-kernel.js"),
        _a[KernelName.WASM] = "".concat(kernelCdnPrefix, "/wasm-kernel.js"),
        _a[KernelName.WEBRTC] = "".concat(kernelCdnPrefix, "/webrtc-kernel.js"),
        _a);
    return kernelName2CdnPathMap[kernelName];
}

// 原生播放内核相关模块导出

var ThumbPlayerCore = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MultiPlayer: MultiPlayer,
  OrgPlayer: OrgPlayer,
  OrgVideoNode: OrgVideoNode,
  OrgPreloader: OrgPreLoader,
  originDefaultConfig: defaultOriginKernelConfig,
  VideoInfo: VideoInfo,
  BaseVideoNode: BaseVideoNode,
  BasePlayer: BasePlayer,
  BaseLivePlayer: BaseLivePlayer,
  defaultPlayerConfig: defaultPlayerConfig,
  get DrmKeySystems () { return KeySystems; },
  t: compile,
  compileI18n: compile,
  i18nTool: i18nTool,
  HDR_CAPABILITY: HDR_CAPABILITY,
  EvtEmitter: EvtEmitter,
  SimpleDefer: SimpleDefer,
  commonTool: commonTool,
  uaTool: uaTool,
  costTimeEmitter: costTimeEmitter,
  performanceCostDecoratorCreator: performanceCostDecoratorCreator,
  logMethodCallDecoratorCreator: logMethodCallDecoratorCreator,
  destroyProtectDecorator: destroyProtectDecorator,
  logMethodCallDecoratorCreater: logMethodCallDecoratorCreator,
  stepTimerClassDecorator: stepTimerClassDecorator,
  StepTimer: StepTimer,
  KernelStepKey: KernelStepKey,
  requireModule: requireModule,
  mountGlobal: mountGlobal,
  cookieTool: cookieTool,
  lsTool: lsTool,
  urlTool: urlTool,
  domTool: domTool,
  netTool: netTool,
  getEventEmitterBinder: getEventEmitterBinder,
  getEventTargetBinder: getEventTargetBinder,
  videoTool: videoTool,
  stringTool: stringTool,
  jsonTool: jsonTool,
  TaskLoop: TaskLoop,
  LoopMode: LoopMode,
  ResizeObserver: ResizeObserver,
  ResizeObserverPolyfilled: ResizeObserverPolyfilled,
  encodingTool: encodingTool,
  hashTool: hashTool,
  KernelFactory: KernelFactory$1,
  KernelProxy: KernelProxy,
  ReferenceReport: ReferenceReport,
  Logger: Logger,
  logTool: logTool,
  get LogMode () { return LogMode; },
  dumpLog: dumpLog,
  get AUDIO_EFFECT_NAME () { return AudioEffectName; },
  AUDIO_EFFECT_CNNAME: AUDIO_EFFECT_CNNAME,
  AUDIO_EFFECT_DISPLAYLIST: AUDIO_EFFECT_DISPLAYLIST,
  isAudioEffectEnvSupport: isEnvSupport,
  kernelEvtBus: kernelEvtBus,
  preloadEvtBus: preloadEvtBus,
  CAN_PLAY_ALL: CAN_PLAY_ALL,
  VIDEO_CONTAINER_CLASS: VIDEO_CONTAINER_CLASS,
  VIDEO_CONTAINER_STYLE: VIDEO_CONTAINER_STYLE,
  CDN_PATH_PREFIX: CDN_PATH_PREFIX,
  get CoreStepKey () { return CoreStepKey; },
  get SET_LEVEL_MODE () { return SetLevelMode; },
  get PLAY_MODE () { return PlayMode; },
  get END_STATE () { return EndState; },
  get VIDEO_READY_STATE () { return VideoReadyState; },
  get VIDEO_EVTS () { return VideoEvts; },
  get VIDEO_STATE () { return VideoState; },
  get ERROR_CODE () { return ErrorCode; },
  get ERROR_MSG () { return ErrorMsg; },
  get PLAY_EVENT () { return PlayEvent; },
  get PRELOAD_EVENT () { return PreloadEvent; },
  get VIDEO_NODE_EVENT () { return VideoNodeEvent; },
  get PAUSE_TYPE () { return PauseType; },
  get PLAYER_LOG_LEVEL () { return PlayerLogLevel; },
  get PRELOAD_TYPE () { return PreloadType; },
  get CODEC () { return Codec; },
  get VIDEO_CODEC () { return VideoCodec; },
  get AUDIO_CODEC () { return AudioCodec; },
  get CONTAINER_FORMAT () { return ContainerFormat; },
  get VIDEO_ELEMENT_STATE () { return VideoElementState; },
  get CACHE_SIZE_KEY () { return CacheSizeKey; },
  get DRM_TYPE () { return DrmType; },
  get VIDEO_TYPE () { return VideoType; },
  get KERNEL_NAME () { return KernelName; },
  defaultI18nConfig: defaultI18nConfig,
  i18nConfig: i18nConfig,
  get AUDIO_TRACK_ERROR_MSG () { return AudioTrackErrorMsg; },
  commonErrorParse: commonErrorParse,
  getVideoError: getVideoError,
  CHANNEL: CHANNEL,
  BUILD_TIME: BUILD_TIME,
  VERSION: VERSION,
  LOCAL_DEV: LOCAL_DEV,
  IS_BETA: IS_BETA,
  ErrorTypeCodeMap: ErrorTypeCodeMap,
  get MediaElementNativeDetail () { return MediaElementNativeDetail; },
  PlayerError: PlayerError,
  ErrorBase: ErrorBase,
  get TpCoreError () { return BuiltInErrorType; },
  NetTimingObserver: NetTimingObserver,
  NetTiming: NetTiming,
  getVideoNetworkDetail: getVideoNetworkDetail
});

// 播放器自带原生播放内核
KernelFactory$1.registerKernel(KernelName.ORIGIN, OrgPlayer);
// 只在 npm 打包后挂载，给 CDN 内核获取 Core
{
    mountGlobal({
        globalName: 'ThumbPlayerCore',
        target: ThumbPlayerCore,
        onDuplicate: function () {
            console.warn('Possible duplicated ThumbPlayerCore detected. Avoid to import this package multiple times.');
        },
    });
}

export { AudioCodec as AUDIO_CODEC, AUDIO_EFFECT_CNNAME, AUDIO_EFFECT_DISPLAYLIST, AudioEffectName as AUDIO_EFFECT_NAME, AudioTrackErrorMsg as AUDIO_TRACK_ERROR_MSG, BUILD_TIME, BaseLivePlayer, BasePlayer, BaseVideoNode, CacheSizeKey as CACHE_SIZE_KEY, CAN_PLAY_ALL, CDN_PATH_PREFIX, CHANNEL, Codec as CODEC, ContainerFormat as CONTAINER_FORMAT, CoreStepKey, DrmType as DRM_TYPE, KeySystems as DrmKeySystems, EndState as END_STATE, ErrorCode as ERROR_CODE, ErrorMsg as ERROR_MSG, ErrorBase, ErrorTypeCodeMap, IS_BETA, KernelName as KERNEL_NAME, KernelFactory$1 as KernelFactory, KernelProxy, LOCAL_DEV, LogMode, Logger, MediaElementNativeDetail, MultiPlayer, NetTiming, NetTimingObserver, OrgPlayer, OrgPreLoader as OrgPreloader, OrgVideoNode, PauseType as PAUSE_TYPE, PlayerLogLevel as PLAYER_LOG_LEVEL, PlayEvent as PLAY_EVENT, PlayMode as PLAY_MODE, PreloadEvent as PRELOAD_EVENT, PreloadType as PRELOAD_TYPE, PlayerError, ReferenceReport, SetLevelMode as SET_LEVEL_MODE, BuiltInErrorType as TpCoreError, VERSION, VideoCodec as VIDEO_CODEC, VIDEO_CONTAINER_CLASS, VIDEO_CONTAINER_STYLE, VideoElementState as VIDEO_ELEMENT_STATE, VideoEvts as VIDEO_EVTS, VideoNodeEvent as VIDEO_NODE_EVENT, VideoReadyState as VIDEO_READY_STATE, VideoState as VIDEO_STATE, VideoType as VIDEO_TYPE, VideoInfo, clearLogCache, commonErrorParse, compile as compileI18n, ThumbPlayerCore as default, defaultI18nConfig, defaultPlayerConfig, dumpLog, getLogCache, getVideoError, getVideoNetworkDetail, i18nConfig, i18nTool, isEnvSupport as isAudioEffectEnvSupport, kernelEvtBus, logTool, defaultOriginKernelConfig as originDefaultConfig, preloadEvtBus, compile as t };
